// Lesson 3 - Dental Hygiene Theory III

export const questions = {
  "1. Fixed Prosthodontics": [
    {
      id: 92001,
      question: "What are prosthodontics/prosthetics designed to replace?",
      options: [
        "Fractured or missing teeth and possibly the supporting structures",
        "Only missing teeth and never any supporting bone or tissue",
        "Only the soft tissues around existing natural teeth",
        "Injuries caused by periodontal disease and dental trauma"
      ],
      correctAnswer: 0
    },
    {
      id: 92002,
      question: "Which type of prosthodontic restoration can be removed and replaced into the mouth by the patient at will?",
      options: [
        "Fixed prosthodontics cemented to existing teeth or implants",
        "Removable prosthodontics that the client controls independently",
        "Implant-retained prosthodontics secured with abutment screws",
        "Splinted prosthodontics bonded to multiple adjacent teeth"
      ],
      correctAnswer: 1
    },
    {
      id: 92003,
      question: "Which of the following is an example of a fixed prosthesis type?",
      options: [
        "Complete denture worn over an edentulous ridge without implant support",
        "Removable partial denture with metal clasps on abutment teeth",
        "Periodontal splint stabilizing mobile teeth in functional position",
        "Full upper denture retained by suction and palatal coverage"
      ],
      correctAnswer: 2
    },
    {
      id: 92004,
      question: "Approximately what proportion of adults aged 65 and older in the U.S. and Canada are completely edentulous?",
      options: [
        "1 in 10 adults aged 65 and older",
        "1 in 3 adults aged 65 and older",
        "1 in 20 adults aged 65 and older",
        "1 in 5 adults aged 65 and older"
      ],
      correctAnswer: 1
    },
    {
      id: 92005,
      question: "Why are tooth loss rates declining in recent decades?",
      options: [
        "Improved oral care practices and greater healthcare awareness",
        "Government mandates requiring dental insurance coverage for all citizens",
        "Widespread fluoridation has completely eliminated dental caries",
        "Advances in implants have made natural tooth preservation unnecessary"
      ],
      correctAnswer: 0
    },
    {
      id: 92006,
      question: "Which of the following is a major contributor to tooth loss across all age groups?",
      options: [
        "Salivary gland dysfunction and medication-induced xerostomia",
        "Temporomandibular joint disorder and chronic bruxism habits",
        "Dental caries, periodontal disease, and low socioeconomic status",
        "Fluoride overexposure causing enamel hypoplasia and fracture"
      ],
      correctAnswer: 2
    },
    {
      id: 92007,
      question: "In adults under 35 years of age, what is the primary cause of tooth loss?",
      options: [
        "Periodontal disease progressing rapidly in young adults",
        "Oral cancer treatment and associated tooth extraction",
        "Osteoporosis and low calcium intake weakening alveolar bone",
        "Dental caries affecting unrestored or under-restored teeth"
      ],
      correctAnswer: 3
    },
    {
      id: 92008,
      question: "Which additional factors can contribute to tooth loss beyond caries and periodontal disease?",
      options: [
        "Salivary gland hypertrophy and excessive salivary flow rate",
        "Oral cancer, associated treatment, and traumatic injuries",
        "Enamel fluorosis causing surface sensitivity and fracture",
        "Vitamin D toxicity and hypercalcemia affecting bone metabolism"
      ],
      correctAnswer: 1
    },
    {
      id: 92009,
      question: "Bone resorption following tooth extraction is correctly described by which statement?",
      options: [
        "It occurs equally in both the mandible and maxilla after extraction",
        "It stops approximately five years after tooth extraction in healthy adults",
        "It begins only if the patient does not wear a denture within six months",
        "It begins after extraction, continues lifelong, and is faster in the mandible"
      ],
      correctAnswer: 3
    },
    {
      id: 92010,
      question: "What is the clinical term for a patient who has lost all of their natural teeth?",
      options: [
        "Edentulous",
        "Hypodontia affected",
        "Partially dentate",
        "Periodontally compromised"
      ],
      correctAnswer: 0
    },
    {
      id: 92011,
      question: "Which of the following hard tissue changes can negatively affect prosthesis fit in edentulous patients?",
      options: [
        "Enamel remineralization and cementum thickening around existing teeth",
        "Increased alveolar bone density and widened residual ridges",
        "Tori, exostoses, and tuberosities affecting ridge contour",
        "Salivary gland hypertrophy and mucosal thickening under the denture"
      ],
      correctAnswer: 2
    },
    {
      id: 92012,
      question: "Which complications of bone resorption can cause pain or irritation in edentulous patients?",
      options: [
        "Increased ridge height and ridge widening that compress soft tissue",
        "Ridge flattening, sharp bony areas, and nerve exposure or compression",
        "Tori enlargement and tuberosity overgrowth causing occlusal interference",
        "Excessive mucosal thickening and papillary hyperplasia under the denture"
      ],
      correctAnswer: 1
    },
    {
      id: 92013,
      question: "What is the approximate masticatory efficiency of a complete denture relative to natural dentition?",
      options: [
        "Approximately 80% of natural dentition efficiency",
        "Approximately 65% of natural dentition efficiency",
        "Approximately 50% of natural dentition efficiency",
        "Approximately 20% of natural dentition efficiency"
      ],
      correctAnswer: 3
    },
    {
      id: 92014,
      question: "Which of the following is NOT one of the four main options for replacement of missing teeth?",
      options: [
        "Dental implant placed into alveolar bone",
        "Fixed prosthesis such as a bridge",
        "Removable prosthesis the patient can take out",
        "Orthodontic retainer to hold the space open"
      ],
      correctAnswer: 3
    },
    {
      id: 92015,
      question: "Loss of occlusal vertical dimension due to multiple missing teeth can lead to which condition?",
      options: [
        "Accelerated root resorption and increased tooth mobility",
        "Enamel hypoplasia and spontaneous crown fracture",
        "Temporomandibular joint (TMJ) disorders from an overclosed bite",
        "Salivary gland obstruction and resultant xerostomia"
      ],
      correctAnswer: 2
    },
    {
      id: 92016,
      question: "When an unopposed tooth lacks an antagonist in the opposing arch, what consequence can occur?",
      options: [
        "The tooth may supererupt toward the opposing edentulous space",
        "The tooth develops increased root surface sensitivity and hypersensitivity",
        "The tooth tilts away from the adjacent edentulous space over time",
        "The tooth becomes ankylosed to the surrounding alveolar bone"
      ],
      correctAnswer: 0
    },
    {
      id: 92017,
      question: "Which of the following is a CONTRAINDICATION for fixed prosthodontic treatment?",
      options: [
        "Client who is motivated and skilled in maintaining oral hygiene practices",
        "One or two adjacent missing teeth with healthy surrounding tissues",
        "Necessary supportive tissues are diseased or entirely missing",
        "Suitable abutment teeth are present and periodontally sound"
      ],
      correctAnswer: 2
    },
    {
      id: 92018,
      question: "Which of the following is an INDICATION for fixed prosthodontic treatment?",
      options: [
        "Client who is not motivated to have the prosthesis placed at this time",
        "One or two adjacent missing teeth with suitable, healthy abutment teeth",
        "Necessary supportive tissues are diseased or absent in the treatment area",
        "Client who cannot afford the proposed fixed prosthodontic treatment plan"
      ],
      correctAnswer: 1
    },
    {
      id: 92019,
      question: "What type of dental specialist focuses on the restoration and replacement of teeth using fixed or removable prosthodontics?",
      options: [
        "Endodontist specializing in root canal therapy and pulpal disease",
        "Periodontist specializing in supporting structures of the teeth",
        "Oral and maxillofacial surgeon performing extractions and implants",
        "Prosthodontist specializing in restoration and replacement of teeth"
      ],
      correctAnswer: 3
    },
    {
      id: 92020,
      question: "Which of the following must be obtained before initiating prosthodontic treatment as part of the plan of care?",
      options: [
        "Detailed medical and dental histories, intraoral exam, diagnostic models, and full-mouth radiographs",
        "A complete blood count, cardiac stress test, and pulmonary function test",
        "Photographs of only the facial profile and a panoramic radiograph",
        "A salivary flow test and microbiological analysis of plaque samples"
      ],
      correctAnswer: 0
    },
    {
      id: 92021,
      question: "Indirect restorations differ from direct restorations primarily because they are:",
      options: [
        "Placed directly into the prepared cavity while the patient is in the chair",
        "Fabricated in the patient's mouth using light-cured composite resin",
        "Fabricated outside the patient's mouth in a dental laboratory",
        "Created using chairside autoclave processing within the dental office"
      ],
      correctAnswer: 2
    },
    {
      id: 92022,
      question: "Which of the following is the correct complete list of indirect cast restorations covered in this lecture?",
      options: [
        "Amalgam restorations, pit-and-fissure sealants, and direct composite veneers",
        "Inlays, onlays, veneers, crowns, and fixed bridges",
        "Composite resin bonding agents, fluoride varnish, and desensitizing agents",
        "Cobalt-chromium frameworks, acrylic denture bases, and cast post-and-core"
      ],
      correctAnswer: 1
    },
    {
      id: 92023,
      question: "How does an inlay differ from an onlay in terms of tooth coverage?",
      options: [
        "An inlay covers one or more entire cusps; an onlay only fits within the cusps",
        "An inlay is used exclusively on anterior teeth; an onlay on posterior teeth only",
        "An inlay is fabricated from metal only; an onlay is fabricated from porcelain only",
        "An inlay fits within the cusps; an onlay covers a large area including entire cusp(s)"
      ],
      correctAnswer: 3
    },
    {
      id: 92024,
      question: "Which type of crown does NOT cover the entire anatomical crown, leaving a portion of enamel typically on the facial surface exposed?",
      options: [
        "3/4 crown",
        "Porcelain-fused-to-metal crown",
        "Full crown made entirely of porcelain",
        "Splinted crown attached to adjacent crowns"
      ],
      correctAnswer: 0
    },
    {
      id: 92025,
      question: "What are splinted crowns in fixed prosthodontics?",
      options: [
        "Crowns made entirely of gold to withstand heavy posterior occlusal forces",
        "Temporary crowns placed while the permanent restoration is being fabricated",
        "Two or more crowns fabricated attached together to support the involved teeth",
        "Crowns used exclusively on endodontically treated anterior teeth"
      ],
      correctAnswer: 2
    },
    {
      id: 92026,
      question: "Which of the following is a possible indication for placing a dental crown?",
      options: [
        "A tooth that is only mildly crowded and could be corrected with orthodontics",
        "A heavily restored, endodontically treated, or symptomatic cracked tooth",
        "A tooth with mild fluorosis staining but no structural damage present",
        "A tooth that is slightly discolored but otherwise structurally intact"
      ],
      correctAnswer: 1
    },
    {
      id: 92027,
      question: "What is the primary purpose of gingival retraction prior to taking a final impression for a crown or bridge?",
      options: [
        "To administer local anesthesia to the gingival tissue around the preparation",
        "To remove excess temporary cement from the sulcus after provisional placement",
        "To irrigate the sulcus with antiseptic solution before placing impression material",
        "To displace gingival tissue so the impression captures margins beyond the preparation"
      ],
      correctAnswer: 3
    },
    {
      id: 92028,
      question: "What technology does the CEREC machine use to fabricate crowns and veneers within a single dental visit?",
      options: [
        "CAD/CAM technology milling the restoration from a solid block of porcelain",
        "Heat-press ceramic technique requiring a dental laboratory kiln",
        "3D printing using layered composite resin polymer materials",
        "Lost-wax casting method using a gold or metal alloy framework"
      ],
      correctAnswer: 0
    },
    {
      id: 92029,
      question: "What is a dental veneer in the context of fixed prosthodontics?",
      options: [
        "A full-coverage restoration made of metal fused to porcelain for posterior teeth",
        "A thick porcelain cap that fully encases the entire crown of the tooth",
        "A thin shell of tooth-coloured material bonded to the facial surface of anterior teeth",
        "A cast metal framework supporting a removable partial denture clasp system"
      ],
      correctAnswer: 2
    },
    {
      id: 92030,
      question: "From which materials can dental veneers be fabricated?",
      options: [
        "Gold alloy and zirconia only",
        "Porcelain or composite resin",
        "Amalgam and composite resin only",
        "Acrylic resin and metal alloy only"
      ],
      correctAnswer: 1
    },
    {
      id: 92031,
      question: "A fixed bridge is also known by which alternate clinical term?",
      options: [
        "Removable partial denture supported by natural teeth",
        "Full-coverage cast crown cemented to a prepared tooth",
        "Implant-supported overdenture retained by ball attachments",
        "Fixed partial denture replacing one or more missing teeth"
      ],
      correctAnswer: 3
    },
    {
      id: 92032,
      question: "Which components make up a fixed bridge?",
      options: [
        "Abutments, pontics, and connectors",
        "Implant body, abutment screw, and healing cap",
        "Retainers, clasps, and acrylic denture base",
        "Post, core build-up, and endodontic file"
      ],
      correctAnswer: 0
    },
    {
      id: 92033,
      question: "Which type of fixed bridge uses wings bonded to the lingual surfaces of adjacent natural teeth instead of requiring full crown retainers?",
      options: [
        "Traditional bilateral bridge with abutment crowns on both sides",
        "Cantilever bridge supported by a single abutment tooth on one side",
        "Maryland or resin-bonded bridge with metal or porcelain wings",
        "Implant-supported fixed partial denture with titanium abutments"
      ],
      correctAnswer: 2
    },
    {
      id: 92034,
      question: "When is a cantilever bridge most appropriately used?",
      options: [
        "When three or more consecutive teeth are missing in a single span",
        "When healthy abutment teeth exist on only one side of the missing tooth",
        "When both sides of the edentulous space have sound abutment teeth",
        "When the patient requires bilateral arch support across the full quadrant"
      ],
      correctAnswer: 1
    },
    {
      id: 92035,
      question: "Why is a cantilever bridge generally not recommended compared to a traditional bilateral bridge?",
      options: [
        "It requires removal of significantly more tooth structure from both abutment teeth",
        "It cannot be fabricated from ceramic materials and is limited to metal alloy only",
        "It cannot replace posterior teeth because it cannot withstand occlusal forces",
        "It is less sturdy due to support from only one side rather than two abutments"
      ],
      correctAnswer: 3
    },
    {
      id: 92036,
      question: "Which of the following materials can be used to fabricate a fixed bridge?",
      options: [
        "Metals, ceramics, or a combination of metal and ceramic",
        "Cobalt-chromium alloy and latex composite only",
        "Composite resin and amalgam materials only",
        "Acrylic resin and dental wax only"
      ],
      correctAnswer: 0
    },
    {
      id: 92037,
      question: "For which clinical situation is a Maryland bridge specifically indicated?",
      options: [
        "Patients requiring replacement of multiple consecutive missing teeth across a quadrant",
        "Patients with severe periodontal disease requiring mobile tooth splinting",
        "Cases where adjacent abutment teeth have very small or minimal existing restorations",
        "Posterior teeth that experience heavy occlusal loading forces during chewing"
      ],
      correctAnswer: 2
    },
    {
      id: 92038,
      question: "Which key physical appearance change results from significant bone resorption in an edentulous patient?",
      options: [
        "Widening of alveolar ridges and increased prominence of the upper lip",
        "Reduced lip support, decreased facial height, and a sunken facial appearance",
        "Enlargement of the mandible and forward displacement of the chin",
        "Increased facial height and greater prominence of the zygomatic arches"
      ],
      correctAnswer: 1
    },
    {
      id: 92039,
      question: "What is a key patient management recommendation for those adapting to a new tooth replacement prosthesis?",
      options: [
        "Remove the prosthesis for all meals to allow tissue recovery during early adaptation",
        "Take small bites, chew evenly on both sides, and avoid sticky foods during adaptation",
        "Increase masticatory force gradually to condition the residual ridge over time",
        "Avoid all hard and fibrous foods permanently throughout the life of the prosthesis"
      ],
      correctAnswer: 1
    },
    {
      id: 92040,
      question: "What risk is associated with tilting and rotation of adjacent teeth into an unreplaced edentulous space?",
      options: [
        "Periodontal problems from difficulty in biofilm control and misdirected occlusal forces",
        "Decreased salivary flow and elevated plaque accumulation in the arch",
        "Nerve exposure and compression causing paresthesia in adjacent teeth",
        "Added occlusal stress on remaining teeth leading to immediate fracture"
      ],
      correctAnswer: 0
    },
    {
      id: 92041,
      question: "Fixed prosthodontics are cemented into place and cannot be removed by the patient at will.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 92042,
      question: "Removable prosthodontics require cementation to adjacent teeth and cannot be taken out by the patient without clinical assistance.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 92043,
      question: "Bone resorption occurs only in the maxilla and stops after approximately five years following tooth extraction.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 92044,
      question: "An inlay covers a larger portion of the occlusal surface and involves an entire cusp, while an onlay fits only within the cusps.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 92045,
      question: "The CEREC machine uses CAD/CAM technology and allows for crown preparation and placement in a single dental visit.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 92046,
      question: "A cantilever bridge is generally preferred over a traditional bridge because it provides greater stability and bilateral support.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 92047,
      question: "Dental hygienists must be knowledgeable about the specialized needs of patients with prostheses because daily maintenance by the client is a vital factor in prosthetic success.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 92048,
      question: "In adults over 35, periodontal disease plays an increasing role as a cause of tooth loss compared to adults under 35.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 92049,
      question: "A Maryland bridge requires full crown preparation of the abutment teeth in order to accommodate its retentive wings.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 92050,
      question: "Loss of occlusal vertical dimension due to multiple missing teeth can contribute to the development of temporomandibular joint disorders.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
  ],
  "2. Removable Prosthedontics": [
    {
      id: 93001,
      question: "What does a removable partial denture (RPD) replace?",
      options: [
        "All natural teeth in a full arch, both maxillary and mandibular",
        "One or more, but less than all, of the natural teeth and associated structures",
        "Only the posterior teeth when the anterior teeth are healthy and stable",
        "Only teeth lost due to periodontal disease, not trauma or decay"
      ],
      correctAnswer: 1
    },
    {
      id: 93002,
      question: "Which of the following is an advantage of a removable partial denture?",
      options: [
        "It is permanently fixed and does not require daily removal or cleaning",
        "It is more affordable than a fixed prosthesis and suitable for patients with advanced periodontal disease",
        "It eliminates all risk of further bone resorption under the prosthesis",
        "It requires no adjustment visits after initial placement by the dentist"
      ],
      correctAnswer: 1
    },
    {
      id: 93003,
      question: "What type of metal is typically used for the framework of a removable partial denture?",
      options: [
        "Titanium alloy, due to its lightweight and biocompatibility properties",
        "Stainless steel, because it is the most widely available dental metal",
        "Chrome cobalt, providing strength and durability for the RPD framework",
        "Gold alloy, which is preferred for its corrosion-resistant properties"
      ],
      correctAnswer: 2
    },
    {
      id: 93004,
      question: "What is a pontic in the context of a partial denture?",
      options: [
        "The cast metal skeleton that provides structural support for the prosthesis",
        "The metal clasp that wraps around an abutment tooth for retention",
        "An artificial tooth or teeth occupying the edentulous space to replace missing teeth",
        "The connector that joins the major and minor parts of the partial frame"
      ],
      correctAnswer: 2
    },
    {
      id: 93005,
      question: "What is the function of a retainer (clasp) in a removable partial denture?",
      options: [
        "It joins the various parts of the partial denture framework together",
        "It controls the seating position of the prosthesis against the teeth",
        "It provides a surface for the denture to rest on the oral mucosa",
        "It supports and provides stability by partially circling an abutment tooth"
      ],
      correctAnswer: 3
    },
    {
      id: 93006,
      question: "Which component of a partial denture is described as a metal projection designed to control the seating of the prosthesis?",
      options: [
        "The connector, which links the major and minor parts of the framework",
        "The retainer clasp that partially encircles the abutment tooth surface",
        "The rest, positioned on a prepared surface of the abutment tooth",
        "The denture base, which rests on the mucosal tissue of the ridge"
      ],
      correctAnswer: 2
    },
    {
      id: 93007,
      question: "What happens to opposing teeth when adjacent teeth are not replaced after extraction?",
      options: [
        "They remain stable because the arch is self-supporting without the missing tooth",
        "They supererupt into the space left by the missing opposing tooth",
        "They tilt toward the space but opposing teeth are unaffected by the gap",
        "They become hypermobile due to loss of biting force distribution"
      ],
      correctAnswer: 1
    },
    {
      id: 93008,
      question: "Which of the following is a consequence of not replacing missing teeth?",
      options: [
        "Increased bone density due to redistribution of occlusal forces",
        "Adjacent teeth become more stable as spacing is naturally corrected",
        "Loss of occlusal vertical dimension leading to possible TMJ disorders",
        "Reduced salivary flow preventing fungal infections at the oral corners"
      ],
      correctAnswer: 2
    },
    {
      id: 93009,
      question: "What condition can result from loss of vertical dimension due to missing teeth?",
      options: [
        "Bruxism caused by increased occlusal forces on the remaining teeth",
        "Angular cheilitis caused by saliva pooling and potential fungal growth",
        "Pericoronitis caused by third molar eruption in the posterior space",
        "Gingivitis caused by increased plaque retention on remaining teeth"
      ],
      correctAnswer: 1
    },
    {
      id: 93010,
      question: "A complete denture replaces which of the following?",
      options: [
        "All teeth in one or both arches, both maxillary and/or mandibular",
        "One or more missing teeth, but retains some natural teeth in the arch",
        "Only the mandibular arch when the maxillary teeth remain healthy",
        "Teeth lost due to caries only, not teeth extracted for periodontal reasons"
      ],
      correctAnswer: 0
    },
    {
      id: 93011,
      question: "Which type of complete denture is placed immediately after tooth extraction?",
      options: [
        "The conventional tissue-supported denture placed after full healing occurs",
        "The immediate denture placed right after extraction of natural teeth",
        "The overdenture placed over retained roots following endodontic therapy",
        "The implant denture placed once implants have integrated into the bone"
      ],
      correctAnswer: 1
    },
    {
      id: 93012,
      question: "What is a key characteristic of an interim (interm) denture?",
      options: [
        "It is designed for permanent use and replaces the need for a definitive prosthesis",
        "It is a provisional prosthesis used for a limited time before a definitive prosthesis",
        "It is always implant-supported and used only after multiple extractions",
        "It is constructed specifically for edentulous patients who refuse implants"
      ],
      correctAnswer: 1
    },
    {
      id: 93013,
      question: "What is an overdenture also known as?",
      options: [
        "A primary prosthesis, used when first transitioning to complete tooth loss",
        "A conventional denture, resting entirely on the mucosal alveolar ridge",
        "An overlay prosthesis, supported by remaining teeth and/or implants",
        "A tissue-supported denture, designed for the edentulous arch surface"
      ],
      correctAnswer: 2
    },
    {
      id: 93014,
      question: "Which teeth are most commonly retained as abutments for a root-supported overdenture?",
      options: [
        "The first molars because they have the largest root surface area present",
        "The central incisors because they are the easiest to reduce coronally",
        "The canines because of their strong roots and favorable arch position",
        "The premolars because they balance the forces on the anterior arch"
      ],
      correctAnswer: 2
    },
    {
      id: 93015,
      question: "What is a significant advantage of a root-supported overdenture compared to a conventional denture?",
      options: [
        "It eliminates the need for any dental visits after the prosthesis is placed",
        "It requires no endodontic treatment of the retained root abutments",
        "Less alveolar bone resorption occurs and masticatory efficiency is improved",
        "It is less expensive than conventional dentures due to simpler construction"
      ],
      correctAnswer: 2
    },
    {
      id: 93016,
      question: "How many implants are typically used for a mandibular implant-supported overdenture with good long-term survival?",
      options: [
        "Four implants placed bilaterally in the posterior mandibular region",
        "Two implants placed in the mandibular canine area",
        "Six implants distributed evenly across the entire mandibular arch",
        "One implant placed at the midline of the mandibular symphysis region"
      ],
      correctAnswer: 1
    },
    {
      id: 93017,
      question: "What is the denture base of a complete denture primarily made of?",
      options: [
        "Chrome cobalt metal, which is stronger and more durable than resin",
        "Porcelain, which is preferred for its natural appearance and hardness",
        "Plastic acrylic resin, sometimes combined with metal for added support",
        "Composite resin, which bonds to the artificial teeth for full retention"
      ],
      correctAnswer: 2
    },
    {
      id: 93018,
      question: "What is the impression surface of a complete denture?",
      options: [
        "The outer polished surface visible when the denture is outside the mouth",
        "The surface that contacts the opposing teeth or opposing dental prosthesis",
        "The tissue or inner surface of the denture that lies on the residual ridge",
        "The posterior palatal surface that creates a seal against the soft palate"
      ],
      correctAnswer: 2
    },
    {
      id: 93019,
      question: "Which of the following is a correct statement about denture adhesives?",
      options: [
        "Patients should use adhesives permanently as a long-term solution for fit",
        "Adhesives improve denture retention and comfort and should be cleaned daily",
        "Adhesives should remain in the mouth even after denture removal at night",
        "Adhesives are only appropriate for new denture wearers in the first week"
      ],
      correctAnswer: 1
    },
    {
      id: 93020,
      question: "What does the post dam provide for a maxillary denture?",
      options: [
        "A metal bar that connects the implant abutments under the denture base",
        "A posterior palatal seal that helps retain the maxillary denture in place",
        "A flexible border that adapts to the soft tissue at the denture flanges",
        "A ridge lap contact area that distributes pressure under the pontic"
      ],
      correctAnswer: 1
    },
    {
      id: 93021,
      question: "What material are the artificial teeth of a complete denture most commonly made from?",
      options: [
        "Chrome cobalt metal, providing maximum strength during chewing function",
        "Gold alloy, which is preferred for posterior teeth due to wear resistance",
        "Plastic acrylic resin, composite resin, porcelain, or polymethyl methacrylate",
        "Stainless steel alloy, providing durability and resistance to fracture loads"
      ],
      correctAnswer: 2
    },
    {
      id: 93022,
      question: "What is an obturator designed to do?",
      options: [
        "Replace missing posterior teeth and support the posterior facial contour",
        "Stabilize an overdenture by snapping onto implant abutment connectors",
        "Close a congenital or acquired opening such as a cleft of the hard palate",
        "Retain a complete mandibular denture by engaging the alveolar ridge"
      ],
      correctAnswer: 2
    },
    {
      id: 93023,
      question: "Which of the following is a clinical consideration for a patient with an obturator?",
      options: [
        "The obturator must always be removed before eating to protect the tissue",
        "The obturator must always be removed prior to taking dental radiographs",
        "The obturator should be worn only at night to allow daytime tissue recovery",
        "The obturator must be replaced every six months due to material degradation"
      ],
      correctAnswer: 1
    },
    {
      id: 93024,
      question: "What is the recommended frequency of hygiene visits for a patient with an obturator?",
      options: [
        "Once a year is sufficient if the patient follows excellent daily home care",
        "Every six months, the same standard recall interval as regular patients",
        "Approximately three hygiene visits per year depending on risk and compliance",
        "Every two months initially, then reduced to quarterly after one full year"
      ],
      correctAnswer: 2
    },
    {
      id: 93025,
      question: "What role does a dental hygienist play in fabrication of prosthodontics?",
      options: [
        "Designing the framework and selecting the type of clasp for the partial",
        "Taking final impressions and fabricating the denture in the dental lab",
        "Conducting client assessment, education, and prosthodontic maintenance",
        "Performing tooth preparation and placement of the finished prosthesis"
      ],
      correctAnswer: 2
    },
    {
      id: 93026,
      question: "When should a removable prosthesis be removed each night?",
      options: [
        "Only when the patient experiences pain or discomfort wearing the device",
        "For a 6–8 hour period each night to allow tissue rest and reduce inflammation",
        "It does not need to be removed nightly if cleaned thoroughly each morning",
        "For a 2–3 hour period is sufficient if soaked in cleanser during removal"
      ],
      correctAnswer: 1
    },
    {
      id: 93027,
      question: "How should a removable prosthesis be stored when it is not in the mouth?",
      options: [
        "Stored dry in an open container to allow air circulation and prevent odors",
        "Wrapped in a damp paper towel to prevent drying and warping overnight",
        "Fully submerged in warm (not hot) water or cleaning solution in a covered container",
        "Placed in a sealed plastic bag to maintain moisture and prevent warping"
      ],
      correctAnswer: 2
    },
    {
      id: 93028,
      question: "Why should hot water never be used to store or rinse a removable denture?",
      options: [
        "Hot water destroys the antifungal properties of the denture cleanser solution",
        "Hot water can distort or warp the plastic acrylic resin of the denture base",
        "Hot water reacts with chrome cobalt to cause metal corrosion and staining",
        "Hot water causes the artificial teeth to loosen from the denture base resin"
      ],
      correctAnswer: 1
    },
    {
      id: 93029,
      question: "Which denture cleanser is considered most effective at killing pathogens such as Candida and MRSA?",
      options: [
        "Alkaline peroxide tablets, which use oxygen bubbling to remove deposits",
        "Enzymatic cleansers that break down protein-based biofilm on the denture",
        "Sodium hypochlorite, which is a bactericidal and fungicidal chemical agent",
        "Chlorhexidine gluconate, which provides antibacterial and antifungal action"
      ],
      correctAnswer: 2
    },
    {
      id: 93030,
      question: "What is a disadvantage of alkaline peroxide as a denture cleanser?",
      options: [
        "It corrodes the metal components and may bleach the acrylic denture base",
        "It is harmful to soft liners and is not very effective at removing calculus",
        "It stains denture teeth and provides only temporary relief of stomatitis",
        "It requires in-office application only and cannot be used by the patient"
      ],
      correctAnswer: 1
    },
    {
      id: 93031,
      question: "Which of the following is an advantage of immersion-type denture cleansers?",
      options: [
        "They can replace the need for physical brushing of the impression surface",
        "They reach all areas of the denture and minimize the risk of dropping it",
        "They are less expensive than brushing with a commercial denture paste",
        "They prevent the need for any dental visits to adjust the denture fit"
      ],
      correctAnswer: 1
    },
    {
      id: 93032,
      question: "For self-care of a fixed prosthesis, what technique is recommended to clean the gingival surface of a pontic?",
      options: [
        "Sulcular toothbrushing technique applied directly to the pontic surface",
        "Charters toothbrushing technique directed at the facial gingival pontic surface",
        "Rolling stroke technique used to sweep debris away from the pontic area",
        "Modified Stillman technique applied with downward pressure on pontic"
      ],
      correctAnswer: 1
    },
    {
      id: 93033,
      question: "What type of floss is recommended for cleaning under fixed prosthesis pontics?",
      options: [
        "Waxed dental floss, which slides more easily under tight contact areas",
        "Unwaxed dental floss, which expands to clean the full interproximal area",
        "Tufted floss threaded through a floss threader to pass under the pontic",
        "PTFE floss, which is shred-resistant and ideal for fixed bridge contacts"
      ],
      correctAnswer: 2
    },
    {
      id: 93034,
      question: "What is denture stomatitis most commonly associated with?",
      options: [
        "Trauma from sharp denture edges that abrade the palatal mucosal tissue",
        "Candida albicans infection combined with poor denture hygiene and continuous wear",
        "Bacterial overgrowth caused by use of denture adhesives under the prosthesis",
        "Allergic reaction to chrome cobalt metal used in the partial denture framework"
      ],
      correctAnswer: 1
    },
    {
      id: 93035,
      question: "Which population is denture stomatitis more frequently diagnosed in?",
      options: [
        "Younger male patients who smoke and wear dentures for less than two years",
        "Elderly male patients who have multiple systemic diseases and dry mouth",
        "Females more than males and more common under a maxillary denture",
        "Patients with mandibular complete dentures who also have diabetes mellitus"
      ],
      correctAnswer: 2
    },
    {
      id: 93036,
      question: "What is the treatment for denture stomatitis?",
      options: [
        "Immediate replacement of the denture with a new implant-supported prosthesis",
        "Denture adjustment or new denture, antifungal medication, and improved denture care",
        "Surgical removal of the affected mucosa followed by a soft tissue graft",
        "Short-term steroid therapy and temporary removal of the denture for two weeks"
      ],
      correctAnswer: 1
    },
    {
      id: 93037,
      question: "Angular cheilitis appears clinically as which of the following?",
      options: [
        "A generalized red velvet-like surface covering the entire palatal mucosa",
        "Pebble-shaped nodules arranged in a cobblestone pattern on the palate",
        "Fissuring at the angles of the mouth with cracks, erythema, and ulcerations",
        "Isolated white keratotic patches found on the buccal mucosa or ridge"
      ],
      correctAnswer: 2
    },
    {
      id: 93038,
      question: "Which nutritional deficiency can complicate angular cheilitis, particularly in elderly patients?",
      options: [
        "Vitamin C deficiency causing impaired wound healing and connective tissue breakdown",
        "Vitamin D deficiency causing reduced calcium absorption and bone resorption",
        "Vitamin B deficiency which can worsen angular cheilitis in debilitated patients",
        "Iron deficiency causing anemia and increased susceptibility to oral infections"
      ],
      correctAnswer: 2
    },
    {
      id: 93039,
      question: "What is epulis fissuratum?",
      options: [
        "A group of red pebble-shaped projections located on the hard palate",
        "Long-standing chronic inflammatory tissue appearing as tissue growth over alveolar ridges",
        "Mobile soft tissue on the superficial aspect of the alveolar ridge surface",
        "Generalized redness of the mucosa with a velvet-like appearance and burning"
      ],
      correctAnswer: 1
    },
    {
      id: 93040,
      question: "What is the treatment for epulis fissuratum?",
      options: [
        "Antifungal medication applied topically or prescribed systemically by the DDS",
        "Denture adhesive adjustment and improved home care with daily brushing",
        "Surgical removal by scalpel or laser and denture replacement or adjustment",
        "Relining of the existing denture to eliminate pressure on the affected tissue"
      ],
      correctAnswer: 2
    },
    {
      id: 93041,
      question: "Inflammatory hyperplasia from dentures is typically located where?",
      options: [
        "At the angles of the mouth, in the commissural folds of the lips",
        "On the vestibular mucosa at the border of the denture flange area",
        "On the palate, rarely outside the confines of the bony ridges",
        "Under the mandibular denture at the lingual frenum attachment area"
      ],
      correctAnswer: 1
    },
    {
      id: 93042,
      question: "What is palatal papillary hyperplasia caused by?",
      options: [
        "Trauma from overextended denture flanges pressing on the alveolar ridge",
        "Candida albicans infection combined with chronic low-grade denture trauma",
        "Vitamin deficiency causing abnormal tissue growth on the hard palate",
        "Bacterial infection under an ill-fitting mandibular denture base area"
      ],
      correctAnswer: 1
    },
    {
      id: 93043,
      question: "What is the clinical appearance of palatal papillary hyperplasia?",
      options: [
        "Single raised ulcerated lesion with a yellow membrane and elevated margins",
        "White keratotic patch that is asymptomatic and does not bleed on contact",
        "Multiple round-ovoid nodules in a cobblestone appearance with red mucosa",
        "Folds of fibrous connective tissue of varying color at the denture border"
      ],
      correctAnswer: 2
    },
    {
      id: 93044,
      question: "A traumatic ulcer from a denture that persists longer than 7–14 days after adjustment should be managed how?",
      options: [
        "The patient should apply OTC topical anesthetic gel and monitor for changes",
        "The ulcer should be biopsied because it may resemble a cancerous lesion",
        "The denture should be relined immediately to reduce pressure on the tissue",
        "The patient should stop wearing the denture for one month for full healing"
      ],
      correctAnswer: 1
    },
    {
      id: 93045,
      question: "What is the primary treatment for denture-induced traumatic ulcers or sore spots?",
      options: [
        "Prescription antifungal medication applied directly to the ulcerated area",
        "Surgical excision of the ulcer followed by a soft tissue healing period",
        "Referral to a DDS for adjustment of the denture causing the irritation",
        "Application of a soft reline material to cushion the affected sore area"
      ],
      correctAnswer: 2
    },
    {
      id: 93046,
      question: "What is relining a denture?",
      options: [
        "Replacing the artificial teeth with new ones of a different shade or mold",
        "Placing a new layer of denture resin over the tissue surface of the prosthesis",
        "Replacing the entire denture base without changing the occlusal relationship",
        "Adjusting the metal framework of a partial denture to improve retention"
      ],
      correctAnswer: 1
    },
    {
      id: 93047,
      question: "How does relining differ from rebasing a denture?",
      options: [
        "In relining, new teeth are placed; in rebasing, the impression surface is adjusted",
        "Relining resurfaces the prosthesis; rebasing replaces the entire denture base",
        "Relining replaces the metal framework; rebasing replaces the acrylic resin teeth",
        "Relining is done in the lab; rebasing is done chairside by the dentist directly"
      ],
      correctAnswer: 1
    },
    {
      id: 93048,
      question: "Which type of complete denture is supported by remaining natural roots that have been reduced to gingival level?",
      options: [
        "The implant-supported overdenture, using titanium fixtures in the bone",
        "The conventional tissue-supported denture resting on the alveolar ridge",
        "The root-supported overdenture using retained periodontally healthy roots",
        "The immediate denture placed directly after all remaining teeth are extracted"
      ],
      correctAnswer: 2
    },
    {
      id: 93049,
      question: "What are the most common causes of abutment tooth loss in root-supported overdentures?",
      options: [
        "Fracture of the root and pulp necrosis due to the endodontic treatment",
        "Periodontal disease and dental caries affecting the retained root abutments",
        "Occlusal overload and denture base fracture over the retained roots",
        "Gingival recession and root resorption caused by the overdenture pressure"
      ],
      correctAnswer: 1
    },
    {
      id: 93050,
      question: "Which type of denture is used when primary teeth are congenitally missing (anodontia)?",
      options: [
        "The immediate denture, placed right after extraction of the affected teeth",
        "The interim denture, used as a provisional to evaluate esthetic outcomes",
        "The primary teeth denture, constructed to provide esthetics and function for children",
        "The overdenture, placed over retained root fragments in pediatric patients"
      ],
      correctAnswer: 2
    },
    {
      id: 93051,
      question: "What is a flabby ridge?",
      options: [
        "A firm bony ridge that has significant undercuts making denture insertion difficult",
        "Mobile soft tissue on the alveolar ridge caused by replacement with fibrous tissue",
        "A sharp bony prominence covered by thin mucosa causing denture soreness",
        "Inflamed ridge tissue associated with active periodontal disease and bone loss"
      ],
      correctAnswer: 1
    },
    {
      id: 93052,
      question: "What is improper storage of a denture in water associated with?",
      options: [
        "A 2 times increased risk of oral mucosal lesions from microorganism growth",
        "An 8 times increased risk of oral mucosal lesions such as denture stomatitis",
        "A 4 times increased risk of angular cheilitis and fungal oral infections",
        "A 6 times increased risk of denture fracture from prolonged water immersion"
      ],
      correctAnswer: 1
    },
    {
      id: 93053,
      question: "When should the denture for primary teeth be adjusted?",
      options: [
        "Every six months to account for normal growth and development in children",
        "As permanent teeth begin to erupt, to allow space for eruption to occur",
        "Only when the child reports pain or difficulty eating with the prosthesis",
        "Once a year at the annual dental examination to monitor fit and retention"
      ],
      correctAnswer: 1
    },
    {
      id: 93054,
      question: "What is the role of the dental assistant in prosthodontic fabrication?",
      options: [
        "Client assessment, prosthodontic design, and placement of the final prosthesis",
        "Client education and performing bite registration and impression-taking procedures",
        "Fabricating the metal framework in the lab and adjusting clasp assemblies",
        "Conducting all hygiene appointments and maintenance of the prosthesis fit"
      ],
      correctAnswer: 1
    },
    {
      id: 93055,
      question: "According to CDHO DH Standards of Practice, when should an RDH collaborate with a prosthodontist?",
      options: [
        "For all cases involving any form of missing teeth regardless of complexity",
        "For advanced cases or full mouth reconstruction, typically via referral through DDS",
        "Whenever a patient requests a dental implant or implant-supported denture",
        "Only when the patient is under 18 years old and requires pediatric prosthetics"
      ],
      correctAnswer: 1
    },
    {
      id: 93056,
      question: "What is a precision attachment in a removable partial denture?",
      options: [
        "A connector consisting of a metal receptacle and close-fitting part for retention",
        "A metal rest designed to seat the prosthesis in the correct vertical position",
        "A special clasp that uses friction rather than wrapping to retain the partial",
        "A direct retainer that engages the undercut of the abutment tooth buccally"
      ],
      correctAnswer: 0
    },
    {
      id: 93057,
      question: "Which of the following best describes the denture base in a complete denture?",
      options: [
        "The cast framework that connects the clasps, rests, and connectors together",
        "The part resting on the oral mucosa and alveolar ridge to which teeth attach",
        "The outer polished surface that is visible from the facial and buccal aspects",
        "The posterior seal area that creates suction for maxillary denture retention"
      ],
      correctAnswer: 1
    },
    {
      id: 93058,
      question: "Which of the following are all components of a removable partial denture?",
      options: [
        "Rests, connectors, denture base, metal framework, retainers, and artificial teeth",
        "Post dam, impression surface, polished surface, occlusal surface, and teeth only",
        "Major connector, minor connector, pontic, implant, and abutment crown only",
        "Clasps, implants, post dam, denture teeth, and soft tissue lining material only"
      ],
      correctAnswer: 0
    },
    {
      id: 93059,
      question: "What is an indication for a full complete denture?",
      options: [
        "The patient has advanced periodontal disease but most teeth can be retained",
        "The remaining teeth cannot be saved and no acceptable alternatives are available",
        "The patient requests a denture but still has several healthy restorable teeth",
        "The patient's teeth are mildly decayed but financially unable to afford fillings"
      ],
      correctAnswer: 1
    },
    {
      id: 93060,
      question: "Which of the following is a contraindication to a full denture?",
      options: [
        "The patient is edentulous and has no remaining natural teeth in the arch",
        "The remaining teeth are too mobile to retain a removable partial denture",
        "Physical or mental illness affects the patient's ability to cooperate or accept the denture",
        "The patient's remaining teeth have significant decay and cannot be restored"
      ],
      correctAnswer: 2
    },
    {
      id: 93061,
      question: "What benefit does an oral irrigator provide when used with a removable prosthesis?",
      options: [
        "It physically removes calculus buildup from the impression surface of the denture",
        "It reduces gingivitis, biofilm, and inflammation and delivers antimicrobial agents subgingivally",
        "It replaces the need for flossing under fixed bridges and around implant abutments",
        "It sterilizes the denture surface more effectively than soaking in cleanser solution"
      ],
      correctAnswer: 1
    },
    {
      id: 93062,
      question: "What is a clasp brush used for in denture care?",
      options: [
        "Brushing the polished outer surface of the denture to remove stain buildup",
        "Cleaning biofilm from the inner surfaces of clasps and precision attachments",
        "Applying denture adhesive evenly to the impression surface before insertion",
        "Removing calculus deposits from the occlusal surface of the artificial teeth"
      ],
      correctAnswer: 1
    },
    {
      id: 93063,
      question: "What denture cleanser has the mechanism of dissolving mucins and organic substances of the prosthesis biofilm matrix?",
      options: [
        "Alkaline peroxide, which creates a mechanical bubbling cleansing effect",
        "Chlorhexidine gluconate, which acts as an antimicrobial chemical agent",
        "Alkaline hypochlorite, which dissolves organic components of biofilm matrix",
        "Ultrasonic devices, which create vibrating and bubbling to remove deposits"
      ],
      correctAnswer: 2
    },
    {
      id: 93064,
      question: "What is the purpose of using a nonabrasive dentifrice when brushing around fixed prosthetics?",
      options: [
        "Nonabrasive dentifrices contain more fluoride to protect the abutment roots",
        "Nonabrasive dentifrices prevent abrasion of the prosthesis surface material",
        "Nonabrasive dentifrices reduce gingival inflammation around the abutment teeth",
        "Nonabrasive dentifrices are more effective at removing biofilm than regular paste"
      ],
      correctAnswer: 1
    },
    {
      id: 93065,
      question: "A removable partial denture can be removed from the mouth by the patient.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 93066,
      question: "The consequences of not replacing missing teeth include migration and supereruption of adjacent and opposing teeth.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 93067,
      question: "A complete (full) denture can only be a removable type; it cannot be fixed.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 93068,
      question: "Immediate dentures often loosen after placement due to bone and soft tissue remodeling following surgery.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 93069,
      question: "Root-supported overdentures eliminate the risk of dental caries on the retained roots.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 93070,
      question: "Sodium hypochlorite soaking for longer than 10 minutes may cause damage to a removable partial denture.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 93071,
      question: "Denture stomatitis is more commonly found under a mandibular denture than a maxillary denture.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 93072,
      question: "Continuous wear of dentures doubles the risk of oral mucosal lesions such as denture stomatitis.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 93073,
      question: "Brushing is considered the most effective method to disinfect a removable partial or complete prosthesis.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 93074,
      question: "An obturator patient may require 3 hygiene visits per year depending on compliance and oral disease risk factors.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
  ],
  "3. Endodontics": [
    {
      id: 94001,
      question: "What does the term \"endodontics\" literally mean?",
      options: [
        "Inside the tooth",
        "Around the root",
        "Outside the tooth",
        "Below the gum line"
      ],
      correctAnswer: 0
    },
    {
      id: 94002,
      question: "Which of the following best describes the dental pulp?",
      options: [
        "Connective tissue composed of nerves, blood vessels, and other cells",
        "A hard calcified layer that covers the root surface",
        "The outermost layer of the tooth crown made of enamel",
        "A mineralized tissue that lines the inner surface of alveolar bone"
      ],
      correctAnswer: 0
    },
    {
      id: 94003,
      question: "How many additional years of training does a specialist endodontist receive beyond general dentistry?",
      options: [
        "3 years",
        "1 year",
        "2 years",
        "4 years"
      ],
      correctAnswer: 0
    },
    {
      id: 94004,
      question: "Which of the following is a microbial cause of pulp damage?",
      options: [
        "Bacteria-related infection entering the pulp",
        "Orthodontic movement applying excessive force",
        "Sensitivity or allergy to restorative materials",
        "Tooth preparation during crown placement"
      ],
      correctAnswer: 0
    },
    {
      id: 94005,
      question: "Which of the following is classified as a mechanical cause of pulpal irritation?",
      options: [
        "Intense parafunctional habits such as bruxism",
        "Tooth bleaching agents",
        "Allergy to composite resin materials",
        "Bacterial invasion through dentinal tubules"
      ],
      correctAnswer: 0
    },
    {
      id: 94006,
      question: "What are the primary symptoms of pulpal nerve damage?",
      options: [
        "Pain on occlusion, pain during mastication, temperature sensitivity, and facial swelling",
        "Tooth discoloration, bone loss, gingival recession, and halitosis",
        "Increased salivation, bleeding on probing, pocket formation, and mobility",
        "Snoring, jaw clicking, headache, and ear ringing"
      ],
      correctAnswer: 0
    },
    {
      id: 94007,
      question: "Cracked tooth syndrome is defined as which of the following?",
      options: [
        "An incomplete fracture of the dentine in a vital posterior tooth",
        "A complete fracture of the enamel extending into the cementum",
        "A vertical split of the root caused by excessive occlusal loading",
        "A horizontal fracture of the crown caused by trauma"
      ],
      correctAnswer: 0
    },
    {
      id: 94008,
      question: "Which instrument or method is used during clinical examination to detect a cracked tooth?",
      options: [
        "A sharp explorer whose tip may catch in a crack",
        "Periodontal probe inserted into the sulcus",
        "Radiograph taken with a bisecting angle technique",
        "Pulp tester delivering an electrical stimulus"
      ],
      correctAnswer: 0
    },
    {
      id: 94009,
      question: "Which of the following is used in transillumination to help detect a fracture line in a tooth?",
      options: [
        "Fiber optic light directed through the tooth",
        "Carbon dioxide spray applied to the surface",
        "Warm gutta-percha placed against enamel",
        "Sodium hypochlorite solution applied to dentin"
      ],
      correctAnswer: 0
    },
    {
      id: 94010,
      question: "What does a positive response to a percussion test indicate?",
      options: [
        "There is inflammation in the periodontal ligament",
        "The pulp has undergone complete necrosis",
        "The root canal system contains accessory canals",
        "The tooth has a vertical root fracture"
      ],
      correctAnswer: 0
    },
    {
      id: 94011,
      question: "How is a palpation test performed during an endodontic examination?",
      options: [
        "The clinician applies firm pressure to the mucosa above the root apex",
        "The clinician taps the incisal edge with a mirror handle",
        "The clinician places ice on the facial surface of the tooth",
        "The clinician inserts a file to gauge resistance in the canal"
      ],
      correctAnswer: 0
    },
    {
      id: 94012,
      question: "A necrotic pulp will display which characteristic response during thermal testing?",
      options: [
        "No response to either cold or heat stimulation",
        "Prolonged and intense pain to cold stimuli only",
        "Immediate sharp pain that subsides within seconds",
        "Heightened sensitivity to warm but not cold stimuli"
      ],
      correctAnswer: 0
    },
    {
      id: 94013,
      question: "Which materials are used for the cold test in pulp vitality assessment?",
      options: [
        "Ice, dry ice, or carbon dioxide spray",
        "Warm gutta-percha and heated metal instruments",
        "Calcium hydroxide paste and zinc oxide eugenol",
        "Parachlorophenol and sodium hypochlorite solution"
      ],
      correctAnswer: 0
    },
    {
      id: 94014,
      question: "Where should thermal stimuli NEVER be applied during testing?",
      options: [
        "A metallic restoration or gingival tissue",
        "The lingual surface of mandibular molars",
        "The incisal edge of upper anterior teeth",
        "The mesial surface adjacent to the contact point"
      ],
      correctAnswer: 0
    },
    {
      id: 94015,
      question: "Which of the following factors can cause a false-positive or false-negative result with an electric pulp tester?",
      options: [
        "The tooth has more than one canal",
        "The patient reports sharp, brief pain to cold",
        "Testing is performed on the lingual surface",
        "There is no restorative material present on the tooth"
      ],
      correctAnswer: 0
    },
    {
      id: 94016,
      question: "Which term describes a tooth whose pulp shows no subjective symptoms, responds normally to sensory stimuli, and is surrounded by a healthy layer of dentin?",
      options: [
        "Normal pulp",
        "Reversible pulpitis",
        "Pulp fibrosis",
        "Necrotic pulp"
      ],
      correctAnswer: 0
    },
    {
      id: 94017,
      question: "What distinguishes reversible pulpitis from irreversible pulpitis?",
      options: [
        "Reversible pulpitis only occurs in primary teeth; irreversible only in permanent teeth",
        "In reversible pulpitis, symptoms subside after sedative treatment; in irreversible they persist",
        "Reversible pulpitis always requires extraction; irreversible requires observation only",
        "Reversible pulpitis shows necrosis on radiograph; irreversible shows normal bone levels"
      ],
      correctAnswer: 1
    },
    {
      id: 94018,
      question: "What sedative dressing material is placed in the cavity preparation to treat reversible pulpitis?",
      options: [
        "Zinc oxide eugenol cement mixed to a firm consistency",
        "Calcium hydroxide placed in the cavity preparation",
        "Formocresol solution diluted with sterile water",
        "Sodium hypochlorite irrigated into the pulp chamber"
      ],
      correctAnswer: 1
    },
    {
      id: 94019,
      question: "What is the only treatment alternative to endodontic therapy for a tooth with irreversible pulpitis?",
      options: [
        "Pulpotomy with formocresol dressing",
        "Extraction of the tooth",
        "Indirect pulp capping with calcium hydroxide",
        "Scaling and root planing of adjacent tissues"
      ],
      correctAnswer: 1
    },
    {
      id: 94020,
      question: "Pulpal necrosis is best described as which of the following?",
      options: [
        "Mild inflammation of the pulp that responds to sedative treatment",
        "Nonvital, infected \"dead\" pulp deprived of its nerve and blood supply",
        "Reversible inflammation caused by a thin partition of exposed dentin",
        "Calcification of the pulp canal that prevents file penetration"
      ],
      correctAnswer: 1
    },
    {
      id: 94021,
      question: "What radiographic finding is most associated with a periapical abscess (Lesion of Endodontic Origin)?",
      options: [
        "Horizontal bone loss appearing as a shelf along the root",
        "Rounded radiolucency at the apex of the tooth",
        "Widening of the periodontal ligament space in the coronal third",
        "Calcified deposit appearing as a radiopaque mass within the canal"
      ],
      correctAnswer: 1
    },
    {
      id: 94022,
      question: "An untreated periapical abscess can potentially lead to which life-threatening condition?",
      options: [
        "Horizontal root resorption at the apical third",
        "Cellulitis spreading to the connective tissues of the face and neck",
        "Pulp calcification blocking all root canal access",
        "Chronic periodontitis with generalized bone loss"
      ],
      correctAnswer: 1
    },
    {
      id: 94023,
      question: "When assessing tooth pain to determine its origin, what percentage is generally attributed to pulpal causes versus periodontal causes?",
      options: [
        "50% pulpal and 50% periodontal",
        "85% pulpal and 15% periodontal",
        "70% pulpal and 30% periodontal",
        "60% pulpal and 40% periodontal"
      ],
      correctAnswer: 1
    },
    {
      id: 94024,
      question: "What is a combination abscess?",
      options: [
        "An abscess involving both primary and permanent teeth simultaneously",
        "An abscess present when both periapical and periodontal infectious processes occur in the same tooth",
        "An abscess caused by both bacterial and chemical irritation in the pulp",
        "An abscess that has both acute and chronic features at the same time"
      ],
      correctAnswer: 1
    },
    {
      id: 94025,
      question: "Which of the following best describes a periradicular cyst?",
      options: [
        "A fluid-filled sac forming within the gingival sulcus due to bacterial plaque",
        "A cyst developing at or near the root of a necrotic tooth as an inflammatory response",
        "A cyst that develops inside the pulp chamber as a result of calcification",
        "A cyst that develops in the alveolar bone unrelated to tooth vitality"
      ],
      correctAnswer: 1
    },
    {
      id: 94026,
      question: "Pulp fibrosis is characterized by which of the following?",
      options: [
        "Bacterial invasion causing complete liquefaction of the pulp contents",
        "A decrease in living cells causing fibrous tissue to replace the pulp canal",
        "Rapid cellular proliferation forming granulation tissue in the apex",
        "Formation of secondary cementum inside the root canal space"
      ],
      correctAnswer: 1
    },
    {
      id: 94027,
      question: "In which patient population is pulp fibrosis most commonly seen?",
      options: [
        "Adolescents undergoing orthodontic treatment",
        "Older patients as part of the aging process",
        "Children with primary dentition and deep caries",
        "Middle-aged adults with parafunctional habits"
      ],
      correctAnswer: 1
    },
    {
      id: 94028,
      question: "What procedure involves removal of only the coronal portion of exposed vital pulp to preserve root vitality?",
      options: [
        "Apicoectomy",
        "Pulpotomy",
        "Retrograde restoration",
        "Pulpectomy"
      ],
      correctAnswer: 1
    },
    {
      id: 94029,
      question: "For which of the following situations is a pulpotomy most commonly indicated?",
      options: [
        "Permanent teeth with complete pulp necrosis and periapical pathology",
        "Vital primary teeth and teeth with deep carious lesions",
        "Teeth requiring retrograde filling after failed root canal therapy",
        "Teeth with severely curved roots that prevent file penetration"
      ],
      correctAnswer: 1
    },
    {
      id: 94030,
      question: "What is the key difference between a pulpotomy and a pulpectomy?",
      options: [
        "A pulpotomy uses rotary files; a pulpectomy uses only hand files",
        "A pulpotomy removes only the coronal pulp; a pulpectomy removes all radicular and coronal pulp",
        "A pulpotomy is always followed by extraction; a pulpectomy is the definitive treatment",
        "A pulpotomy is performed under general anesthesia; a pulpectomy under local anesthesia"
      ],
      correctAnswer: 1
    },
    {
      id: 94031,
      question: "What is the purpose of an endodontic post?",
      options: [
        "To expand the root canal space before filing begins",
        "To retain the core buildup over which the final crown restoration is placed",
        "To condense gutta-percha laterally during obturation",
        "To deliver irrigation solution deep into the apical third of the canal"
      ],
      correctAnswer: 1
    },
    {
      id: 94032,
      question: "Which of the following is the most commonly used irrigation solution during root canal therapy?",
      options: [
        "Parachlorophenol mixed with camphor",
        "Sodium hypochlorite mixed equal parts with sterile water",
        "Hydrogen peroxide diluted with sterile saline",
        "Formocresol solution at full strength"
      ],
      correctAnswer: 1
    },
    {
      id: 94033,
      question: "What is the function of irrigation solutions during root canal therapy?",
      options: [
        "To soften gutta-percha before condensation into the canal",
        "To remove debris, bleach and deodorize the canal, and control hemorrhaging",
        "To temporarily seal the access cavity between appointments",
        "To anesthetize the pulp before file instrumentation begins"
      ],
      correctAnswer: 1
    },
    {
      id: 94034,
      question: "Which instrument has a paddle end resembling a beaver tail and is used to place temporary restorative material?",
      options: [
        "Endodontic spreader",
        "Endodontic spoon excavator",
        "Glick number 1",
        "K-type file"
      ],
      correctAnswer: 2
    },
    {
      id: 94035,
      question: "Which instrument is specifically used to remove necrotic pulp tissue, decay, and temporary cement during endodontic procedures?",
      options: [
        "Hedstrom file",
        "Broach",
        "Endodontic spoon excavator",
        "Endodontic spreader"
      ],
      correctAnswer: 2
    },
    {
      id: 94036,
      question: "What is the function of a broach during endodontic treatment?",
      options: [
        "To shape and enlarge the apical third of the canal",
        "To condense gutta-percha laterally within the shaped canal",
        "To remove pulp tissue, cotton pellets, and paper points from root canals",
        "To measure the exact working length of the canal electronically"
      ],
      correctAnswer: 2
    },
    {
      id: 94037,
      question: "What is the primary function of paper points during root canal therapy?",
      options: [
        "To carry sealer cement to the apical portion of the canal",
        "To condense and adapt gutta-percha against the canal walls",
        "To absorb irrigating solutions and dry the root canal",
        "To measure and record the working length of the canal"
      ],
      correctAnswer: 2
    },
    {
      id: 94038,
      question: "Which endodontic file type is used for initial debridement, shaping, and contouring of the root canal?",
      options: [
        "Hedstrom file",
        "Gates-Glidden bur",
        "K-type file",
        "Reamer file"
      ],
      correctAnswer: 2
    },
    {
      id: 94039,
      question: "What color handle corresponds to a file with a diameter of 25, 55, or 110 on the standard color-coding chart?",
      options: [
        "Blue",
        "White",
        "Red",
        "Yellow"
      ],
      correctAnswer: 2
    },
    {
      id: 94040,
      question: "At what temperature does gutta-percha melt during obturation?",
      options: [
        "Above 120 degrees Fahrenheit",
        "Above 200 degrees Fahrenheit",
        "Above 140 degrees Fahrenheit",
        "Above 100 degrees Fahrenheit"
      ],
      correctAnswer: 2
    },
    {
      id: 94041,
      question: "What is the most common temporary restorative material placed into an endodontic access opening between appointments?",
      options: [
        "Glass ionomer restorative",
        "Zinc phosphate cement",
        "Cavit cement",
        "Intermediate restorative material mixed with eugenol"
      ],
      correctAnswer: 2
    },
    {
      id: 94042,
      question: "What are the radiographic requirements for an endodontic film?",
      options: [
        "Must show the crown and 2 mm beyond the apex with moderate contrast",
        "Must show bone levels equivalent to a full-mouth series radiograph",
        "Must show 4 to 5 mm beyond the apex, an accurate undistorted image, and good contrast",
        "Must show only the coronal third taken at a right-angle technique"
      ],
      correctAnswer: 2
    },
    {
      id: 94043,
      question: "Which radiographic image is taken to determine the length of the root canal during treatment?",
      options: [
        "Initial diagnostic radiograph",
        "Root canal completion image",
        "Working length image",
        "Recall posttreatment image"
      ],
      correctAnswer: 2
    },
    {
      id: 94044,
      question: "During root canal therapy, rubber dams are used for which purpose?",
      options: [
        "To retract the cheek and improve access to posterior teeth",
        "To prevent the electronic apex locator from short-circuiting",
        "To isolate and disinfect the operating field",
        "To stabilize the tooth during percussion testing"
      ],
      correctAnswer: 2
    },
    {
      id: 94045,
      question: "What type of anesthesia is typically used for maxillary teeth during root canal therapy?",
      options: [
        "General anesthesia with IV sedation",
        "Nerve block at the inferior alveolar nerve",
        "Infiltration anesthesia",
        "Intraosseous injection technique"
      ],
      correctAnswer: 2
    },
    {
      id: 94046,
      question: "What is the step-by-step sequence of root canal (endodontic) therapy?",
      options: [
        "Access preparation, obturation, pulpectomy, debridement, restoration",
        "Obturation, canal shaping, pulpotomy, irrigation, temporary filling",
        "Pulpectomy, debridement of canals, shaping of canals, filling of canals, restoration",
        "Temporary filling, canal debridement, pulp capping, working length, obturation"
      ],
      correctAnswer: 2
    },
    {
      id: 94047,
      question: "What percentage failure rate is associated with root canal therapy, potentially necessitating surgical intervention?",
      options: [
        "5% to 8%",
        "25% to 30%",
        "10% to 15%",
        "1% to 3%"
      ],
      correctAnswer: 2
    },
    {
      id: 94048,
      question: "Which of the following is an indication for surgical endodontic intervention?",
      options: [
        "Mild reversible pulpitis that responds to calcium hydroxide placement",
        "Normal pulp with no subjective symptoms or objective signs",
        "Persistent infection, severely curved roots, or perforation of the canal",
        "A first-time root canal with no periapical pathology present"
      ],
      correctAnswer: 2
    },
    {
      id: 94049,
      question: "What is an apicoectomy?",
      options: [
        "The complete removal of the dental pulp from the coronal and radicular portions",
        "The placement of a post and core to retain a crown on an endodontically treated tooth",
        "Surgical removal of the apical portion of the root using a high-speed handpiece",
        "The removal of one or more roots of a multirooted tooth while keeping the crown"
      ],
      correctAnswer: 2
    },
    {
      id: 94050,
      question: "What is a retrograde restoration also commonly called?",
      options: [
        "Indirect pulp cap",
        "Canal obturation",
        "Apical debridement",
        "Root-end filling"
      ],
      correctAnswer: 3
    },
    {
      id: 94051,
      question: "Root amputation is most often performed on which type of teeth?",
      options: [
        "Mandibular incisors with single roots",
        "Mandibular molars during hemisection procedures",
        "Maxillary premolars with two roots",
        "Maxillary molars with multiple roots"
      ],
      correctAnswer: 3
    },
    {
      id: 94052,
      question: "Hemisection involves which of the following?",
      options: [
        "Removing only the root tips surgically while preserving the entire crown",
        "Separating the roots of a maxillary molar without touching the crown",
        "Removing the coronal pulp tissue and capping the remaining radicular pulp",
        "Cutting the root and crown lengthwise and removing the diseased portion"
      ],
      correctAnswer: 3
    },
    {
      id: 94053,
      question: "What is the correct sequence of measurements used in an endodontic filling procedure?",
      options: [
        "Trial point, trial file, trial length",
        "Trial length, trial point, trial file",
        "Trial file, trial length, trial point",
        "Trial length, trial file, trial point"
      ],
      correctAnswer: 3
    },
    {
      id: 94054,
      question: "Which of the following describes an acute periodontal abscess?",
      options: [
        "A chronic long-standing infection associated with a sinus tract draining continuously",
        "A periapical lesion resulting from pulpal necrosis and bacterial invasion of the root canal",
        "A combination lesion involving both pulpal infection and deep periodontal pocketing",
        "Localized accumulation of purulence in the gingival wall of a periodontal pocket with rapid onset"
      ],
      correctAnswer: 3
    },
    {
      id: 94055,
      question: "What differentiates a chronic periodontal abscess from an acute periodontal abscess?",
      options: [
        "A chronic abscess involves only the gingiva; an acute abscess involves the alveolar bone",
        "A chronic abscess is always associated with a non-vital tooth; an acute abscess with a vital tooth",
        "A chronic abscess requires surgical drainage; an acute abscess resolves with antibiotics alone",
        "A chronic abscess is a long-standing infection often with a sinus tract; acute presents with sudden pain and swelling"
      ],
      correctAnswer: 3
    },
    {
      id: 94056,
      question: "What is a fistula (sinus tract) in relation to a periodontal or periapical abscess?",
      options: [
        "A pocket of purulent exudate forming at the junction of hard and soft tissue",
        "A calcified deposit forming along the root surface inside a periodontal pocket",
        "A perforated area of the root resulting from file separation during canal shaping",
        "An abnormal channel connecting the abscess to another space or to the surface"
      ],
      correctAnswer: 3
    },
    {
      id: 94057,
      question: "Which microbial species are most associated with periodontal abscesses?",
      options: [
        "Streptococcus mutans and Lactobacillus acidophilus",
        "Actinomyces and Candida albicans",
        "Staphylococcus aureus and Enterococcus faecalis",
        "Porphyromonas gingivalis and Treponema denticola among others"
      ],
      correctAnswer: 3
    },
    {
      id: 94058,
      question: "What is the primary treatment approach for an acute periodontal abscess?",
      options: [
        "Immediate extraction of the affected tooth and socket debridement",
        "Placement of an antibiotic-impregnated chip into the periodontal pocket only",
        "Root canal therapy followed by retrograde restoration at the next appointment",
        "Drainage of the abscess through the pocket or incision, scaling, and postoperative care"
      ],
      correctAnswer: 3
    },
    {
      id: 94059,
      question: "After treatment of an acute periodontal abscess, approximately how long does it take for gingival appearance to return to normal?",
      options: [
        "2 to 3 days",
        "3 to 4 months",
        "9 to 12 months",
        "6 to 8 weeks"
      ],
      correctAnswer: 3
    },
    {
      id: 94060,
      question: "What is the purpose of a control tooth in an endodontic examination?",
      options: [
        "It is used to calibrate the electronic apex locator before testing",
        "It is extracted to provide access for surgical endodontic procedures",
        "It is the first tooth treated to ensure the protocol is correct before proceeding",
        "It is a healthy tooth of the same type in the opposite quadrant used for comparison"
      ],
      correctAnswer: 3
    },
    {
      id: 94061,
      question: "What is the formulation of the formocresol pulpotomy medicament?",
      options: [
        "35% formaldehyde and 19% cresol",
        "50% formaldehyde and 50% phenol solution",
        "19% cresol and 35% calcium hydroxide",
        "19% formaldehyde and 35% cresol"
      ],
      correctAnswer: 3
    },
    {
      id: 94062,
      question: "What is parachlorophenol (PCP) used for in endodontic procedures?",
      options: [
        "As a sealer to cement gutta-percha points to the canal walls",
        "As a temporary restorative material to seal the access cavity",
        "As an anesthetic agent applied topically to the pulp tissue",
        "As an antimicrobial agent for disinfection of the pulp canal"
      ],
      correctAnswer: 3
    },
    {
      id: 94063,
      question: "Which of the following best describes the role of the endodontic spreader during root canal obturation?",
      options: [
        "It creates the access opening in the crown of the tooth",
        "It measures the working length before canal instrumentation begins",
        "It delivers paper points into the canal to absorb residual moisture",
        "It condenses gutta-percha into the canal during filling"
      ],
      correctAnswer: 3
    },
    {
      id: 94064,
      question: "What is the primary responsibility of the dental hygienist regarding patients with untreated periapical abscesses?",
      options: [
        "To perform the root canal treatment if the dentist is unavailable",
        "To extract the tooth to prevent life-threatening spread of infection",
        "To prescribe antibiotics and schedule a surgical consultation immediately",
        "To inform patients of the risks of delaying treatment and monitor for complications"
      ],
      correctAnswer: 3
    },
    {
      id: 94065,
      question: "Which of the following is a key objective finding assessed during the endodontic objective examination?",
      options: [
        "The patient's description of pain character and duration",
        "The patient's self-reported sensitivity to hot and cold beverages",
        "The patient's report of recent dental trauma or restorative work",
        "Tooth mobility, swelling, and pulp exposure"
      ],
      correctAnswer: 3
    },
    {
      id: 94066,
      question: "Which component of the endodontic subjective examination involves the patient's description of their main concern?",
      options: [
        "Chief complaint reported by the patient",
        "Radiographic findings noted at the apex",
        "Mobility test results recorded by the clinician",
        "Percussion sensitivity recorded with a mirror handle"
      ],
      correctAnswer: 0
    },
    {
      id: 94067,
      question: "The dental pulp provides nourishment, sensation, and protection through the formation of reparative dentin throughout the life of the tooth.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 94068,
      question: "General dentists are NOT permitted to perform endodontic treatment; it must always be referred to a specialist endodontist.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 94069,
      question: "A necrotic (nonvital) tooth that has lost its pulp vitality is no longer attached to the alveolus and will spontaneously exfoliate.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 94070,
      question: "Periapical abscesses are among the most common dental emergencies and can also be referred to as apical periodontitis or endodontic abscesses.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 94071,
      question: "Rubber dams are optional during root canal procedures and are only used when the dentist prefers isolation.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 94072,
      question: "The endodontic spreader is used to condense gutta-percha into the canal during obturation.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 94073,
      question: "Sodium hypochlorite is diluted with sterile water and has both antimicrobial and solvent action on necrotic pulp tissue during root canal irrigation.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 94074,
      question: "Root amputation is most commonly performed on mandibular molars, while hemisection is most often performed on maxillary molars.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 94075,
      question: "An untreated periapical abscess can lead to life-threatening conditions such as brain abscess or fasciitis of the neck or chest wall.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 94076,
      question: "Cavit cement is the most common temporary restorative material placed into an endodontic access opening between appointments.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
  ],
  "4. Oral and Maxillofacial Surgery": [
    {
      id: 95001,
      question: "Which branch of dentistry addresses the diagnosis and treatment of defects, injuries, and diseases involving the head, mouth, teeth, gums, jaws, and neck?",
      options: [
        "Oral and maxillofacial surgery",
        "Prosthodontics",
        "Orthodontics",
        "Periodontics"
      ],
      correctAnswer: 0
    },
    {
      id: 95002,
      question: "Which of the following is classified as a dentoalveolar surgery referral indication?",
      options: [
        "Salivary gland obstruction",
        "Alveoloplasty",
        "Facial aesthetic surgery",
        "Prognathism correction"
      ],
      correctAnswer: 1
    },
    {
      id: 95003,
      question: "What is orthognathic surgery primarily designed to accomplish?",
      options: [
        "Perform biopsy procedures on suspicious oral lesions",
        "Remove impacted wisdom teeth and provide socket irrigation",
        "Restore facial aesthetics and proper function by manipulating the facial skeleton",
        "Drain periodontal abscesses and treat cellulitis infections"
      ],
      correctAnswer: 2
    },
    {
      id: 95004,
      question: "How many years of postgraduate hospital residency training does an oral surgeon complete?",
      options: [
        "1–2 years",
        "2–3 years",
        "3–4 years",
        "4–6 years"
      ],
      correctAnswer: 3
    },
    {
      id: 95005,
      question: "Which of the following professionals is part of the oral surgeon's team?",
      options: [
        "Surgical assistants, anesthetists, registered nurses, and dental hygienists",
        "Optometrists and physical therapists",
        "Medical laboratory technicians and dietitians",
        "Pharmacist and radiologist"
      ],
      correctAnswer: 0
    },
    {
      id: 95006,
      question: "Which of the following procedures falls within the scope of periodontal surgery?",
      options: [
        "Cleft lip repair and bone grafting procedures",
        "Pocket elimination, gingivoplasty, and treatment of furcation involvements",
        "Fracture repair of the mandible and maxilla",
        "Orthognathic correction and salivary gland removal"
      ],
      correctAnswer: 1
    },
    {
      id: 95007,
      question: "In which two settings does the surgical team typically complete oral surgical procedures?",
      options: [
        "Mobile dental unit and community health centre",
        "Emergency room and rehabilitation centre",
        "The private dental office and the hospital or outpatient surgical suite",
        "Public health clinic and university dental school"
      ],
      correctAnswer: 2
    },
    {
      id: 95008,
      question: "What is an arthrotomy?",
      options: [
        "Biopsy technique that scrapes cells from a lesion surface",
        "Surgical recontouring of the alveolar ridge after extractions",
        "Removal of a cyst around an unerupted tooth crown",
        "Incision made directly into a joint"
      ],
      correctAnswer: 3
    },
    {
      id: 95009,
      question: "What type of biopsy involves removing a wedge-shaped section of affected tissue along with some normal adjacent tissue?",
      options: [
        "Incision biopsy",
        "Aspiration biopsy",
        "Exfoliative biopsy",
        "Excision biopsy"
      ],
      correctAnswer: 0
    },
    {
      id: 95010,
      question: "What type of biopsy removes the entire lesion along with some underlying normal tissue?",
      options: [
        "Aspiration biopsy",
        "Excision biopsy",
        "Exfoliative biopsy",
        "Incision biopsy"
      ],
      correctAnswer: 1
    },
    {
      id: 95011,
      question: "Which biopsy technique involves scraping a layer of cells from the surface of a lesion?",
      options: [
        "Incision biopsy",
        "Excision biopsy",
        "Exfoliative biopsy",
        "Core needle biopsy"
      ],
      correctAnswer: 2
    },
    {
      id: 95012,
      question: "Which of the following best describes the exfoliative biopsy technique?",
      options: [
        "A fine needle aspirates fluid from a cystic lesion under local anesthetic",
        "The entire lesion is excised with a margin of normal surrounding tissue",
        "A scalpel removes a full wedge of tissue including underlying bone",
        "A sterile flat-ended brush gathers surface cells for microscopic or computer-assisted analysis"
      ],
      correctAnswer: 3
    },
    {
      id: 95013,
      question: "Which of the following tumors is classified as a benign tumor composed of fibrous or connective tissue?",
      options: [
        "Fibroma",
        "Melanoma",
        "Hemangioma",
        "Granuloma"
      ],
      correctAnswer: 0
    },
    {
      id: 95014,
      question: "Which oral tumor is described as a benign self-involuting tumor of endothelial cells that line blood vessels?",
      options: [
        "Papilloma",
        "Hemangioma",
        "Fibroma",
        "Granuloma"
      ],
      correctAnswer: 1
    },
    {
      id: 95015,
      question: "Which type of cyst forms around the crown of an unerupted tooth and is also called a follicular cyst?",
      options: [
        "Mucocele",
        "Ranula",
        "Dentigerous cyst",
        "Radicular cyst"
      ],
      correctAnswer: 2
    },
    {
      id: 95016,
      question: "Which cyst is described as a mucocele-like lesion on the floor of the mouth, typically unilateral, and often found in major salivary ducts?",
      options: [
        "Radicular cyst",
        "Dentigerous cyst",
        "Mucocele",
        "Ranula"
      ],
      correctAnswer: 3
    },
    {
      id: 95017,
      question: "What is the primary difference between a mucocele and a ranula?",
      options: [
        "A mucocele blocks minor salivary ducts while a ranula occurs in major salivary ducts on the floor of the mouth",
        "A mucocele is found in the palate while a ranula occurs in the cheek",
        "A mucocele requires surgery while a ranula resolves without treatment",
        "A mucocele is malignant while a ranula is benign"
      ],
      correctAnswer: 0
    },
    {
      id: 95018,
      question: "Which surgical procedure corrects diastema by addressing the maxillary or mandibular labial frenum?",
      options: [
        "Alveoloplasty",
        "Frenectomy",
        "Gingivectomy",
        "Gingivoplasty"
      ],
      correctAnswer: 1
    },
    {
      id: 95019,
      question: "What is the purpose of a gingivectomy?",
      options: [
        "Surgical recontouring of gingival tissues for aesthetic purposes",
        "Placement of titanium posts in the alveolar bone for prosthetic support",
        "Surgical excision of unattached, diseased gum tissue",
        "Smoothing and reshaping irregular alveolar bone after extraction"
      ],
      correctAnswer: 2
    },
    {
      id: 95020,
      question: "What distinguishes gingivoplasty from gingivectomy?",
      options: [
        "Gingivoplasty is performed in the hospital while gingivectomy is done in the dental office",
        "Gingivectomy uses sutures while gingivoplasty does not require suture placement",
        "Gingivoplasty removes diseased tissue while gingivectomy is aesthetic",
        "Gingivectomy removes unattached diseased tissue while gingivoplasty surgically recontours tissue for aesthetic purposes"
      ],
      correctAnswer: 3
    },
    {
      id: 95021,
      question: "What is the purpose of periodontal flap surgery?",
      options: [
        "Retract a section of periodontal tissue to access root and bone for curettage and recontouring",
        "Remove cysts and benign tumors from the oral cavity",
        "Extract impacted teeth with minimal trauma to surrounding bone",
        "Place dental implants directly into the alveolar bone"
      ],
      correctAnswer: 0
    },
    {
      id: 95022,
      question: "What material is used in implantology for the posts placed in the alveolar bone?",
      options: [
        "Stainless steel",
        "Titanium",
        "Cobalt chromium alloy",
        "Zirconia ceramic"
      ],
      correctAnswer: 1
    },
    {
      id: 95023,
      question: "Which teeth are most commonly referred for complex extractions due to impaction?",
      options: [
        "Maxillary central incisors",
        "Mandibular premolars",
        "Impacted teeth, endodontically treated teeth, and root tips",
        "Deciduous canines and first molars"
      ],
      correctAnswer: 2
    },
    {
      id: 95024,
      question: "What is the primary difference between a soft tissue impaction and a hard tissue impaction?",
      options: [
        "Hard tissue impaction always requires general anesthesia while soft tissue impaction uses local",
        "Soft tissue impaction requires a rongeur while hard tissue impaction uses only a forceps",
        "Soft tissue impaction causes more pain while hard tissue impaction is asymptomatic",
        "Soft tissue impaction is under gingival tissue only while hard tissue impaction is partially or totally covered by tissue and bone"
      ],
      correctAnswer: 3
    },
    {
      id: 95025,
      question: "What does alveolectomy involve?",
      options: [
        "Removal of alveolar bone crests after tooth extraction",
        "Placement of bone grafts to support a future prosthesis",
        "Smoothing of bone using a file in a push-pull motion",
        "Surgical recontouring and shaping of irregular bone remnants after surgery"
      ],
      correctAnswer: 0
    },
    {
      id: 95026,
      question: "What is alveoplasty?",
      options: [
        "Extraction of multiple teeth in preparation for a denture",
        "Surgical recontouring and shaping of irregular bone remnants after a surgical procedure",
        "Placement of absorbable collagen dressings over extraction sockets",
        "Removal of alveolar bone crests immediately following extraction"
      ],
      correctAnswer: 1
    },
    {
      id: 95027,
      question: "Which of the following is one reason the dental hygienist reduces oral bacterial count before oral surgery?",
      options: [
        "To eliminate the need for prophylactic antibiotics in all patients",
        "To reduce the cost of postoperative medications for the patient",
        "To aid in preparation of an aseptic surgical field and reduce postoperative infection",
        "To allow the patient to avoid using a mouthrinse after surgery"
      ],
      correctAnswer: 2
    },
    {
      id: 95028,
      question: "Why is it important to remove calculus deposits before oral surgery?",
      options: [
        "Calculus removal reduces the need for general anesthesia during the procedure",
        "Calculus removal helps the surgeon determine the correct incision location",
        "Calculus removal prevents the need for suture placement after the procedure",
        "Calculus removal prevents pieces from breaking away and potentially being inhaled or acting as a foreign body in the surgical site"
      ],
      correctAnswer: 3
    },
    {
      id: 95029,
      question: "Which of the following is an essential nutrient for promoting wound healing after oral surgery?",
      options: [
        "Protein, vitamin A, vitamin C, and riboflavin",
        "Calcium, phosphorus, and magnesium",
        "Sodium and potassium",
        "Unsaturated fat and simple carbohydrates"
      ],
      correctAnswer: 0
    },
    {
      id: 95030,
      question: "Which presurgical instruction covers what the patient should know regarding anesthesia administration?",
      options: [
        "Oral hygiene methods to reduce postoperative infection risk",
        "Food and liquid intake restrictions, alcohol and medication restrictions, and transportation requirements",
        "Instructions for choosing proper dental floss for postsurgical care",
        "Details of dietary supplements to take for one week before surgery"
      ],
      correctAnswer: 1
    },
    {
      id: 95031,
      question: "According to postsurgical immediate care instructions, how long should a patient bite on gauze to control bleeding?",
      options: [
        "10 minutes, then replace",
        "20 minutes, then replace if needed",
        "30 minutes, then discard",
        "45 minutes, then switch to a cold wet tea bag"
      ],
      correctAnswer: 2
    },
    {
      id: 95032,
      question: "How long should a patient wait before rinsing after oral surgery?",
      options: [
        "48 hours",
        "12 hours",
        "6 hours",
        "24 hours"
      ],
      correctAnswer: 3
    },
    {
      id: 95033,
      question: "What type of rinse is recommended after the first 24 hours post-surgery?",
      options: [
        "Warm salt water (1/2 tsp salt in 1/2 cup warm water)",
        "Sodium bicarbonate rinse twice daily",
        "Undiluted chlorhexidine gluconate",
        "Hydrogen peroxide diluted with water"
      ],
      correctAnswer: 0
    },
    {
      id: 95034,
      question: "Which of the following is a listed complication that may occur after oral surgery?",
      options: [
        "Jaw joint inflammation and parotid swelling",
        "Uncontrolled bleeding, trismus, dry socket, or nerve damage",
        "Periodontal pocket deepening and calculus reformation",
        "Tooth sensitivity and gingival recession"
      ],
      correctAnswer: 1
    },
    {
      id: 95035,
      question: "What temperature reading after surgery would be considered a complication requiring attention?",
      options: [
        "99.5°F or higher",
        "100°F or higher",
        "101°F or higher",
        "98.6°F or higher"
      ],
      correctAnswer: 2
    },
    {
      id: 95036,
      question: "How should an ice pack be applied during the first 36 hours post-surgery to reduce swelling?",
      options: [
        "30 minutes on, then 30 minutes off throughout the day",
        "Applied only at night during sleep for maximum effect",
        "Continuously for 4 hours then removed for 2 hours",
        "15 minutes on, then 15 minutes off, as directed by the oral surgeon"
      ],
      correctAnswer: 3
    },
    {
      id: 95037,
      question: "What is a suture?",
      options: [
        "A strand of material used to control bleeding, stabilize wound edges, protect the wound, and aid in patient comfort",
        "A type of periodontal dressing placed to prevent biofilm accumulation on the wound",
        "A rigid splint used to hold fractured jaw bones in alignment",
        "A liquid antiseptic material used to disinfect the surgical wound after closure"
      ],
      correctAnswer: 0
    },
    {
      id: 95038,
      question: "Which of the following is listed as a function of sutures?",
      options: [
        "Provide anesthetic effect to reduce intraoperative pain",
        "Promote primary intention healing and prevent underlying bone exposure",
        "Chemically dissolve necrotic tissue and biofilm",
        "Sterilize the surgical wound and eliminate bacteria"
      ],
      correctAnswer: 1
    },
    {
      id: 95039,
      question: "Which of the following is a biologic characteristic of ideal suture material?",
      options: [
        "Bright colour to allow easy identification during removal",
        "Fluorescence under UV light for easy visibility",
        "Sterility, reabsorption ability, and creating minimal inflammatory reaction",
        "Metallic composition for maximum tensile strength"
      ],
      correctAnswer: 2
    },
    {
      id: 95040,
      question: "Which of the following is a physical characteristic of suture material?",
      options: [
        "Bacterial colonization and hydrolysis resistance",
        "Biocompatibility and allergenicity",
        "Absorption rate and enzyme resistance",
        "Tensile strength, flexibility, plasticity, and elasticity"
      ],
      correctAnswer: 3
    },
    {
      id: 95041,
      question: "Natural absorbable sutures are digested by which mechanism?",
      options: [
        "Body enzymes digest the suture material over time",
        "Mechanical friction from normal oral movement degrades the material",
        "Hydrolysis, where water slowly penetrates the suture filaments",
        "Ultraviolet light exposure breaks down the suture polymer chain"
      ],
      correctAnswer: 0
    },
    {
      id: 95042,
      question: "How long does plain gut suture last before beginning to degrade?",
      options: [
        "3–4 days",
        "About 8 days",
        "About 18 days",
        "25–30 days"
      ],
      correctAnswer: 1
    },
    {
      id: 95043,
      question: "How does chromic gut differ from plain gut suture?",
      options: [
        "Chromic gut is made from synthetic polymer while plain gut is natural",
        "Chromic gut is nonabsorbable and must be removed by the clinician",
        "Chromic gut contains chromostatic salts that delay enzyme resorption, lasting approximately 18 days",
        "Chromic gut is multifilament while plain gut is always monofilament"
      ],
      correctAnswer: 2
    },
    {
      id: 95044,
      question: "Synthetic absorbable sutures are broken down by which process?",
      options: [
        "Thermal decomposition from body heat",
        "Oxidation by oral bacteria at the suture site",
        "Enzymatic digestion",
        "Hydrolysis, where water slowly penetrates the suture filaments and breaks down the polymer chain"
      ],
      correctAnswer: 3
    },
    {
      id: 95045,
      question: "Which of the following is an example of a synthetic absorbable suture?",
      options: [
        "Polyglactin (Vicryl) and poliglecaprone (Monocryl)",
        "Polyester (Ethibond) and polypropylene (Prolene)",
        "Silk and nylon",
        "Cotton and linen"
      ],
      correctAnswer: 0
    },
    {
      id: 95046,
      question: "When are nonabsorbable sutures typically removed?",
      options: [
        "At 3–4 days post-surgery",
        "At 5–7 days post-surgery for routine, or approximately 1 week after placement",
        "At 10–14 days post-surgery",
        "They dissolve on their own and are never removed"
      ],
      correctAnswer: 1
    },
    {
      id: 95047,
      question: "Which nonabsorbable suture material has demonstrated the lowest bacterial accumulation?",
      options: [
        "Polyester",
        "Polypropylene",
        "Nylon",
        "Silk"
      ],
      correctAnswer: 2
    },
    {
      id: 95048,
      question: "What is a monofilament suture?",
      options: [
        "A suture that absorbs within 8 days via enzymatic digestion",
        "A suture consisting of several strands twisted or braided together",
        "A suture coated with antibacterial chlorhexidine for infection prevention",
        "A suture made from a single strand of material"
      ],
      correctAnswer: 3
    },
    {
      id: 95049,
      question: "What is a multifilament suture?",
      options: [
        "A suture consisting of several strands that are twisted or braided together",
        "A suture that is coated to reduce inflammation at the surgical site",
        "A suture with a larger diameter used only for bone-level procedures",
        "A suture made of a single synthetic polymer strand"
      ],
      correctAnswer: 0
    },
    {
      id: 95050,
      question: "In suture sizing, what does a greater number of zeros indicate?",
      options: [
        "A longer and more flexible suture material",
        "A thinner suture with a finer diameter",
        "A nonabsorbable suture material classification",
        "A thicker and stronger suture diameter"
      ],
      correctAnswer: 1
    },
    {
      id: 95051,
      question: "What is the swaged end of a suture needle?",
      options: [
        "The sharpest point that penetrates tissue first",
        "The widest part of the body grasped by the needle holder",
        "The end that allows suture material and needle to act as one unit",
        "The reverse-cut portion that reduces trauma to tissue"
      ],
      correctAnswer: 2
    },
    {
      id: 95052,
      question: "Which part of the suture needle is considered the strongest?",
      options: [
        "The cutting edge",
        "The swaged end",
        "The needle tip",
        "The body"
      ],
      correctAnswer: 3
    },
    {
      id: 95053,
      question: "What is the difference between a reverse cut and a conventional cut needle?",
      options: [
        "Reverse cut needles have a third cutting edge on the outer convex curve while conventional cut needles have the third edge on the inner concave curvature",
        "Reverse cut needles are for absorbable sutures while conventional cut needles are for nonabsorbable sutures",
        "Reverse cut needles are single-use while conventional cut needles can be resterilized",
        "Reverse cut needles are straight while conventional cut needles are curved"
      ],
      correctAnswer: 0
    },
    {
      id: 95054,
      question: "Which type of knot is most frequently used in dentistry?",
      options: [
        "Slip knot",
        "Square knot",
        "Half-hitch knot",
        "Surgeon's knot"
      ],
      correctAnswer: 1
    },
    {
      id: 95055,
      question: "Why is the suture knot tied on the facial aspect?",
      options: [
        "Regulations require all knots to face outward from the tongue",
        "The facial aspect provides more tissue thickness for secure knot placement",
        "Facial placement allows easier access for removal",
        "The lingual side has more bacteria and increases infection risk"
      ],
      correctAnswer: 2
    },
    {
      id: 95056,
      question: "How long of a suture tail is typically left to assist in locating the suture for removal?",
      options: [
        "4–5 mm",
        "0.5–1 mm",
        "1–1.5 mm",
        "2–3 mm"
      ],
      correctAnswer: 3
    },
    {
      id: 95057,
      question: "Which of the following items is required for suture removal?",
      options: [
        "Curved sharp scissors with pointed tip, cotton pliers, and topical anesthetic",
        "Wax spatula, curing light, and cotton rolls",
        "Periodontal probe and dental explorer",
        "Ultrasonic scaler and air polisher"
      ],
      correctAnswer: 0
    },
    {
      id: 95058,
      question: "Why must patients with valvular heart disease be evaluated before suture removal?",
      options: [
        "Suture removal requires general anesthesia in cardiac patients",
        "Suture removal can cause bacteremia, so patients at high risk for infective endocarditis require prophylactic antibiotic coverage",
        "Valvular heart disease patients must have sutures removed only in a hospital setting",
        "Cardiac medications may interfere with the topical anesthetic used during suture removal"
      ],
      correctAnswer: 1
    },
    {
      id: 95059,
      question: "During suture removal, how should the suture be cut?",
      options: [
        "At the knot, pulling both ends upward simultaneously",
        "As far from the tissue as possible to reduce pulling sensation",
        "As close as possible to the tissue, cutting the part previously buried in tissue",
        "Through the middle of the strand with one smooth cut"
      ],
      correctAnswer: 2
    },
    {
      id: 95060,
      question: "What must the clinician verify when removing sutures?",
      options: [
        "The suture material type to determine if it was absorbable or nonabsorbable",
        "The wound has been completely re-epithelialized before any suture is removed",
        "The patient's blood pressure before and after the procedure",
        "The number of sutures removed corresponds with the number of sutures placed"
      ],
      correctAnswer: 3
    },
    {
      id: 95061,
      question: "Which of the following is recorded in the progress notes after suture removal?",
      options: [
        "Number of sutures removed, location, tissue condition, and instructions given to the patient",
        "Suture material brand, lot number, and expiration date",
        "Anesthetic dosage administered and patient weight",
        "Insurance billing codes and appointment duration"
      ],
      correctAnswer: 0
    },
    {
      id: 95062,
      question: "What does current evidence say about the use of periodontal dressings to prevent wound infection and enhance healing?",
      options: [
        "Strong evidence supports their routine use after all periodontal surgeries",
        "Current evidence does not support the idea that dressings prevent infection or enhance healing; use is based on clinical preference",
        "Recent studies confirm that dressings consistently improve healing compared to no dressing",
        "Evidence supports their use only in anterior esthetic areas of the mouth"
      ],
      correctAnswer: 1
    },
    {
      id: 95063,
      question: "Which of the following is a stated purpose of periodontal dressings?",
      options: [
        "Provide local anesthesia to the surgical area for 48–72 hours",
        "Permanently bond the flap to underlying bone",
        "Provide a physical barrier, reduce pain, help prevent posttreatment bleeding, and support mobile teeth during healing",
        "Replace sutures when wound closure is not needed"
      ],
      correctAnswer: 2
    },
    {
      id: 95064,
      question: "What is a disadvantage of zinc oxide with eugenol periodontal dressings?",
      options: [
        "They require a curing light to achieve proper hardness",
        "They set too quickly, reducing working time",
        "They are not available in premixed formulations",
        "They have a sharp, unpleasant taste and can cause tissue irritation or hypersensitivity reactions"
      ],
      correctAnswer: 3
    },
    {
      id: 95065,
      question: "What are the two pastes in Coe-Pak, the most commonly used chemical-cured periodontal dressing?",
      options: [
        "Base paste with zinc oxide, oils, and gums; catalyst paste with resins, fatty acids, and chlorothymol",
        "Collagen paste and eugenol-free rosin paste",
        "Calcium sulfate paste and sodium bicarbonate gel",
        "Zinc oxide paste and chlorhexidine gel"
      ],
      correctAnswer: 0
    },
    {
      id: 95066,
      question: "What is an advantage of the visible light-cured (VLC) periodontal dressing?",
      options: [
        "It is the most rigid dressing available, providing maximum wound protection",
        "It is more gingiva-coloured than other dressings and is cured in increments with a light curing unit",
        "It is self-setting without any equipment required for placement",
        "It contains eugenol for superior antibacterial activity"
      ],
      correctAnswer: 1
    },
    {
      id: 95067,
      question: "What special use does collagen dressing have in periodontal surgery?",
      options: [
        "It is used to fill extraction sockets and prevent alveolitis formation",
        "It is used exclusively in posterior extraction sites to prevent dry socket",
        "It is used as a patch dressing to protect graft sites of the palate during healing and can be shaped into a bullet for deep biopsy sites",
        "It is applied to surgical incisions as a replacement for sutures in non-load-bearing areas"
      ],
      correctAnswer: 2
    },
    {
      id: 95068,
      question: "What properties make curcumin (turmeric) gel beneficial as a periodontal dressing?",
      options: [
        "Antimicrobial activity from chlorhexidine coating and slow resorption rate",
        "Strong adhesion, rapid setting time, and eugenol-based antibacterial action",
        "Fluoride release, caries prevention, and high tensile strength",
        "Anti-inflammatory and antioxidant properties that reduce inflammation, discomfort, and edema"
      ],
      correctAnswer: 3
    },
    {
      id: 95069,
      question: "How long does epithelium take to begin covering a wound, and when is complete epithelial healing expected?",
      options: [
        "Begins in 5–6 days; complete in 7–14 days",
        "Begins in 7–10 days; complete in 14–21 days",
        "Begins in 1–2 days; complete in 4–5 days",
        "Begins in 2–3 days; complete in 5–7 days"
      ],
      correctAnswer: 0
    },
    {
      id: 95070,
      question: "How long may a periodontal dressing remain in place before removal?",
      options: [
        "5–7 days as determined by the surgeon",
        "7–10 days as determined by the surgeon",
        "10–14 days as determined by the surgeon",
        "3–5 days as determined by the surgeon"
      ],
      correctAnswer: 1
    },
    {
      id: 95071,
      question: "What should be done if a dressing remains intact for 4–5 days before the removal appointment?",
      options: [
        "A second layer of dressing is applied directly over the first",
        "Replacement is always required regardless of how long the dressing remained intact",
        "Replacement may not be necessary if the dressing stayed in place for 4–5 days",
        "The patient must return immediately for evaluation and replacement"
      ],
      correctAnswer: 2
    },
    {
      id: 95072,
      question: "Which oral hygiene agent is recommended during the healing period after periodontal dressing placement?",
      options: [
        "Diluted povidone-iodine rinse applied after every meal",
        "Stannous fluoride rinse applied three times daily",
        "Warm salt water rinse and hydrogen peroxide gel",
        "0.12% chlorhexidine gluconate twice daily, gently forced between the teeth"
      ],
      correctAnswer: 3
    },
    {
      id: 95073,
      question: "What is the function of an elevator in oral surgery?",
      options: [
        "Reflect, retract, or loosen gingival and periodontal fibres around a tooth prior to extraction",
        "Grasp and transfer soft tissue and bone fragments during procedures",
        "Smooth the bone surface using a push-pull motion after rongeur use",
        "Contour and shape the alveolar bone after extractions"
      ],
      correctAnswer: 0
    },
    {
      id: 95074,
      question: "What is the purpose of a surgical curette?",
      options: [
        "Make precise incisions into soft tissue with minimal trauma",
        "Scrape the interior of the socket to remove diseased tissue after extractions",
        "Grasp suture needles firmly during wound closure",
        "Trim irregular alveolar bone after multiple extractions"
      ],
      correctAnswer: 1
    },
    {
      id: 95075,
      question: "What does a rongeur instrument resemble in design?",
      options: [
        "A large spoon excavator with sharp, scooped edges",
        "A pair of scissors with curved blades and offset handles",
        "A fingernail clipper with a spring between the handles and sharp cutting blades",
        "A needle holder with a serrated locking beak"
      ],
      correctAnswer: 2
    },
    {
      id: 95076,
      question: "What is the primary use of a bone file in oral surgery?",
      options: [
        "Retract the periosteum away from the bone surface during flap procedures",
        "Apply lateral pressure to loosen the tooth from the periodontal ligament",
        "Remove large sections of alveolar bone crests after multiple extractions",
        "Smooth the bone surface with a push-pull motion after the rongeur has removed most undesirable bone"
      ],
      correctAnswer: 3
    },
    {
      id: 95077,
      question: "What is the function of a periosteal elevator?",
      options: [
        "Retract and separate the periosteum from the surface of the bone",
        "Remove root tips and root fragments from the socket",
        "Apply leverage to loosen a tooth from the periodontal ligament",
        "Smooth sharp bone projections after extraction using a push-pull motion"
      ],
      correctAnswer: 0
    },
    {
      id: 95078,
      question: "What is the purpose of a straight elevator?",
      options: [
        "Contour the alveolar ridge after a multiple extraction procedure",
        "Apply leverage against the tooth to loosen it from the periodontal ligament and ease extraction",
        "Retract and hold gingival tissue away from the surgical field",
        "Transport suture material through tissues with minimal trauma"
      ],
      correctAnswer: 1
    },
    {
      id: 95079,
      question: "What is the function of a hemostat in oral surgery?",
      options: [
        "Cut suture material close to the tissue during suture removal",
        "Make precise incisions into soft tissue with controlled depth",
        "Grasp, clamp, or transfer soft tissue, bone, tooth fragments, and other instruments",
        "Smooth bone surfaces after the rongeur has removed most undesirable bone"
      ],
      correctAnswer: 2
    },
    {
      id: 95080,
      question: "How should a used scalpel blade be disposed of after an oral surgical procedure?",
      options: [
        "Wiped with gauze and placed in a labeled biohazard bag",
        "Placed in a regular waste container after recapping",
        "Returned to the sterile packaging for reprocessing",
        "Disposed of using a mechanical scalpel blade remover and placed in a sharps container"
      ],
      correctAnswer: 3
    },
    {
      id: 95081,
      question: "What is the purpose of a needle holder in oral surgery?",
      options: [
        "Firmly grasp a suture needle during suturing of soft tissue intraorally",
        "Retract periosteum from the surface of the bone during flap procedures",
        "Transfer instruments to the surgeon with the beak pointing upward",
        "Cut suture material at the tissue surface after wound healing"
      ],
      correctAnswer: 0
    },
    {
      id: 95082,
      question: "What is the purpose of suture scissors in oral surgery?",
      options: [
        "Trim excess soft tissue during flap procedures",
        "Cut suture material only, with a notch to prevent trauma to soft tissue",
        "Divide bone using a sharp cutting edge during osteotomy procedures",
        "Remove calculus and debris from the root surface post-extraction"
      ],
      correctAnswer: 1
    },
    {
      id: 95083,
      question: "What is the purpose of a mouth prop (bite-block) in oral surgery?",
      options: [
        "Provide retraction of the cheek and tongue during procedures",
        "Support mobile teeth during the healing period after surgery",
        "Allow the patient to rest and relax jaw muscles; prevent involuntary mouth closure during sedation",
        "Hold the surgical flap open during access to underlying bone"
      ],
      correctAnswer: 2
    },
    {
      id: 95084,
      question: "What are the two bevel designs for a chisel used in oral surgery?",
      options: [
        "Convex bevel and concave bevel",
        "Cutting bevel and smoothing bevel",
        "Reverse bevel and conventional bevel",
        "Single bevel for removing bone and bi-bevel for splitting teeth"
      ],
      correctAnswer: 3
    },
    {
      id: 95085,
      question: "What is the role of a mallet in oral surgery?",
      options: [
        "Provide a source of pressure when used on the chisel handle",
        "Elevate and separate the periosteum from the underlying bone",
        "Trim and contour the alveolar bone after multiple extractions",
        "Compress the periodontal dressing into the interdental spaces"
      ],
      correctAnswer: 0
    },
    {
      id: 95086,
      question: "How are surgical burs disposed of after use?",
      options: [
        "Rinsed under running water and returned to the bur block",
        "Disposed of in the sharps container after each use",
        "Placed in a disinfectant solution for 30 minutes then reused",
        "Autoclaved and stored in a sterile pouch for reuse"
      ],
      correctAnswer: 1
    },
    {
      id: 95087,
      question: "What condition increases a woman's susceptibility to developing alveolitis (dry socket)?",
      options: [
        "Thyroid disorder and vitamin D deficiency",
        "Diabetes mellitus and poor immune function",
        "Hormonal contraceptive use (oral contraceptives)",
        "A history of periodontal disease and bone loss"
      ],
      correctAnswer: 2
    },
    {
      id: 95088,
      question: "Which of the following actions within the first 24 hours after extraction can contribute to the development of dry socket?",
      options: [
        "Using prescribed analgesics and sleeping with head elevated",
        "Eating soft foods and drinking warm soup",
        "Applying an ice pack for 15 minutes on and 15 minutes off",
        "Smoking, sneezing, spitting, coughing, or drinking from a straw"
      ],
      correctAnswer: 3
    },
    {
      id: 95089,
      question: "What is the initial treatment for dry socket (alveolitis)?",
      options: [
        "Recommendation of a nonsteroidal anti-inflammatory drug, followed by socket cleaning and medicated dressing if pain persists",
        "Application of a zinc oxide eugenol dressing without socket irrigation",
        "Immediate re-extraction to allow proper socket healing",
        "Antibiotic therapy combined with antifungal oral rinses"
      ],
      correctAnswer: 0
    },
    {
      id: 95090,
      question: "Which postoperative swelling control measure is appropriate after the first 24 hours?",
      options: [
        "Continue applying ice packs in a 20-minute on/off cycle",
        "Apply external heat to increase circulation in the tissues and promote healing",
        "Begin aggressive rinsing with cold water to reduce swelling",
        "Apply a compression bandage around the jaw for 48 hours"
      ],
      correctAnswer: 1
    },
    {
      id: 95091,
      question: "What dietary guidance is given to patients for the day of oral surgery?",
      options: [
        "Eat only protein-rich solid foods to support tissue healing",
        "Resume a normal diet as soon as the anesthesia wears off",
        "Drink liquids and eat soft nutritious foods, avoiding anything too hot or too cold",
        "Avoid all food and beverages for 24 hours after the procedure"
      ],
      correctAnswer: 2
    },
    {
      id: 95092,
      question: "Which cleft correction procedure may also require bone grafting?",
      options: [
        "Frenectomy for ankyloglossia correction",
        "Dental implant placement",
        "Orthognathic jaw realignment",
        "Cleft lip, palate, and tongue repair, which involves loosen muscles sutured together and may require bone grafting"
      ],
      correctAnswer: 3
    },
    {
      id: 95093,
      question: "Which of the following describes the forceps extraction procedure?",
      options: [
        "Removal of a fully erupted tooth with a solid intact crown, usually without sutures",
        "Extraction of a tooth partially covered by gingival tissue requiring flap elevation",
        "Complex extraction requiring general anesthesia and hospital admission",
        "Surgical removal requiring bone removal and suture placement"
      ],
      correctAnswer: 0
    },
    {
      id: 95094,
      question: "What is the patient characteristic known as \"resigned\" as described in the personal factors section?",
      options: [
        "Discouragement over tooth loss and financial aspects of dental care",
        "A sense that the situation is unavoidable and a lack of appreciation for preserving natural teeth",
        "Apprehension toward the need for personal care and oral hygiene",
        "Fear of personal appearance after surgery and dental procedures"
      ],
      correctAnswer: 1
    },
    {
      id: 95095,
      question: "What type of diet is emphasized for the patient receiving an immediate denture after extraction?",
      options: [
        "A high-fat, low-fibre diet to reduce bowel movement frequency",
        "A high-sugar, soft diet for rapid caloric intake during recovery",
        "A diet containing all essential food groups to provide nutrients for tissue building and repair",
        "A liquid-only diet for the entire recovery period until the denture is adjusted"
      ],
      correctAnswer: 2
    },
    {
      id: 95096,
      question: "Which of the following is an exostosis?",
      options: [
        "An infected abscess requiring incision and drainage",
        "A type of malignant skin tumour associated with excessive sun exposure",
        "A fluid-filled sac lined with epithelium found in the jaw",
        "A benign outgrowth of cartilaginous tissue on a bone that may require surgical excision"
      ],
      correctAnswer: 3
    },
    {
      id: 95097,
      question: "What is the recovery timeline for a patient with intermaxillary fixation (IMF)?",
      options: [
        "Rehabilitation of oral tissues is needed after removal of fixation appliances to prevent permanent tissue damage and inadequate oral self-care habits",
        "The patient must remain on complete rest for 6 weeks following appliance removal",
        "Rehabilitation is not needed since fixation prevents any muscle atrophy",
        "Oral hygiene can resume normally immediately after removal of the fixation appliances"
      ],
      correctAnswer: 0
    },
    {
      id: 95098,
      question: "Oral and maxillofacial surgery addresses only intraoral conditions and does not include the head and neck.",
      options: [
        "True",
        "False",
      ],
      correctAnswer: 1
    },
    {
      id: 95099,
      question: "Exfoliative biopsy is a minimally invasive technique that requires no anesthesia and can definitively distinguish benign from precancerous and cancerous lesions.",
      options: [
        "True",
        "False",
      ],
      correctAnswer: 1
    },
    {
      id: 95100,
      question: "A dentigerous cyst, also called a follicular cyst, forms around the crown of an unerupted tooth.",
      options: [
        "True",
        "False",
      ],
      correctAnswer: 0
    },
    {
      id: 95101,
      question: "Silk sutures are classified as synthetic nonabsorbable sutures.",
      options: [
        "True",
        "False",
      ],
      correctAnswer: 1
    },
    {
      id: 95102,
      question: "The body of the suture needle is considered the weakest part and must be handled carefully during procedures.",
      options: [
        "True",
        "False",
      ],
      correctAnswer: 1
    },
    {
      id: 95103,
      question: "Current evidence supports the routine use of periodontal dressings to prevent wound infection and enhance healing after periodontal surgery.",
      options: [
        "True",
        "False",
      ],
      correctAnswer: 1
    },
    {
      id: 95104,
      question: "Chromic gut suture lasts approximately 18 days before beginning to degrade, due to chromostatic salts that delay enzyme resorption.",
      options: [
        "True",
        "False",
      ],
      correctAnswer: 0
    },
    {
      id: 95105,
      question: "The rongeur is used to finely smooth the surface of the bone in a push-pull motion after most of the undesirable bone has been removed.",
      options: [
        "True",
        "False",
      ],
      correctAnswer: 1
    },
    {
      id: 95106,
      question: "Removing sutures can precipitate bacteremia, and patients at high risk for infective endocarditis require prophylactic antibiotic coverage prior to suture removal.",
      options: [
        "True",
        "False",
      ],
      correctAnswer: 0
    },
    {
      id: 95107,
      question: "Patients should rinse vigorously with warm salt water immediately after surgery to prevent infection and clot disruption.",
      options: [
        "True",
        "False",
      ],
      correctAnswer: 1
    },
    {
      id: 95108,
      question: "Women taking oral contraceptives are more susceptible to developing dry socket (alveolitis) after tooth extraction.",
      options: [
        "True",
        "False",
      ],
      correctAnswer: 0
    },
    {
      id: 95109,
      question: "Nylon sutures have demonstrated the highest bacterial accumulation among nonabsorbable suture materials.",
      options: [
        "True",
        "False",
      ],
      correctAnswer: 1
    }
  ],
  "5. Pediatric Dentistry": [
    {
      id: 96001,
      question: "What is pediatric dentistry defined as?",
      options: [
        "The specialized area of dentistry limited to the care of children from birth through adolescence, with additional focus on patients with special needs",
        "The specialized area of dentistry focused solely on surgical procedures for children under twelve years of age",
        "The branch of dentistry that treats only infants and toddlers up to three years of age",
        "The area of dentistry that manages pain and sedation exclusively for pediatric hospital patients"
      ],
      correctAnswer: 0
    },
    {
      id: 96002,
      question: "How many additional years of education does a pediatric dentist complete after dental school?",
      options: [
        "4 to 5 years",
        "2 to 3 years",
        "5 to 6 years",
        "1 to 2 years"
      ],
      correctAnswer: 1
    },
    {
      id: 96003,
      question: "What is the correct age range for the toddler category of pediatric patients?",
      options: [
        "6 to 11 years of age",
        "0 to 1 years of age",
        "1 to 3 years of age",
        "3 to 5 years of age"
      ],
      correctAnswer: 2
    },
    {
      id: 96004,
      question: "Which age group is classified as school-aged children (middle childhood)?",
      options: [
        "3 to 5 years of age",
        "1 to 3 years of age",
        "12 to 17 years of age",
        "6 to 11 years of age"
      ],
      correctAnswer: 3
    },
    {
      id: 96005,
      question: "By what age should a dental home be established for a child?",
      options: [
        "No later than 12 months of age",
        "No later than 24 months of age",
        "No later than 6 months of age",
        "No later than 18 months of age"
      ],
      correctAnswer: 0
    },
    {
      id: 96006,
      question: "What is a \"dental home\" defined as?",
      options: [
        "A pediatric dental clinic located near a child's school or daycare center",
        "An ongoing relationship between the dentist and the patient delivered in a comprehensive, continuously accessible, coordinated, and family-centered way",
        "A home visit program where a dental hygienist checks children's teeth in a family setting",
        "A community health centre that provides free dental care to children under five years of age"
      ],
      correctAnswer: 1
    },
    {
      id: 96007,
      question: "What proportion of toddlers already have one or more cavities?",
      options: [
        "1 in 20 toddlers",
        "1 in 5 toddlers",
        "1 in 10 toddlers",
        "1 in 3 toddlers"
      ],
      correctAnswer: 2
    },
    {
      id: 96008,
      question: "What does \"chronologic age\" refer to when understanding a pediatric patient?",
      options: [
        "The expected developmental stage based on standardized growth norms",
        "The child's level of intellectual capacity and overall developmental milestone achievement",
        "The child's level of emotional maturity as observed during dental appointments",
        "The child's age as determined by date of birth and the calendar"
      ],
      correctAnswer: 3
    },
    {
      id: 96009,
      question: "What does \"mental age\" refer to in the context of the pediatric patient?",
      options: [
        "The child's level of intellectual capacity and development",
        "The child's emotional response to stress and dental procedures",
        "The child's level of behavioral maturity during school activities",
        "The child's age as determined by date of birth or calendar"
      ],
      correctAnswer: 0
    },
    {
      id: 96010,
      question: "Why might a child temporarily behave in a more immature way during a dental appointment?",
      options: [
        "Dental offices use sedation routinely, which may affect a child's behavior",
        "Children under stress may temporarily regress to a more immature level of behavior",
        "Younger children tend to mimic the anxious behavior of older siblings in the waiting room",
        "Children are often sleepy at appointment times and struggle to communicate clearly"
      ],
      correctAnswer: 1
    },
    {
      id: 96011,
      question: "Which of the following is a responsibility of the dental hygienist in pediatric care?",
      options: [
        "Prescribing antibiotics and sedatives for anxious children before appointments",
        "Diagnosing orthodontic conditions and creating treatment plans for malocclusions",
        "Risk assessment, radiographic exposure, salivary testing, varnish and sealant application, and patient/parent education",
        "Performing pulpotomies and placing stainless steel crowns on primary teeth"
      ],
      correctAnswer: 2
    },
    {
      id: 96012,
      question: "What should parents avoid saying when preparing a child for a dental visit?",
      options: [
        "Information about the dental hygienist's name or role",
        "Any reference to the length of the appointment or procedures planned",
        "Words explaining what instruments look like or how they are used",
        "Negative words such as \"hurt,\" \"pain,\" or \"do not be scared\""
      ],
      correctAnswer: 3
    },
    {
      id: 96013,
      question: "When should the first dental hygiene/dental visit take place?",
      options: [
        "At 6 months of age or after the eruption of the first primary tooth, and by no later than age one",
        "At 2 years of age, when regular exams traditionally begin for most children",
        "At 18 months of age, once the child is cooperative enough for a clinical examination",
        "At 12 months or after the eruption of the second primary tooth"
      ],
      correctAnswer: 0
    },
    {
      id: 96014,
      question: "At what age do regular dental examinations typically begin?",
      options: [
        "Age 3",
        "Age 2",
        "Age 4",
        "Age 1"
      ],
      correctAnswer: 1
    },
    {
      id: 96015,
      question: "What is required before any dental care is provided to a person under 18 years of age?",
      options: [
        "Approval from the school's public health nurse or dental coordinator",
        "Written consent from the child's primary care physician",
        "Parental consent must be given before any treatment begins",
        "A completed medical history form signed by both parents or guardians"
      ],
      correctAnswer: 2
    },
    {
      id: 96016,
      question: "What is the recommended positioning for an infant oral examination?",
      options: [
        "The infant is held upright by the parent while the clinician examines the oral cavity",
        "The infant is placed in a standard dental chair with a small pillow for head support",
        "The infant lies on the floor on a blanket with the parent kneeling nearby",
        "Knee-to-knee positioning, with the child's head on the clinician's lap"
      ],
      correctAnswer: 3
    },
    {
      id: 96017,
      question: "What should the clinician examine for during the infant oral examination?",
      options: [
        "Biofilm, discolouration, malformations, and caries, as well as evidence of abuse",
        "Tongue posture, lip seal, and the nasal airway for signs of mouth breathing",
        "Only the gingival tissue health and the eruption sequence of primary incisors",
        "Only the presence of erupted primary teeth and spacing between them"
      ],
      correctAnswer: 0
    },
    {
      id: 96018,
      question: "How frequently should dental hygiene visits occur for children with little or no oral disease?",
      options: [
        "Every 12 months",
        "Every 4 to 6 months",
        "Every 2 years",
        "Every 3 months"
      ],
      correctAnswer: 1
    },
    {
      id: 96019,
      question: "What is the best time to schedule dental appointments for toddlers and young school-aged children?",
      options: [
        "Late afternoon when children have finished school and are ready for activities",
        "Midday, after lunch, when the child has energy from a meal",
        "Early morning when well-rested, or after naps when not tired and more cooperative",
        "During school hours when the child is in a structured and cooperative mindset"
      ],
      correctAnswer: 2
    },
    {
      id: 96020,
      question: "Which of Erikson's stages of development involves learning basic trust during infancy?",
      options: [
        "Play age, where the child follows simple instructions and takes an active role in treatment",
        "School age, where the child learns social rules and begins overcoming fears",
        "Adolescence, where the young person acquires self-certainty and experiments with roles",
        "Infancy through the first year of life, where the well-nurtured child develops trust and optimism"
      ],
      correctAnswer: 3
    },
    {
      id: 96021,
      question: "What does \"learning autonomy\" refer to in Erikson's developmental stages?",
      options: [
        "The childhood process of becoming independent, occurring during the toddler years",
        "The school-age process of learning social rules and overcoming fears of objects",
        "The infant process of learning to identify familiar faces and respond to strangers",
        "The adolescent process of establishing a clear sense of identity and sexual maturity"
      ],
      correctAnswer: 0
    },
    {
      id: 96022,
      question: "Around what age do children begin to have fears associated with separation from a parent?",
      options: [
        "Around 4 years old",
        "Around 2 years old",
        "Around 3 years old",
        "Around 1 year old"
      ],
      correctAnswer: 1
    },
    {
      id: 96023,
      question: "What best describes the school-age stage in Erikson's developmental theory?",
      options: [
        "A period of learning basic trust through nurturing, handling, and loving interactions",
        "A period of establishing sexual identity and experimenting with different roles in society",
        "A period of socialization where the child learns to get along with people and overcome fears",
        "A period of developing autonomy and initiative while requiring control and structure"
      ],
      correctAnswer: 2
    },
    {
      id: 96024,
      question: "What behavior characterizes Erikson's adolescence stage?",
      options: [
        "Developing basic trust through consistent, nurturing interactions with parents and caregivers",
        "Learning to control bodily functions and developing a sense of independence from caregivers",
        "Learning to get along with peers and overcoming fears related to objects and situations",
        "Acquiring self-certainty, experimenting with roles, and gradually developing a set of ideals"
      ],
      correctAnswer: 3
    },
    {
      id: 96025,
      question: "What is the purpose of the \"Tell, show, do\" technique in pediatric dentistry?",
      options: [
        "It is used to prepare the child and elicit appropriate cooperation by explaining, demonstrating, then performing a procedure",
        "It involves telling the child about rewards, showing a sticker chart, and doing a reward after treatment",
        "It is a charting system that records what was told, shown, and performed at each visit",
        "It allows the parent to narrate the procedure to the child while the hygienist works efficiently"
      ],
      correctAnswer: 0
    },
    {
      id: 96026,
      question: "What should be done if a child is unable to cooperate during a dental appointment?",
      options: [
        "Administer nitrous oxide immediately to calm the child without parental consultation",
        "Reschedule the appointment if the child is unable to cooperate",
        "Allow the parent to take over and complete the procedure at home with guidance",
        "Restrain the child using a papoose board to complete the procedure as quickly as possible"
      ],
      correctAnswer: 1
    },
    {
      id: 96027,
      question: "When might a parent be asked to exit the treatment room?",
      options: [
        "If the parent has not completed the required consent forms before the appointment",
        "When the child has reached school age and is comfortable with dental procedures",
        "If the parent is anxious or nervous and their presence may increase the child's anxiety",
        "When the treatment requires sterile conditions that parents are not permitted to disrupt"
      ],
      correctAnswer: 2
    },
    {
      id: 96028,
      question: "What is sedation used for in challenging pediatric dental patients?",
      options: [
        "It replaces the need for local anesthesia during all restorative procedures",
        "It is required for all children under the age of three regardless of cooperation level",
        "It is prescribed to make the child sleep through the entire procedure with no memory of it",
        "It is prescribed to calm the patient and put them at ease before treatment"
      ],
      correctAnswer: 3
    },
    {
      id: 96029,
      question: "What is the purpose of the papoose board in pediatric dentistry?",
      options: [
        "A physical restraint used to prevent injury to the child and dental team during procedures",
        "A specialized chair insert that adjusts standard dental chairs to fit children of all sizes",
        "To help the child practice sitting still through positive behavioral reinforcement techniques",
        "To position an infant properly for a knee-to-knee examination in the dental office"
      ],
      correctAnswer: 0
    },
    {
      id: 96030,
      question: "Which of the following describes healthy gingiva in primary dentition?",
      options: [
        "Pale white in color with a flat, firm texture and minimal papillae between teeth",
        "Pink or slightly red, thick, rounded or rolled, and shiny with less fibrous tissue adaptation than in permanent dentition",
        "Bright coral pink with sharply pointed papillae and a stippled texture identical to adult gingiva",
        "Deep red in color with a knife-edge contour and very tight adaptation to the teeth"
      ],
      correctAnswer: 1
    },
    {
      id: 96031,
      question: "What signs indicate unhealthy gingiva in a child?",
      options: [
        "Pink color with visible stippling and tight tissue adaptation around the teeth",
        "Flat interdental papillae and a col present between posterior teeth",
        "Swelling, redness, and bleeding on brushing or debriding",
        "Slightly rounded tissue contour and shiny appearance on the labial gingiva"
      ],
      correctAnswer: 2
    },
    {
      id: 96032,
      question: "What is a \"col\" in the context of gingival anatomy in primary dentition?",
      options: [
        "A flat saddle-shaped papilla found between primary incisors with spacing",
        "A fibrous gingival attachment that is tighter in primary than in permanent dentition",
        "A sharp interdental papilla present between all anterior primary teeth",
        "A valley-like depression that connects a facial and lingual papilla, found on posterior teeth in contact"
      ],
      correctAnswer: 3
    },
    {
      id: 96033,
      question: "What should be done when a white-spot lesion is found on an intact tooth surface during a caries evaluation?",
      options: [
        "Explore lightly for an intact surface, and if present, initiate caries control for remineralization",
        "Extract the primary tooth to prevent the lesion from spreading to the permanent tooth below",
        "Immediately schedule a restorative appointment and fill the demineralized area",
        "Document the finding and refer the child to an oral surgeon for biopsy"
      ],
      correctAnswer: 0
    },
    {
      id: 96034,
      question: "Which teeth should be evaluated for deep pits and fissures that may require sealants?",
      options: [
        "Primary mandibular canines and lateral incisors",
        "Primary molars, which should be assessed for deep or shallow pits and fissures",
        "All primary teeth including incisors, canines, and molars without exception",
        "Primary maxillary central and lateral incisors"
      ],
      correctAnswer: 1
    },
    {
      id: 96035,
      question: "What conditions are indications for orthodontic referral in a pediatric patient?",
      options: [
        "Delayed shedding of primary teeth beyond age twelve in otherwise healthy children",
        "Normal spacing between primary teeth and healthy gingival tissue with no pockets",
        "Severely crowded or malposed teeth, overbite, overjet, crossbites, or early loss of primary molars",
        "Premature eruption of permanent molars before the age of six years"
      ],
      correctAnswer: 2
    },
    {
      id: 96036,
      question: "Why is radiographic evaluation particularly important for primary molars?",
      options: [
        "Primary molars have thinner enamel and require X-rays to determine pulp vitality",
        "Primary molars frequently develop cysts and tumors that cannot be detected visually",
        "Primary molars are too large for direct visual examination with a dental mirror",
        "Primary molars are close together and interfere with visualization and exploration of interproximal surfaces"
      ],
      correctAnswer: 3
    },
    {
      id: 96037,
      question: "What risk factors for gingivitis are evaluated during an oral risk assessment?",
      options: [
        "Visible biofilm, mouth breathing, and crowded teeth",
        "Prenatal tobacco exposure, low birth weight, and frequent ear infections",
        "Socioeconomic status, dental insurance coverage, and frequency of dental visits",
        "High sugar diet, pacifier use, and lack of fluoride exposure in well water"
      ],
      correctAnswer: 0
    },
    {
      id: 96038,
      question: "What is required before treatment as part of treatment planning and consent in pediatric care?",
      options: [
        "A signed consent from the child's school confirming absence is approved for the appointment",
        "Parents and guardians must sign an informed consent before treatment begins",
        "A co-payment must be confirmed before the care plan is presented to the family",
        "The child must verbally agree to the procedure before any treatment can begin"
      ],
      correctAnswer: 1
    },
    {
      id: 96039,
      question: "What is the role of the disclosing agent during oral prophylaxis in pediatric patients?",
      options: [
        "It acts as a mild anesthetic to reduce discomfort during scaling and polishing procedures",
        "It is used as a flavoring agent to increase patient cooperation during toothbrushing",
        "It is essential for biofilm assessment and patient/parent education about plaque location",
        "It replaces the use of a scaler when only soft deposits are present on the tooth surfaces"
      ],
      correctAnswer: 2
    },
    {
      id: 96040,
      question: "Why is fluoride varnish preferred over topical gels and foams for children under 6 years?",
      options: [
        "Fluoride varnish is less expensive and easier to apply than gel trays for young children",
        "Fluoride varnish has no fluoride content and is therefore safe for all age groups without concern",
        "Fluoride varnish has a stronger concentration than gels and requires less frequent application",
        "Fluoride varnish reduces the risk of inadvertent ingestion, while professional gels and foams are not recommended for this age group"
      ],
      correctAnswer: 3
    },
    {
      id: 96041,
      question: "At what age is fluoride varnish application recommended to begin for children at moderate to high caries risk?",
      options: [
        "At 1 year of age",
        "At 6 months of age",
        "At 3 years of age",
        "At 2 years of age"
      ],
      correctAnswer: 0
    },
    {
      id: 96042,
      question: "How often should fluoride varnish be applied for a child at high caries risk?",
      options: [
        "Every 12 months",
        "Every 3 to 6 months",
        "Every 6 months",
        "Every 18 months"
      ],
      correctAnswer: 1
    },
    {
      id: 96043,
      question: "What percentage of dental caries in school-aged children occur in the pits and fissures?",
      options: [
        "As many as 70%",
        "As many as 80%",
        "As many as 90%",
        "As many as 50%"
      ],
      correctAnswer: 2
    },
    {
      id: 96044,
      question: "Why should children younger than 6 years of age not use mouthrinse unless directed by a dentist?",
      options: [
        "Mouthrinse interferes with the fluoride varnish applied at the dental office",
        "Mouthrinse contains fluoride levels that are too high for young children and may cause fluorosis",
        "Mouthrinse has a strong antibacterial effect that disrupts normal oral flora in young children",
        "Children under 6 may inadvertently swallow large amounts of the liquid"
      ],
      correctAnswer: 3
    },
    {
      id: 96045,
      question: "What chlorhexidine gluconate protocol is recommended for a parent/caregiver to reduce the transfer of cariogenic bacteria to the child?",
      options: [
        "Rinse with 0.12% chlorhexidine gluconate at bedtime for 1 week per month",
        "Rinse with 1% chlorhexidine gluconate twice daily during all weeks of the year",
        "Rinse with 0.2% chlorhexidine gluconate every morning for two weeks per month",
        "Rinse with 0.05% chlorhexidine gluconate daily for one month continuously"
      ],
      correctAnswer: 0
    },
    {
      id: 96046,
      question: "What are the two factors that most commonly affect the pulpal health of young teeth?",
      options: [
        "Orthodontic pressure and premature eruption",
        "Deep caries and traumatic injury",
        "Prolonged thumb sucking and mouth breathing",
        "Fluorosis and enamel hypoplasia"
      ],
      correctAnswer: 1
    },
    {
      id: 96047,
      question: "What is a pulpotomy in pediatric dentistry?",
      options: [
        "Removal of all infected carious dentin followed by a direct pulp cap with resin material",
        "Complete removal of all pulp tissue from both the crown and root portions of a primary tooth",
        "Complete removal of the coronal portion of the dental pulp while the root pulp is preserved",
        "A procedure that seals the pulp chamber with calcium hydroxide to promote continued root growth"
      ],
      correctAnswer: 2
    },
    {
      id: 96048,
      question: "What is pulp therapy in a pediatric context designed to do?",
      options: [
        "Replace the pulp with a synthetic material that supports permanent tooth development",
        "Reduce inflammation through surgical drainage of periapical infections",
        "Remove all pulp tissue to ensure the tooth remains pain-free until natural exfoliation",
        "Stimulate and preserve pulpal regeneration in primary teeth"
      ],
      correctAnswer: 3
    },
    {
      id: 96049,
      question: "What is a stainless steel crown used for in pediatric dentistry?",
      options: [
        "A prefabricated crown prepared and placed in a single appointment to cover severely decayed primary teeth",
        "A permanent crown fabricated in a laboratory and cemented at a subsequent appointment",
        "A temporary protective covering placed over a tooth while waiting for a custom crown",
        "An esthetic restoration placed on permanent teeth in adolescent patients requiring coverage"
      ],
      correctAnswer: 0
    },
    {
      id: 96050,
      question: "Which teeth are most likely to be injured in a child as a result of dental trauma?",
      options: [
        "Mandibular central incisors",
        "Maxillary central incisors",
        "Maxillary first primary molars",
        "Mandibular lateral incisors"
      ],
      correctAnswer: 1
    },
    {
      id: 96051,
      question: "What is a concern when a primary tooth is traumatically injured?",
      options: [
        "The child's facial growth pattern may be permanently altered by the trauma",
        "The adjacent tooth may drift mesially into the space left by the injured tooth",
        "The developing permanent tooth directly under the injured primary tooth may also become damaged",
        "The primary tooth's root may be resorbed prematurely, causing early exfoliation"
      ],
      correctAnswer: 2
    },
    {
      id: 96052,
      question: "What is avulsion of a tooth?",
      options: [
        "Partial displacement of a tooth while the root remains in the socket",
        "The abnormal displacement of a tooth into bone",
        "The abnormal displacement of a tooth out of bone without complete detachment",
        "The complete displacement of a tooth from the alveolar bone"
      ],
      correctAnswer: 3
    },
    {
      id: 96053,
      question: "What is the correct definition of traumatic intrusion?",
      options: [
        "A tooth is forcibly driven into the alveolus so that only a portion of the crown is visible",
        "A tooth is completely knocked out of the socket and recovered by the patient",
        "A tooth shifts laterally, causing damage to the surrounding periodontal ligament",
        "A tooth is displaced out of its socket and partially hangs from the periodontal ligament"
      ],
      correctAnswer: 0
    },
    {
      id: 96054,
      question: "What is the immediate first step when managing an avulsed tooth?",
      options: [
        "Wrap the tooth in a dry tissue and transport it in a rigid container to the dental office",
        "Recover the tooth immediately, wrap it in a moistened gauze, and go immediately to the dentist",
        "Reimplant the tooth without any cleaning, then apply pressure to the area with gauze",
        "Place the tooth in a glass of warm water and wait until the dentist can be reached"
      ],
      correctAnswer: 1
    },
    {
      id: 96055,
      question: "What determines how a fractured anterior tooth is treated?",
      options: [
        "The level of the child's anxiety and ability to cooperate during the examination",
        "The age of the child and the presence or absence of spacing between primary teeth",
        "The extent of the damage to the pulp determines how fractured anterior teeth are treated",
        "Whether the tooth is a primary or permanent tooth, regardless of pulp involvement"
      ],
      correctAnswer: 2
    },
    {
      id: 96056,
      question: "Which of the following is a clinical indicator that should raise suspicion of child abuse?",
      options: [
        "A child who demonstrates age-appropriate fear during a first dental visit",
        "A child who is excited about dental appointments and eager to please the clinical staff",
        "Injuries that are consistent with the explanation provided by the parent",
        "Injuries in various stages of healing, bite marks, or tears of the labial frena"
      ],
      correctAnswer: 3
    },
    {
      id: 96057,
      question: "What is the dental team's role regarding child abuse?",
      options: [
        "They are mandatory reporters and must report suspected child abuse",
        "They are required to contact the child's school board before notifying any authority",
        "They may report suspected abuse but are not required to do so by law",
        "They should document findings privately and share only with the family dentist"
      ],
      correctAnswer: 0
    },
    {
      id: 96058,
      question: "Which of the following is a listed oral health consideration for infants?",
      options: [
        "Orthodontic evaluation, habit cessation, and dietary pattern modification",
        "Non-nutritive sucking, bottle-feeding, teething, early childhood caries, and fluoride supplementation",
        "Mouthrinse use, disclosing agent application, and radiographic monitoring",
        "Supervised brushing with fluoride toothpaste and fissure sealant placement"
      ],
      correctAnswer: 1
    },
    {
      id: 96059,
      question: "What is nonnutritive sucking?",
      options: [
        "A feeding technique used when breastfeeding is not possible for the mother",
        "A pattern of feeding where infants receive nutrition through intravenous methods",
        "Sucking on the thumb, fingers, or pacifiers for comfort, which is normal and acceptable in infancy",
        "A harmful habit that should be immediately discouraged at the first dental visit"
      ],
      correctAnswer: 2
    },
    {
      id: 96060,
      question: "Which of the following is a characteristic of a safe pacifier?",
      options: [
        "Small enough to fit entirely in the child's mouth to prevent falling out during sleep",
        "Tied to the child's clothing so it is always accessible and easy to retrieve",
        "Cleaned in the parent's mouth before giving it to the infant to remove bacteria",
        "Solid construction with a ventilated shield large enough to prevent swallowing and made of nontoxic material"
      ],
      correctAnswer: 3
    },
    {
      id: 96061,
      question: "What is the correct minimum shield size for a safe pacifier?",
      options: [
        "At least 1 to 1-1/2 inches in diameter",
        "At least 2 to 2-1/2 inches in diameter",
        "At least 3 inches in diameter",
        "At least half an inch in diameter"
      ],
      correctAnswer: 0
    },
    {
      id: 96062,
      question: "What guidance is given regarding bottle feeding?",
      options: [
        "The child may be placed in bed with a bottle of formula as long as it contains no juice",
        "Place only formula or milk in the bottle, hold the child during feeding, and never place the child in bed with a bottle",
        "Sweet liquids are acceptable in the bottle if the child uses fluoride toothpaste daily",
        "Juice and milk are both appropriate in a bottle as long as teeth are brushed afterward"
      ],
      correctAnswer: 1
    },
    {
      id: 96063,
      question: "When can breastfeeding lead to dental demineralization?",
      options: [
        "When the infant uses an orthodontic nipple pacifier between feeding sessions",
        "When the infant is breastfed more than four times per day during waking hours",
        "When the infant falls asleep after sucking and milk collects around the teeth",
        "When the mother consumes large amounts of sugar that enters the breastmilk"
      ],
      correctAnswer: 2
    },
    {
      id: 96064,
      question: "Which teeth are most often first affected by early childhood caries?",
      options: [
        "Mandibular central incisors",
        "Maxillary canines",
        "Mandibular first primary molars",
        "Maxillary anterior incisors"
      ],
      correctAnswer: 3
    },
    {
      id: 96065,
      question: "Why are mandibular anterior teeth rarely affected by early childhood caries (ECC)?",
      options: [
        "The nipple covers the mandibular anterior teeth during suckling, so sweet liquid does not pool there",
        "Mandibular anterior teeth erupt later and are exposed to fewer cariogenic episodes",
        "Mandibular teeth are protected by a higher salivary flow from the sublingual glands",
        "Mandibular teeth have thicker enamel and more resistance to acid attack than maxillary teeth"
      ],
      correctAnswer: 0
    },
    {
      id: 96066,
      question: "What bacteria is most associated with early childhood caries?",
      options: [
        "Lactobacillus acidophilus and Porphyromonas gingivalis",
        "Streptococcus mutans, which can be transferred from caregiver to child",
        "Staphylococcus aureus and Candida albicans in the dental biofilm",
        "Fusobacterium nucleatum and Actinomyces viscosus"
      ],
      correctAnswer: 1
    },
    {
      id: 96067,
      question: "What are early childhood caries also known as?",
      options: [
        "Pit and fissure caries, enamel hypoplasia, or white spot disease",
        "Radiation caries, fluoride caries, or early-onset periodontal disease",
        "Nursing caries, baby bottle caries, or baby bottle tooth decay",
        "Rampant caries, childhood decay, or interproximal caries"
      ],
      correctAnswer: 2
    },
    {
      id: 96068,
      question: "Which of the following is a strategy to decrease the incidence of early childhood caries?",
      options: [
        "Begin brushing with fluoride toothpaste twice daily starting at birth",
        "Place the child in bed with a bottle of diluted fruit juice instead of plain water",
        "Allow infants to sip juice freely from a sippy cup during the day to stay hydrated",
        "Do not share eating utensils with the infant and do not clean pacifiers in an adult's mouth"
      ],
      correctAnswer: 3
    },
    {
      id: 96069,
      question: "At what age should an infant be weaned to a sippy cup according to ECC prevention strategies?",
      options: [
        "At one year of age",
        "At two years of age",
        "At six months of age",
        "At eighteen months of age"
      ],
      correctAnswer: 0
    },
    {
      id: 96070,
      question: "What is the appropriate amount of fluoride toothpaste for a child aged 3 to 5 years?",
      options: [
        "A strip the full length of the toothbrush head",
        "A pea-sized amount spread in a thin layer across the brush before brushing",
        "A large ribbon of toothpaste is acceptable as long as the child spits it out",
        "No toothpaste until the child can consistently rinse and spit without assistance"
      ],
      correctAnswer: 1
    },
    {
      id: 96071,
      question: "What is fluorosis?",
      options: [
        "A condition caused by insufficient fluoride intake that leads to rapid dental caries in children",
        "An inflammatory gingival condition triggered by high fluoride levels in well water",
        "A developmental defect of enamel caused by excessive fluoride intake during tooth formation",
        "A systemic condition affecting bone density caused by fluoride supplementation in infants"
      ],
      correctAnswer: 2
    },
    {
      id: 96072,
      question: "What causes oral malodour in toddlers and preschoolers?",
      options: [
        "Prolonged pacifier use and non-nutritive sucking beyond infancy",
        "Residual milk proteins remaining on the tongue after feeding sessions",
        "Poor digestion from high sugar intake and carbonated beverages",
        "Bacteria at the base of the tongue and bacteria between the teeth"
      ],
      correctAnswer: 3
    },
    {
      id: 96073,
      question: "Why should toddlers not be allowed to sip milk or sweet liquids at will from a sippy cup?",
      options: [
        "Frequent at-will sipping of milk or sweet liquids promotes demineralization of teeth",
        "Constant access to sippy cups limits the development of proper swallowing reflexes",
        "Frequent sipping causes the child to consume excess calories and leads to childhood obesity",
        "Sweet liquids in a sippy cup cause staining of the primary teeth over time"
      ],
      correctAnswer: 0
    },
    {
      id: 96074,
      question: "What age range does Erikson's adolescence stage cover?",
      options: [
        "10 to 18 years",
        "12 to 20 years",
        "14 to 21 years",
        "6 to 12 years"
      ],
      correctAnswer: 1
    },
    {
      id: 96075,
      question: "What is \"preventive orthodontics\"?",
      options: [
        "Monitoring orthodontic development without any active intervention until adolescence",
        "Using fixed appliances to reposition already erupted teeth into their ideal positions",
        "Allowing the dentist to prevent or eliminate irregularities and malpositions in the developing dentofacial region",
        "A referral process that places children on waiting lists for orthodontic treatment after age 12"
      ],
      correctAnswer: 2
    },
    {
      id: 96076,
      question: "What is the role of \"interceptive orthodontics\"?",
      options: [
        "It focuses on esthetic improvements using removable appliances in adults",
        "It prevents problems from developing by eliminating irregularities early in dentofacial growth",
        "It places fixed retainers after orthodontic treatment to maintain tooth position",
        "It allows the dentist to intercede or correct problems as they develop"
      ],
      correctAnswer: 3
    },
    {
      id: 96077,
      question: "What is avulsion defined as?",
      options: [
        "The complete displacement of a tooth from the alveolar bone",
        "The displacement of a tooth into the alveolar bone so that the crown is not fully visible",
        "The abnormal displacement of a tooth laterally while remaining in the socket",
        "The partial displacement of a tooth from its socket while still attached by the periodontal ligament"
      ],
      correctAnswer: 0
    },
    {
      id: 96078,
      question: "What happens to space when a second primary molar is prematurely lost?",
      options: [
        "The erupting permanent canine drifts into the space and blocks the premolar",
        "The first permanent molar drifts mesially into the space, crowding the developing second premolar",
        "The primary first molar spontaneously shifts distally to fill the gap left behind",
        "The developing permanent molar erupts early to compensate for the missing primary tooth"
      ],
      correctAnswer: 1
    },
    {
      id: 96079,
      question: "When should a referral to a pedodontist be considered from a general practice?",
      options: [
        "Whenever a child has any restorative procedure or requires radiographs at any appointment",
        "Only when the child is diagnosed with a systemic illness requiring hospital-based care",
        "When a child is very young, very anxious, very uncooperative, or in need of special treatment",
        "When the dental hygienist determines that the child needs sealants placed on primary molars"
      ],
      correctAnswer: 2
    },
    {
      id: 96080,
      question: "What key topics should parents be taught regarding their child's oral health?",
      options: [
        "How to manage early childhood caries at home using over-the-counter remineralizing agents",
        "The benefits of dental insurance coverage and how to access community dental care programs",
        "How to perform fluoride supplementation, orthodontic monitoring, and pit and fissure sealant application",
        "The effect of parental health on the child, transfer of cariogenic bacteria, fluoride effects, caries prevention, professional care needs, and injury prevention"
      ],
      correctAnswer: 3
    },
    {
      id: 96081,
      question: "Which age group should take in fluoride daily for optimal preventive benefit?",
      options: [
        "Children between the ages of 6 months and 16 years",
        "Children between the ages of 2 and 18 years",
        "Children between the ages of 1 and 6 years",
        "Children between the ages of 3 and 12 years"
      ],
      correctAnswer: 0
    },
    {
      id: 96082,
      question: "What is the purpose of sealants in pediatric preventive dentistry?",
      options: [
        "They are applied to anterior smooth surfaces to prevent early childhood caries",
        "They are applied to pits and fissures to help keep those areas cavity-free",
        "They replace fluoride varnish for children at moderate risk for dental caries",
        "They are placed over white spot lesions to promote remineralization of enamel"
      ],
      correctAnswer: 1
    },
    {
      id: 96083,
      question: "What should be worn during any recreational sport that might injure the mouth?",
      options: [
        "A standard foam earplug cut to fit between the upper and lower teeth",
        "A face shield that covers the entire lower face from the nose to the chin",
        "Protective equipment such as a mouthguard",
        "A custom-fabricated hard acrylic nightguard from the dental office"
      ],
      correctAnswer: 2
    },
    {
      id: 96084,
      question: "What type of anxiety-management approach does voice control involve?",
      options: [
        "Allowing the parent to take over verbal communication with the child during treatment",
        "Using a loud and commanding voice to immediately stop uncooperative behavior",
        "Using a very quiet voice so the child cannot clearly hear instructions and becomes calm",
        "Speaking calmly but firmly, which usually prevents the need for additional management steps"
      ],
      correctAnswer: 3
    },
    {
      id: 96085,
      question: "Which type of pacifier nipple is designed to be more similar to a mother's breast nipple during nursing?",
      options: [
        "Orthodontic nipple",
        "Latex nipple",
        "Nonorthodontic nipple",
        "Silicone nipple"
      ],
      correctAnswer: 0
    },
    {
      id: 96086,
      question: "What is the extraoral examination used to assess in a pediatric initial clinical examination?",
      options: [
        "The number and type of teeth present and any spacing discrepancies in the arch",
        "The patient's profile to determine skeletal characteristics",
        "The gingival tissue health and the depth of periodontal pockets around primary teeth",
        "The presence of lymphadenopathy and signs of systemic disease in the neck region"
      ],
      correctAnswer: 1
    },
    {
      id: 96087,
      question: "What predisposing factor for early childhood caries involves feeding behavior at bedtime?",
      options: [
        "Giving the child water in a bottle at bedtime to keep them hydrated during the night",
        "Giving the child a toothbrush with toothpaste as the last activity before bed",
        "Placing a bottle or sippy cup in bed with the child or allowing prolonged at-will breast/bottle feeding as a sleep control",
        "Allowing the child to eat crackers or dry cereal as a bedtime snack before brushing"
      ],
      correctAnswer: 2
    },
    {
      id: 96088,
      question: "Which of the following is listed as a barrier to dental care for children?",
      options: [
        "The availability of too many dental office options in a given geographic area",
        "Excessive parental involvement in the child's oral hygiene routine",
        "The child's refusal to cooperate with the dental hygienist during appointments",
        "Lack of belief in prevention, cost, fear, language, and no dental home"
      ],
      correctAnswer: 3
    },
    {
      id: 96089,
      question: "The dental home should be established no later than 12 months of age and emphasis is placed on oral health counseling and prevention.",
      options: [
        "True",
        "False",
      ],
      correctAnswer: 0
    },
    {
      id: 96090,
      question: "Children who differ widely from developmental norms always have a physical or cognitive disorder and should be immediately referred.",
      options: [
        "True",
        "False",
      ],
      correctAnswer: 1
    },
    {
      id: 96091,
      question: "The \"Tell, show, do\" technique is an important behavior management strategy for preparing children and eliciting appropriate cooperation during dental procedures.",
      options: [
        "True",
        "False",
      ],
      correctAnswer: 0
    },
    {
      id: 96092,
      question: "Fluoride varnish is not recommended for children at moderate or high risk for dental caries until they are at least 3 years of age.",
      options: [
        "True",
        "False",
      ],
      correctAnswer: 1
    },
    {
      id: 96093,
      question: "As many as 90% of dental caries in school-aged children occur in the pits and fissures of posterior teeth.",
      options: [
        "True",
        "False",
      ],
      correctAnswer: 0
    },
    {
      id: 96094,
      question: "Mandibular anterior teeth are the first teeth to be affected by early childhood caries because they are the first to erupt.",
      options: [
        "True",
        "False",
      ],
      correctAnswer: 1
    },
    {
      id: 96095,
      question: "Dental hygienists working with pediatric patients are mandatory reporters when they suspect child abuse or neglect.",
      options: [
        "True",
        "False",
      ],
      correctAnswer: 0
    },
    {
      id: 96096,
      question: "Cleaning a pacifier in the parent's or caregiver's mouth is a recommended practice to remove harmful bacteria before giving it to an infant.",
      options: [
        "True",
        "False",
      ],
      correctAnswer: 1
    },
    {
      id: 96097,
      question: "Fluoride varnish has been shown to reduce the incidence of early childhood caries and is used routinely for caries prevention.",
      options: [
        "True",
        "False",
      ],
      correctAnswer: 0
    },
    {
      id: 96098,
      question: "Children younger than 6 years of age should use mouthrinse daily to help control gingivitis and dental biofilm accumulation.",
      options: [
        "True",
        "False",
      ],
      correctAnswer: 1
    }
  ],
  "6. Sutures Supplemental Slides": [
    {
      id: 97001,
      question: "What is sedation?",
      options: [
        "A method of blocking all pain perception in the body",
        "The reduction of anxiety or agitation, typically by administering sedative drugs",
        "A technique that only uses inhalation routes of drug delivery",
        "A surgical procedure requiring general anesthesia"
      ],
      correctAnswer: 1
    },
    {
      id: 97002,
      question: "Which of the following correctly describes nitrous oxide (N2O)?",
      options: [
        "It is a yellow gas with a bitter smell that is irritating to the lungs",
        "It is stored and delivered only in gaseous form under high pressure",
        "It is colorless, tasteless, and has a sweet smell",
        "It is a highly allergenic compound that affects the respiratory system"
      ],
      correctAnswer: 2
    },
    {
      id: 97003,
      question: "Which route of administration is historically the most common for dental sedation?",
      options: [
        "Oral route using benzodiazepines taken before the appointment",
        "Intravenous route using midazolam and propofol infusion",
        "Intramuscular route using ketamine at a low dose",
        "Inhalation route using nitrous oxide and oxygen"
      ],
      correctAnswer: 3
    },
    {
      id: 97004,
      question: "Why can the pressure gauge on a nitrous oxide cylinder NOT accurately measure how much gas remains?",
      options: [
        "The gauge is calibrated only for oxygen cylinders and gives false readings",
        "N2O is stored as both liquid and gas; the gauge stays constant until the liquid is nearly gone",
        "The gauge measures volume, not pressure, causing systematic errors",
        "N2O pressure fluctuates continuously based on ambient temperature changes"
      ],
      correctAnswer: 1
    },
    {
      id: 97005,
      question: "N2O acts on the central nervous system by which mechanism?",
      options: [
        "Blocking sodium channels in peripheral nerve fibers to stop pain signals",
        "Directly binding to opioid receptors to eliminate all pain perception",
        "Altering the relay of nerve impulses to the cerebral cortex or changing their interpretation",
        "Stimulating dopamine release to produce euphoria and complete analgesia"
      ],
      correctAnswer: 2
    },
    {
      id: 97006,
      question: "Which statement about N2O pharmacology is correct?",
      options: [
        "N2O significantly elevates heart rate and blood pressure even at low concentrations",
        "N2O has no effect on sensations such as hearing, touch, or warmth",
        "N2O has no effect on heart rate, blood pressure, liver, or kidneys when adequate oxygen is given",
        "N2O is metabolized extensively by the liver before being exhaled"
      ],
      correctAnswer: 2
    },
    {
      id: 97007,
      question: "How quickly does N2O reach the brain, and when does it begin to take clinical effect?",
      options: [
        "It reaches the brain in 5 minutes and takes effect after approximately 15 minutes",
        "It reaches the brain in about 20 seconds and begins to take effect in approximately 2–3 minutes",
        "It reaches the brain instantly and produces maximum effect within 30 seconds",
        "It requires 10 minutes to reach the brain and up to 30 minutes to take full effect"
      ],
      correctAnswer: 1
    },
    {
      id: 97008,
      question: "What physiological problem occurs with oversedation of N2O?",
      options: [
        "Hypertension and tachycardia requiring emergency intervention",
        "Kidney failure due to accumulation of N2O metabolites",
        "Hypoxia, which can present as headache and nausea",
        "Liver enzyme elevation requiring discontinuation of treatment"
      ],
      correctAnswer: 2
    },
    {
      id: 97009,
      question: "\"Conscious sedation\" in the context of N2O-O2 analgesia means:",
      options: [
        "The client is fully unconscious and unresponsive to all stimuli",
        "The client is minimally depressed, maintains airway independently, and responds to commands",
        "The client has lost all pain perception but retains protective reflexes",
        "The client requires airway assistance due to reduced respiratory function"
      ],
      correctAnswer: 1
    },
    {
      id: 97010,
      question: "Which synonym for N2O-O2 sedation refers to the fact that gas is inhaled through the nose?",
      options: [
        "Relative analgesia",
        "N2O psychosedation",
        "Conscious sedation",
        "Inhalation sedation"
      ],
      correctAnswer: 3
    },
    {
      id: 97011,
      question: "\"Relative analgesia\" as a synonym for N2O-O2 sedation refers to:",
      options: [
        "A state where all pain sensations are completely blocked by the gas",
        "Sedation that is only appropriate relative to the patient's age and weight",
        "The state of sedation that alters mood and raises pain threshold without blocking pain entirely",
        "An analgesic effect that is relative only to soft tissue procedures"
      ],
      correctAnswer: 2
    },
    {
      id: 97012,
      question: "In the four stages of anesthesia, Stage II is characterized by:",
      options: [
        "Loss of consciousness appropriate for oral surgery procedures",
        "Mild analgesia where the patient feels pain but does not care",
        "Respiratory paralysis reserved for major hospital surgery",
        "Hyperresponsiveness to stimuli, exaggerated inspirations, and loss of consciousness"
      ],
      correctAnswer: 3
    },
    {
      id: 97013,
      question: "Which stage of anesthesia involves surgical anesthesia with respiratory paralysis, reserved for major hospital surgery?",
      options: [
        "Stage I (Analgesia Stage)",
        "Stage IV",
        "Stage II (Delirium/Excitement)",
        "Stage III (Surgical Anesthesia)"
      ],
      correctAnswer: 1
    },
    {
      id: 97014,
      question: "Which stage of anesthesia is most appropriate for dental hygiene care?",
      options: [
        "Stage III, Plane 1 — light surgical anesthesia with loss of consciousness",
        "Stage II — delirium stage with hyperresponsiveness",
        "Stage I — relative analgesia where the client feels pain but does not care",
        "Stage IV — respiratory paralysis managed in hospital settings"
      ],
      correctAnswer: 2
    },
    {
      id: 97015,
      question: "How is minimal sedation best defined?",
      options: [
        "Complete loss of consciousness with intact airway protective reflexes",
        "A state requiring airway support but maintaining cardiovascular function",
        "A minimally depressed level of consciousness retaining airway maintenance and normal response to stimuli",
        "Drug-induced deep depression requiring repeated stimulation to arouse the patient"
      ],
      correctAnswer: 2
    },
    {
      id: 97016,
      question: "When N2O-O2 is combined with another synergistic sedative drug, the patient is placed in which category?",
      options: [
        "Minimal sedation regardless of the drug combination used",
        "Moderate sedation, because the addition of N2O deepens the effect",
        "Stage I analgesia, which remains unchanged when drugs are combined",
        "Deep sedation only if three or more sedative agents are used together"
      ],
      correctAnswer: 1
    },
    {
      id: 97017,
      question: "What is titration in the context of N2O-O2 sedation?",
      options: [
        "The process of weighing a patient to calculate the exact milligram dose of N2O required",
        "A method of mixing N2O and O2 in a fixed ratio before delivery",
        "Administering incremental doses of a drug over time until the desired effect is reached",
        "Reversing sedation by administering increasing amounts of oxygen after the procedure"
      ],
      correctAnswer: 2
    },
    {
      id: 97018,
      question: "Which of the following is an indication for N2O-O2 sedation?",
      options: [
        "Cystic fibrosis with known pulmonary bullae formation",
        "A hypersensitive gag response during dental procedures",
        "Recent vitreoretinal eye surgery requiring follow-up care",
        "First trimester pregnancy with routine dental cleaning"
      ],
      correctAnswer: 1
    },
    {
      id: 97019,
      question: "Why is N2O-O2 sedation beneficial for patients with asthma?",
      options: [
        "N2O acts as a bronchodilator that relaxes the smooth muscle in the airways",
        "The sedation eliminates the need for any other respiratory medications",
        "Patients receive supplemental oxygen above room-air levels, which facilitates breathing and decreases stress",
        "N2O blocks the histamine receptors responsible for asthma attacks"
      ],
      correctAnswer: 2
    },
    {
      id: 97020,
      question: "Which statement correctly describes N2O's relationship to local anesthesia?",
      options: [
        "N2O completely replaces the need for local anesthesia in all dental procedures",
        "N2O is a substitute for local anesthesia in patients with needle phobia",
        "N2O is not a substitute for local anesthesia but can make injections and procedures more comfortable",
        "N2O is contraindicated when local anesthesia is administered simultaneously"
      ],
      correctAnswer: 2
    },
    {
      id: 97021,
      question: "Nitrous oxide causes vasodilation. Which patient group benefits from this property?",
      options: [
        "Patients with severe COPD who rely on hypoxic drive to breathe",
        "Patients with cystic fibrosis who develop air-filled lung bullae",
        "Patients with claustrophobia who cannot tolerate the nasal hood",
        "Patients with controlled cardiovascular disease or hypertension"
      ],
      correctAnswer: 3
    },
    {
      id: 97022,
      question: "Which condition is listed as a contraindication to N2O-O2 sedation?",
      options: [
        "Controlled hypertension with regular medication",
        "Mild intellectual disability with intact nasal breathing",
        "Chronic obstructive pulmonary disease (COPD)",
        "A history of dental anxiety without other health concerns"
      ],
      correctAnswer: 2
    },
    {
      id: 97023,
      question: "Why is pregnancy listed as a contraindication or area of caution for N2O-O2 sedation?",
      options: [
        "N2O causes teratogenic effects in all trimesters with no controversy",
        "Use is controversial; first-trimester drug avoidance is recommended and third-trimester concerns include low oxygen tension",
        "N2O is completely safe in all trimesters when a scavenging system is used",
        "Pregnancy increases N2O metabolism, making sedation ineffective"
      ],
      correctAnswer: 1
    },
    {
      id: 97024,
      question: "Why is claustrophobia considered a contraindication to N2O-O2 sedation?",
      options: [
        "Claustrophobic patients cannot tolerate lying in the supine position during treatment",
        "Claustrophobic patients are allergic to the rubber compounds in the nasal hood",
        "The nasal hood may increase feelings of anxiety or confinement in claustrophobic patients",
        "Claustrophobia causes hyperventilation that prevents effective gas absorption"
      ],
      correctAnswer: 2
    },
    {
      id: 97025,
      question: "Why is cystic fibrosis a contraindication for N2O-O2 sedation?",
      options: [
        "Patients with cystic fibrosis cannot breathe through the nose, making the hood ineffective",
        "N2O is an expansive gas that can enlarge air-filled bullae in the lungs of cystic fibrosis patients",
        "Cystic fibrosis causes liver disease that prevents normal N2O metabolism",
        "The high oxygen content of N2O-O2 is toxic to patients with cystic fibrosis"
      ],
      correctAnswer: 1
    },
    {
      id: 97026,
      question: "Why must patients with COPD use N2O-O2 sedation with extreme caution?",
      options: [
        "Their compromised lung tissue fully absorbs N2O, causing unpredictable overdose",
        "Excess oxygen can suppress their hypoxic breathing drive, leading to dyspnea or apnea",
        "COPD patients have altered N2O metabolism requiring much higher doses",
        "The scavenging system cannot function properly when COPD patients exhale"
      ],
      correctAnswer: 1
    },
    {
      id: 97027,
      question: "Language barriers or reduced mental capacity are listed as contraindications to N2O-O2 sedation primarily because:",
      options: [
        "These patients are likely to be allergic to N2O and require alternative sedation",
        "Patients must be able to provide informed consent and communicate discomfort during treatment",
        "Translators are not permitted in dental operatories during sedation procedures",
        "Reduced mental capacity increases N2O absorption causing dangerous overdose"
      ],
      correctAnswer: 1
    },
    {
      id: 97028,
      question: "Why is drug or alcohol abuse a contraindication consideration for N2O-O2 sedation?",
      options: [
        "Substance users cannot breathe through the nose effectively",
        "Alcohol is chemically similar to N2O, causing immediate toxic reactions",
        "N2O may potentiate the effects of drugs or alcohol already in the patient's system",
        "Substance abusers always request higher N2O concentrations than are safe"
      ],
      correctAnswer: 2
    },
    {
      id: 97029,
      question: "Why is a recent eye surgery (e.g., vitreoretinal) a contraindication for N2O-O2 sedation?",
      options: [
        "Patients cannot wear protective eyewear over a surgical eye during the procedure",
        "Eye surgery medications react chemically with N2O in the bloodstream",
        "N2O can expand trapped gases within the eye, interfering with healing",
        "Post-surgical eye inflammation increases sensitivity to N2O's analgesic effects"
      ],
      correctAnswer: 2
    },
    {
      id: 97030,
      question: "Which of the following conditions requires cautious use of N2O-O2 sedation?",
      options: [
        "Controlled mild hypertension without other complications",
        "Vitamin B12 deficiency or patients taking methotrexate",
        "Mild dental anxiety in an otherwise healthy adult patient",
        "A patient with a mild cold who can still breathe through their nose"
      ],
      correctAnswer: 1
    },
    {
      id: 97031,
      question: "Why is bleomycin sulfate listed as a condition requiring cautious N2O-O2 use?",
      options: [
        "Bleomycin enhances N2O absorption, causing unpredictably deep sedation",
        "Patients on bleomycin should not receive 100% oxygen due to hyperoxygenation risks",
        "Bleomycin causes nasal polyps that block effective gas delivery",
        "The combination of bleomycin and N2O creates toxic metabolites in the liver"
      ],
      correctAnswer: 1
    },
    {
      id: 97032,
      question: "Which of the following is an advantage of N2O-O2 sedation?",
      options: [
        "It completely eliminates the need for local anesthesia in all dental procedures",
        "It requires a surgical center and specialized monitoring equipment",
        "Rapid induction and emergence eliminate the need for surgical centers or highly trained personnel",
        "Patients must always have a companion to drive them home after treatment"
      ],
      correctAnswer: 2
    },
    {
      id: 97033,
      question: "What is the primary disadvantage of N2O-O2 sedation?",
      options: [
        "It causes permanent memory loss requiring extended post-treatment observation",
        "Some patients may experience nausea, dizziness, or may not relax or respond as expected",
        "Morbidity and mortality rates are significantly higher than other sedation methods",
        "It requires intravenous access and hospital-level monitoring for every patient"
      ],
      correctAnswer: 1
    },
    {
      id: 97034,
      question: "What is the Verrill sign observed during N2O-O2 sedation?",
      options: [
        "A rapid, involuntary blinking reflex indicating the patient is in Stage II anesthesia",
        "Constriction of the pupils signaling oversedation requiring immediate intervention",
        "A half-closed appearance of the eyelids or a slow blink rate indicating appropriate sedation",
        "Fixed and dilated pupils indicating the patient has lost consciousness"
      ],
      correctAnswer: 2
    },
    {
      id: 97035,
      question: "Which of the following is a subjective symptom a patient may report during appropriate N2O-O2 sedation?",
      options: [
        "Severe nausea and vomiting indicating the sedation is working properly",
        "Numbness or tingling in the lips, prompting them to ask if their mouth has been numbed",
        "Complete inability to move or respond to the clinician's instructions",
        "Sharp pain in the chest area indicating cardiac involvement"
      ],
      correctAnswer: 1
    },
    {
      id: 97036,
      question: "Which objective sign is observed in a patient achieving ideal N2O-O2 sedation?",
      options: [
        "Rigid, tense muscles and elevated blood pressure indicating deeper sedation",
        "Feet falling to the sides, relaxed shoulders, and lips curled into a slight smile",
        "Eyes wide open and hypervigilant, indicating the patient is comfortable and alert",
        "Tachycardia and increased perspiration signaling adequate analgesic effect"
      ],
      correctAnswer: 1
    },
    {
      id: 97037,
      question: "What does a deflated reservoir bag indicate during N2O-O2 administration?",
      options: [
        "The flow rate is too high or the breathing line may be occluded",
        "The patient is not breathing at all and requires immediate airway intervention",
        "The patient is breathing deeply or heavily and the flow rate should be increased",
        "The N2O cylinder is empty and must be replaced before proceeding"
      ],
      correctAnswer: 2
    },
    {
      id: 97038,
      question: "What is the color of nitrous oxide cylinders in the United States and Canada?",
      options: [
        "Green, to distinguish them from other medical gas cylinders",
        "White, in conformity with international ISO medical gas standards",
        "Blue, to differentiate them from oxygen and other gas cylinders",
        "Yellow, to indicate that the gas supports combustion"
      ],
      correctAnswer: 2
    },
    {
      id: 97039,
      question: "What is the color of oxygen cylinders in the United States and Canada?",
      options: [
        "Blue, matching the color used internationally for respiratory gases",
        "White, following the ISO international standard for oxygen",
        "Yellow, indicating the gas is under high pressure in the cylinder",
        "Green, to distinguish them from nitrous oxide and other medical gases"
      ],
      correctAnswer: 3
    },
    {
      id: 97040,
      question: "A full nitrous oxide cylinder contains approximately what proportion of liquid to gaseous N2O?",
      options: [
        "50% liquid and 50% gaseous nitrous oxide in equal amounts",
        "95% liquid nitrous oxide and 5% gaseous nitrous oxide",
        "10% liquid and 90% gaseous nitrous oxide ready for delivery",
        "75% liquid and 25% gaseous nitrous oxide at full capacity"
      ],
      correctAnswer: 1
    },
    {
      id: 97041,
      question: "What is the purpose of the reservoir bag on the gas machine?",
      options: [
        "It stores extra N2O to be used if the cylinder runs low during treatment",
        "It acts as a mixing chamber, accommodates deep breaths, and allows visualization of respirations",
        "It filters impurities from the gas before delivery to the patient",
        "It measures the exact tidal volume exhaled by the patient during sedation"
      ],
      correctAnswer: 1
    },
    {
      id: 97042,
      question: "What safety feature do modern N2O-O2 delivery machines include regarding gas concentrations?",
      options: [
        "They limit oxygen to a maximum of 50% to conserve cylinder supply",
        "They automatically increase N2O if the patient reports any discomfort",
        "They prevent N2O from exceeding 70% and keep oxygen at or above 30%",
        "They deliver a fixed 50/50 ratio of N2O and O2 at all times"
      ],
      correctAnswer: 2
    },
    {
      id: 97043,
      question: "What is the purpose of the scavenging system used with N2O-O2 delivery?",
      options: [
        "It filters incoming gas to remove bacteria and toxins before delivery",
        "It removes exhaled nitrous oxide from the treatment room, reducing ambient N2O levels",
        "It recycles exhaled N2O back into the cylinder for cost-effective reuse",
        "It monitors the patient's blood oxygenation levels throughout the procedure"
      ],
      correctAnswer: 1
    },
    {
      id: 97044,
      question: "How much does a scavenging system reduce N2O levels in the treatment environment?",
      options: [
        "From 500 ppm down to approximately 100 ppm",
        "From 900 ppm down to approximately 30 ppm",
        "From 200 ppm down to approximately 10 ppm",
        "From 1500 ppm down to approximately 200 ppm"
      ],
      correctAnswer: 1
    },
    {
      id: 97045,
      question: "What is the Pin Index Safety System used for on portable size E cylinders?",
      options: [
        "It measures the remaining gas pressure in each cylinder",
        "It allows both N2O and O2 cylinders to connect to the same yoke",
        "Each cylinder has a unique pin configuration to prevent incorrect gas attachment",
        "It prevents the valve from being opened more than halfway during use"
      ],
      correctAnswer: 2
    },
    {
      id: 97046,
      question: "What does the Diameter Index Safety System prevent?",
      options: [
        "Cylinders from being stored near heat sources or open flames",
        "The scavenging system from being accidentally disconnected during use",
        "Gas hoses from being crossed by using different connection widths and lengths",
        "Cylinders from being opened fully, protecting against sudden pressure release"
      ],
      correctAnswer: 2
    },
    {
      id: 97047,
      question: "What is capnography used for during sedation monitoring?",
      options: [
        "Measuring blood oxygenation using a pulse oximeter clipped to the finger",
        "Recording the electrical activity of the heart during the procedure",
        "Measuring exhaled CO2 to monitor respiratory rate, depth, and detect emergencies",
        "Tracking the patient's blood pressure continuously during sedation"
      ],
      correctAnswer: 2
    },
    {
      id: 97048,
      question: "What are the four phases of N2O-O2 administration and monitoring?",
      options: [
        "Screening, induction, maintenance, and discharge assessment",
        "Preparation, administration, recovery, and postoperative phases",
        "Assessment, titration, monitoring, and documentation phases",
        "Consent, delivery, oxygenation, and chart review phases"
      ],
      correctAnswer: 1
    },
    {
      id: 97049,
      question: "What is the recommended initial oxygen flow rate for an average adult at the start of N2O-O2 sedation?",
      options: [
        "Approximately 2 L/min to prevent rapid N2O dilution at onset",
        "Approximately 10 L/min to ensure full saturation before N2O is introduced",
        "Approximately 4 L/min, the same rate used for pediatric patients",
        "Approximately 6 L/min of oxygen before introducing nitrous oxide"
      ],
      correctAnswer: 3
    },
    {
      id: 97050,
      question: "During titration, how long should the clinician wait after each N2O increase before evaluating the effect?",
      options: [
        "30 seconds, as the brain responds almost immediately to each dose change",
        "10 minutes, to allow for full distribution throughout the central nervous system",
        "Several minutes, as the brain requires approximately 3–5 minutes to process each dose",
        "1 minute, which is sufficient time for N2O to equilibrate in the bloodstream"
      ],
      correctAnswer: 2
    },
    {
      id: 97051,
      question: "In the titration process, by what percentage increments should N2O be increased?",
      options: [
        "1–2% increments to ensure very fine control over sedation depth",
        "5–10% increments while observing patient response after each adjustment",
        "20–25% increments to reach the therapeutic range quickly and efficiently",
        "15–20% increments, as smaller changes have no observable clinical effect"
      ],
      correctAnswer: 1
    },
    {
      id: 97052,
      question: "What N2O concentration is exceeded when a patient — especially a child — enters moderate sedation?",
      options: [
        "30% nitrous oxide concentration",
        "40% nitrous oxide concentration",
        "50% nitrous oxide concentration",
        "60% nitrous oxide concentration"
      ],
      correctAnswer: 2
    },
    {
      id: 97053,
      question: "For how long must patients receive 100% oxygen after N2O-O2 sedation ends?",
      options: [
        "1 minute, which is sufficient to clear residual N2O from the lungs",
        "A minimum of 5 minutes to displace nitrous oxide from the respiratory system",
        "15 minutes, as N2O takes much longer to clear from the bloodstream",
        "30 minutes, due to the extended half-life of N2O in the central nervous system"
      ],
      correctAnswer: 1
    },
    {
      id: 97054,
      question: "What is diffusion hypoxia?",
      options: [
        "Hypoxia caused by N2O entering the pulmonary bullae in cystic fibrosis patients",
        "Inadequate oxygen in the alveoli when N2O diffuses out rapidly and dilutes oxygen at recovery",
        "Reduced tissue oxygenation resulting from cardiovascular disease during sedation",
        "A condition where the scavenging system removes too much oxygen from the treatment room"
      ],
      correctAnswer: 1
    },
    {
      id: 97055,
      question: "Which of the following is the most common complication of N2O-O2 sedation?",
      options: [
        "Loss of consciousness requiring emergency airway management",
        "Cardiac arrhythmia due to N2O's effects on the cardiovascular system",
        "Nausea, which occurs infrequently and is often linked to oversedation",
        "Corneal irritation requiring the patient to remove contact lenses immediately"
      ],
      correctAnswer: 2
    },
    {
      id: 97056,
      question: "What percentage of patients experience vomiting during N2O-O2 sedation?",
      options: [
        "Approximately 10% of patients, mostly children",
        "Approximately 5% of patients receiving moderate sedation",
        "Approximately 0.5% of patients (about 1 in 200)",
        "Approximately 20% of patients receiving higher N2O concentrations"
      ],
      correctAnswer: 2
    },
    {
      id: 97057,
      question: "Which symptoms indicate slight oversedation or heavier-than-intended sedation?",
      options: [
        "Relaxed shoulders, feet falling to the sides, and lips curled into a slight smile",
        "Acute hearing of distant sounds, visual confusion, sleepiness, and possible nausea",
        "Normal vital signs with increased patient cooperation and reduced gag reflex",
        "Slow blink rate, mild lacrimation, and tingling in the extremities"
      ],
      correctAnswer: 1
    },
    {
      id: 97058,
      question: "What are the signs of serious oversedation with N2O?",
      options: [
        "Relaxed muscles, decreased blood pressure, and mild facial flushing",
        "Tingling in extremities, warmth sensation, and slightly slowed speech",
        "Vomiting and loss of consciousness",
        "Mild perspiration, lacrimation, and decreased gag reflex activity"
      ],
      correctAnswer: 2
    },
    {
      id: 97059,
      question: "Chronic occupational exposure to N2O is associated with which health risk?",
      options: [
        "Elevated blood pressure and kidney stones in long-term users",
        "Increased risk of skin allergies due to contact with the nasal hood material",
        "Reduced fertility, increased risk of spontaneous abortion, and neurologic disease",
        "Progressive hearing loss due to extended exposure to the gas delivery equipment"
      ],
      correctAnswer: 2
    },
    {
      id: 97060,
      question: "What is the NIOSH-recommended maximum occupational exposure limit for N2O during administration?",
      options: [
        "No more than 100 ppm, averaged over a full working week",
        "No more than 50 ppm per eight-hour working day",
        "No more than 25 ppm during administration",
        "No more than 10 ppm, measured at the clinician's breathing zone"
      ],
      correctAnswer: 2
    },
    {
      id: 97061,
      question: "Which of the following methods helps minimize occupational N2O exposure?",
      options: [
        "Increasing N2O concentration to shorten appointment time and reduce total exposure",
        "Using a scavenging system capable of moving 45 L/min of air, vented outdoors",
        "Removing the reservoir bag from the circuit to reduce gas accumulation",
        "Instructing the patient to breathe through the mouth to reduce exhaled N2O levels"
      ],
      correctAnswer: 1
    },
    {
      id: 97062,
      question: "According to CDHO standards, in Ontario, who is authorized to administer N2O-O2 sedation?",
      options: [
        "Any licensed dental hygienist with appropriate N2O training and certification",
        "The dental hygienist working independently under standing orders",
        "The dentist, an appropriately trained registered nurse, or a respiratory therapist",
        "A dental assistant supervised by the dental hygienist during the procedure"
      ],
      correctAnswer: 2
    },
    {
      id: 97063,
      question: "Under CDHO standards, who must be present in the room while a client is receiving N2O-O2 sedation?",
      options: [
        "Only the dental hygienist performing treatment, to minimize room crowding",
        "The dentist, nurse, or respiratory therapist must be present for the entire time",
        "A second dental hygienist who monitors the sedation while the first treats the patient",
        "Any licensed healthcare professional available in the office suite"
      ],
      correctAnswer: 1
    },
    {
      id: 97064,
      question: "What must be documented in the patient record after N2O-O2 sedation?",
      options: [
        "Only the percentage of N2O used and the patient's verbal feedback on the experience",
        "Pre and post vital signs, N2O/O2 concentrations, duration, recovery oxygen time, patient response, and clinician signature",
        "The name of the N2O machine used and the cylinder lot numbers for safety tracking",
        "The patient's ASA classification only, as other data is stored in the machine logs"
      ],
      correctAnswer: 1
    },
    {
      id: 97065,
      question: "What does the ASA Physical Status Classification System help determine before N2O-O2 sedation?",
      options: [
        "The exact dose of N2O in milligrams required based on the patient's weight",
        "The patient's previous experience with sedation and likelihood of anxiety",
        "The patient's suitability and safety for sedation based on systemic health status",
        "The type of nasal hood most appropriate for the patient's anatomy"
      ],
      correctAnswer: 2
    },
    {
      id: 97066,
      question: "A patient with severe systemic disease that is a constant threat to life would be classified as:",
      options: [
        "ASA I — a healthy patient with no significant medical history",
        "ASA II — a patient with mild, well-controlled systemic disease",
        "ASA III — a patient with severe systemic disease limiting activity",
        "ASA IV — a patient whose systemic disease is a constant threat to life"
      ],
      correctAnswer: 3
    },
    {
      id: 97067,
      question: "What is tidal volume as it relates to N2O-O2 administration?",
      options: [
        "The maximum volume of gas that can be stored in the reservoir bag",
        "The amount of air a person needs for one complete respiration cycle, typically 6–8 L for adults",
        "The percentage of N2O in the total gas flow delivered to the patient",
        "The volume of gas scavenged from the operatory per minute by the vacuum system"
      ],
      correctAnswer: 1
    },
    {
      id: 97068,
      question: "Which cylinder size is used for portable N2O-O2 units?",
      options: [
        "Size A cylinders for both nitrous oxide and oxygen",
        "Size G cylinders for nitrous oxide and H for oxygen",
        "Size E cylinders for both nitrous oxide and oxygen",
        "Size H cylinders for portable units and size G for central systems"
      ],
      correctAnswer: 2
    },
    {
      id: 97069,
      question: "Gas cylinders must never come into contact with grease, oil, or lubricants because:",
      options: [
        "These substances corrode the cylinder valve and cause gas leaks over time",
        "They alter the chemical composition of N2O making it toxic to inhale",
        "These substances may contribute to combustion due to N2O's oxidizing properties",
        "Oil coating the cylinder interferes with accurate pressure gauge readings"
      ],
      correctAnswer: 2
    },
    {
      id: 97070,
      question: "How should cylinder valves be operated to prevent confusion about whether the tank is open or closed?",
      options: [
        "Valves should be opened fully so gas flows freely and the gauge reads accurately",
        "Valves should be opened halfway before use and closed promptly when finished",
        "Valves should be opened a quarter turn only and left open between appointments",
        "Valves should remain permanently open when cylinders are attached to the machine"
      ],
      correctAnswer: 1
    },
    {
      id: 97071,
      question: "Which of the following is a benefit of N2O for patients undergoing lengthy dental procedures?",
      options: [
        "N2O eliminates the need for positional adjustments throughout the procedure",
        "N2O has mild amnesic properties that make time seem to pass more quickly",
        "N2O provides complete analgesia, removing all discomfort during long procedures",
        "N2O permanently reduces patient anxiety about future dental appointments"
      ],
      correctAnswer: 1
    },
    {
      id: 97072,
      question: "Patients with cerebral palsy or developmental disabilities are candidates for N2O-O2 sedation provided that:",
      options: [
        "They weigh less than 50 kg and can be monitored with a pulse oximeter continuously",
        "They are accompanied by a family member who can consent on their behalf",
        "They can communicate with the operator, breathe through the nose, and cooperate with the mask",
        "They have been pre-medicated with oral benzodiazepines before the appointment"
      ],
      correctAnswer: 2
    },
    {
      id: 97073,
      question: "What is the recommended scavenging system flow rate and ventilation method?",
      options: [
        "20 L/min, recirculated through an in-room air purifier with HEPA filtration",
        "45 L/min, vented to the outside of the building away from windows and air intakes",
        "60 L/min, vented back into the central HVAC system of the dental building",
        "10 L/min, filtered through an activated charcoal canister before room release"
      ],
      correctAnswer: 1
    },
    {
      id: 97074,
      question: "Which statement about the nasal hood used for N2O delivery is correct?",
      options: [
        "Nasal hoods must always be single-use disposable and can never be autoclaved",
        "All nasal hoods are universal size and do not require individual patient fitting",
        "Some nasal hoods can be autoclaved and reused; others are single-patient use",
        "Scented nasal hoods are not available and all hoods deliver odorless gas only"
      ],
      correctAnswer: 2
    },
    {
      id: 97075,
      question: "What is a double-hood (hood-in-hood) nasal delivery system designed to do?",
      options: [
        "Deliver a higher concentration of N2O using two separate inlet hoses simultaneously",
        "Provide a backup delivery path if one hose becomes kinked or obstructed",
        "Use an outer hood to scavenge exhaled waste gases after patient exhalation",
        "Allow two patients to receive sedation simultaneously in adjacent dental chairs"
      ],
      correctAnswer: 2
    },
    {
      id: 97076,
      question: "What are the three main categories into which N2O-O2 sedation armamentarium is divided?",
      options: [
        "Regulators, flowmeters, and scavenging systems",
        "Cylinders, gas machines, and delivery systems",
        "Nasal hoods, gas hoses, and reservoir bags",
        "Oxygen flush valves, pressure gauges, and yoke assemblies"
      ],
      correctAnswer: 1
    },
    {
      id: 97077,
      question: "What does the oxygen flush button on the gas machine do?",
      options: [
        "It terminates N2O flow and switches the machine to room air automatically",
        "It delivers 100% oxygen rapidly into the reservoir bag for emergency use",
        "It purges the delivery lines of any residual N2O before the next patient",
        "It increases oxygen pressure to compensate when a cylinder is running low"
      ],
      correctAnswer: 1
    },
    {
      id: 97078,
      question: "What does the flowmeter on a gas machine measure?",
      options: [
        "The pressure of each gas inside the cylinder in pounds per square inch",
        "The percentage of each gas remaining in the cylinder based on weight",
        "The rate of flow of each gas in liters and the combined total flow",
        "The oxygen saturation of the gas mixture delivered to the patient"
      ],
      correctAnswer: 2
    },
    {
      id: 97079,
      question: "What does N2O's low solubility in blood contribute to clinically?",
      options: [
        "A prolonged recovery period requiring extended post-sedation oxygen",
        "A rapid onset of sedative effects compared to many other anesthetic gases",
        "Slower absorption requiring higher concentrations to achieve adequate sedation",
        "Extensive metabolism in the liver before the drug reaches the brain"
      ],
      correctAnswer: 1
    },
    {
      id: 97080,
      question: "What happens physiologically when N2O enters the bloodstream through the lungs?",
      options: [
        "It binds irreversibly to hemoglobin, displacing oxygen from red blood cells",
        "It is metabolized by the liver into inactive compounds that are renally excreted",
        "It displaces nitrogen and exits the body unchanged through the lungs",
        "It crosses the blood-brain barrier and permanently alters GABA receptor function"
      ],
      correctAnswer: 2
    },
    {
      id: 97081,
      question: "What should the clinician do if the patient's inability to keep their eyes open is observed during sedation?",
      options: [
        "Reassure the patient and maintain the current N2O concentration",
        "Increase the N2O concentration, as this sign indicates the patient needs more sedation",
        "Decrease the N2O concentration, as this sign indicates deeper sedation than intended",
        "Immediately terminate the procedure and administer 100% oxygen for 15 minutes"
      ],
      correctAnswer: 2
    },
    {
      id: 97082,
      question: "Why do clients under N2O influence sometimes tune in to distant background sounds?",
      options: [
        "N2O selectively enhances auditory cortex activity, sharpening hearing acuity",
        "N2O suppresses nearby sounds, making distant sounds proportionally louder",
        "N2O affects all sensations and may alter the way auditory stimuli are processed",
        "Patients become hypervigilant due to anxiety, causing them to focus on distractions"
      ],
      correctAnswer: 2
    },
    {
      id: 97083,
      question: "What discharge criterion must a patient meet before being dismissed after N2O-O2 sedation?",
      options: [
        "The patient must have a companion present to drive them home after treatment",
        "The patient must be alert, oriented, and returned to normal physiologic and emotional status",
        "The patient must score at least 90% on an orientation questionnaire administered by the staff",
        "The patient must wait 30 minutes after mask removal regardless of subjective recovery status"
      ],
      correctAnswer: 1
    },
    {
      id: 97084,
      question: "What postoperative phenomenon may cause a patient to feel cold or shiver during recovery?",
      options: [
        "A drop in body temperature caused by the cool gas flowing through the nasal hood",
        "Vasoconstriction occurring as nitrous oxide leaves the body during recovery",
        "Hypoglycemia triggered by N2O's effect on glucose metabolism after sedation",
        "Dehydration resulting from mouth breathing throughout the dental procedure"
      ],
      correctAnswer: 1
    },
    {
      id: 97085,
      question: "Which of the following correctly describes pneumoencephalography and its relevance to N2O?",
      options: [
        "It is a blood test that measures N2O metabolites and is not relevant to gas use",
        "It is a procedure where gas replaces cerebrospinal fluid; N2O is contraindicated afterward",
        "It is a lung imaging technique used to confirm COPD before sedation is approved",
        "It is a hearing test used to assess whether N2O has altered auditory perception"
      ],
      correctAnswer: 1
    },
    {
      id: 97086,
      question: "What is N2O psychosedation?",
      options: [
        "Deep sedation that induces a psychedelic state requiring hospital monitoring",
        "A method of sedation that uses psychological techniques alongside inhalation gas",
        "A term referring to N2O acting on the CNS so pain impulses are not relayed or are reinterpreted",
        "Sedation combined with antipsychotic medications for psychiatric dental patients"
      ],
      correctAnswer: 2
    },
    {
      id: 97087,
      question: "Approximately what percentage of patients achieve adequate sedation with less than 50% N2O?",
      options: [
        "About 30% of patients, with most requiring higher concentrations",
        "About 50% of patients, evenly divided between low and high responders",
        "About 70% of patients, with optimal sedation usually in the 30–40% range",
        "About 90% of patients, with very few requiring concentrations above 30%"
      ],
      correctAnswer: 2
    },
    {
      id: 97088,
      question: "What documentation phrase must appear in the patient record regarding the recovery phase?",
      options: [
        "\"Patient denied adverse effects\" signed by the dental hygienist",
        "Patient received a minimum of 5 minutes of 100% oxygen and was alert and oriented before dismissal",
        "\"Full recovery confirmed by specialist\" countersigned by the supervising dentist",
        "\"Vitals within normal limits\" checked at least three times during the recovery phase"
      ],
      correctAnswer: 1
    },
    {
      id: 97089,
      question: "How does N2O affect patients with psychotic disorders requiring extra caution?",
      options: [
        "N2O directly counteracts the therapeutic effects of antipsychotic medications",
        "Patients with psychoses cannot breathe through the nose due to medication side effects",
        "The combination of antipsychotic medications and N2O can be unpredictable and variable",
        "N2O causes permanent changes in dopamine receptors in patients with psychoses"
      ],
      correctAnswer: 2
    },
    {
      id: 97090,
      question: "According to the CDHO, what must occur before a client is sedated with N2O-O2?",
      options: [
        "The dental hygienist must obtain a specialist referral and anesthesiology consultation",
        "The client must undergo a fasting period of at least 4 hours before the appointment",
        "Informed consent must be obtained by the dental hygienist before the client is sedated",
        "The client must complete a psychological readiness assessment approved by the RCDSO"
      ],
      correctAnswer: 2
    },
    {
      id: 97091,
      question: "N2O is metabolized by the liver and excreted by the kidneys after sedation.",
      options: [
        "True",
        "False",
      ],
      correctAnswer: 1
    },
    {
      id: 97092,
      question: "In Ontario, dental hygienists are authorized to independently administer nitrous oxide and oxygen for conscious sedation.",
      options: [
        "True",
        "False",
      ],
      correctAnswer: 1
    },
    {
      id: 97093,
      question: "Condensation on the outside of a nitrous oxide cylinder during use indicates a gas leak and requires immediate cylinder replacement.",
      options: [
        "True",
        "False",
      ],
      correctAnswer: 1
    },
    {
      id: 97094,
      question: "The pressure gauge on an oxygen cylinder accurately reflects the amount of oxygen remaining.",
      options: [
        "True",
        "False",
      ],
      correctAnswer: 0
    },
    {
      id: 97095,
      question: "Patients who receive appropriate recovery oxygenation after N2O-O2 sedation are generally able to drive home and return to normal activities.",
      options: [
        "True",
        "False",
      ],
      correctAnswer: 0
    },
    {
      id: 97096,
      question: "Modern N2O-O2 machines can deliver nitrous oxide concentrations greater than 70% when clinically necessary.",
      options: [
        "True",
        "False",
      ],
      correctAnswer: 1
    },
    {
      id: 97097,
      question: "N2O is nonallergenic and nonirritating to the respiratory system.",
      options: [
        "True",
        "False",
      ],
      correctAnswer: 0
    },
    {
      id: 97098,
      question: "The dentist or authorized monitor must be present in the treatment room for the entire time the client is receiving N2O-O2 sedation in Ontario.",
      options: [
        "True",
        "False",
      ],
      correctAnswer: 0
    },
    {
      id: 97099,
      question: "Nausea is the most common complication of N2O-O2 sedation, occurring in approximately half of all patients.",
      options: [
        "True",
        "False",
      ],
      correctAnswer: 1
    },
    {
      id: 97100,
      question: "N2O-O2 sedation is a weak analgesic but a potent anesthetic on its own.",
      options: [
        "True",
        "False",
      ],
      correctAnswer: 1
    }
  ],
  "7. Introduction to Orthodontics": [
    {
      id: 98001,
      question: "What is the definition of orthodontics?",
      options: [
        "The branch of dentistry that focuses only on tooth whitening and cosmetic procedures",
        "The branch of dentistry that diagnoses, prevents, and treats dental and facial irregularities",
        "The surgical specialty that corrects jaw fractures and oral trauma injuries",
        "The branch of dentistry that manages gum disease and periodontal conditions"
      ],
      correctAnswer: 1
    },
    {
      id: 98002,
      question: "What does the term \"dentofacial orthopedics\" refer to in orthodontics?",
      options: [
        "The process of placing dental implants to replace missing teeth in the jawbone",
        "The cosmetic procedure used to veneer and reshape individual teeth surfaces",
        "The use of a fixed or removable appliance inside or outside the mouth to correct tooth movement or jaw growth",
        "The surgical technique for removing impacted wisdom teeth from the lower jaw"
      ],
      correctAnswer: 2
    },
    {
      id: 98003,
      question: "Which of the following is a type of treatment provided by orthodontics?",
      options: [
        "Straightening teeth that are rotated, tilted, or improperly aligned",
        "Placing porcelain veneers on the labial surfaces of anterior teeth",
        "Performing root canal therapy on infected posterior molar teeth",
        "Applying bleaching agents to remove extrinsic staining from enamel"
      ],
      correctAnswer: 0
    },
    {
      id: 98004,
      question: "How does malocclusion contribute to dental disease?",
      options: [
        "It directly causes pulp necrosis by transmitting excessive occlusal forces to the root apex",
        "It increases the risk of temporomandibular joint disorders by displacing the condyle posteriorly",
        "When teeth do not receive normal occlusion and natural cleansing, proper plaque removal becomes difficult",
        "It disrupts the cementum layer, exposing the dentinal tubules to bacterial invasion and sensitivity"
      ],
      correctAnswer: 2
    },
    {
      id: 98005,
      question: "What is the primary area of study emphasis for an orthodontist?",
      options: [
        "Operative dentistry techniques, dental materials science, and crown fabrication methods",
        "Orofacial growth and development, new techniques, biomechanics, and research",
        "Periodontal surgery, bone grafting procedures, and guided tissue regeneration protocols",
        "Pharmacology, local anesthetic techniques, and pain management for dental procedures"
      ],
      correctAnswer: 1
    },
    {
      id: 98006,
      question: "The orthodontic office patient care area can be sectioned to serve three functions. Which of the following is one of those three functions?",
      options: [
        "To perform surgical extractions and manage post-operative patient recovery",
        "To store orthodontic materials, instruments, and sterilization equipment securely",
        "To take radiographs as part of records and diagnostic imaging procedures",
        "To dispense prescriptions and provide pharmacological consultations for patients"
      ],
      correctAnswer: 2
    },
    {
      id: 98007,
      question: "What is the most common cause of malocclusion?",
      options: [
        "Poor oral hygiene habits leading to extensive dental caries and tooth loss early in life",
        "A disproportion in size between the jaw and teeth, or between the upper and lower jaws",
        "Prolonged use of orthodontic appliances causing root resorption and alveolar bone loss",
        "Nutritional deficiencies during childhood affecting the development of dental enamel"
      ],
      correctAnswer: 1
    },
    {
      id: 98008,
      question: "How is malocclusion defined according to Angle's classification system?",
      options: [
        "Any tooth that requires extraction due to severe crowding or impaction in the dental arch",
        "A jaw relationship in which the mandible is positioned more than 5 mm posterior to the maxilla",
        "Occlusion that deviates from a Class I normal occlusion due to irregularities in tooth positions and bite relationships",
        "A condition in which the upper and lower dental midlines are misaligned by more than 2 mm"
      ],
      correctAnswer: 2
    },
    {
      id: 98009,
      question: "Which of the following is a developmental cause of malocclusion?",
      options: [
        "Prolonged thumb-sucking habit that persists beyond the primary dentition stage",
        "Trauma to the jaw during birth resulting in condylar fracture or displacement",
        "A genetic disproportion between the size of the teeth and the size of the jaw",
        "Ectopic eruption resulting in an abnormal direction of tooth eruption"
      ],
      correctAnswer: 3
    },
    {
      id: 98010,
      question: "Which of the following best describes a genetic cause of malocclusion?",
      options: [
        "Fetal molding in which fetal limbs press against the face, distorting rapidly growing areas",
        "Tongue thrusting that applies persistent pressure against the anterior teeth during swallowing",
        "A child inheriting a mother's small jaw and a father's large teeth, resulting in crowding",
        "Premature loss of a primary tooth causing adjacent teeth to drift into the space"
      ],
      correctAnswer: 2
    },
    {
      id: 98011,
      question: "Which of the following habits is listed as an environmental cause of malocclusion?",
      options: [
        "Delayed eruption of permanent teeth due to lack of space in the dental arch",
        "Congenitally missing teeth caused by interruption of tooth bud formation",
        "Bruxism, which involves grinding or clenching of the teeth",
        "Ectopic eruption of a permanent tooth in an abnormal direction or position"
      ],
      correctAnswer: 2
    },
    {
      id: 98012,
      question: "In Class I malocclusion, which statement is most accurate?",
      options: [
        "The mandible is positioned distally relative to the maxilla, causing a retrognathic facial profile",
        "There is a normal molar relationship, but the anterior teeth are out of alignment or malpositioned",
        "The mandible protrudes anteriorly, causing mandibular incisors to extend in front of maxillary incisors",
        "There is an excessive vertical overlap of the maxillary incisors covering the mandibular incisors"
      ],
      correctAnswer: 1
    },
    {
      id: 98013,
      question: "What is another term used to describe Class II malocclusion?",
      options: [
        "Mesioclusion, referring to the mesial positioning of the mandibular arch relative to the maxilla",
        "Neutrocclusion, referring to a normal first molar relationship with anterior dental crowding",
        "Distoclusion, referring to the abnormal distal relationship of the mandible to the maxilla",
        "Prognathism, referring to the anterior protrusion of the lower jaw beyond the upper jaw"
      ],
      correctAnswer: 2
    },
    {
      id: 98014,
      question: "What facial profile is associated with Class III malocclusion?",
      options: [
        "Retrognathic, characterized by a recessive mandible positioned distally to the maxilla",
        "Mesognathic, characterized by a balanced and proportionate facial skeletal relationship",
        "Orthognathic, characterized by ideal alignment of both the maxilla and mandible",
        "Prognathic, characterized by an abnormal mesial relationship of the mandible to the maxilla"
      ],
      correctAnswer: 3
    },
    {
      id: 98015,
      question: "What is an overjet?",
      options: [
        "An increased vertical overlap of the maxillary incisors over the mandibular incisors",
        "A lack of vertical overlap resulting in an anterior open space when teeth are occluded",
        "An excessive horizontal protrusion of maxillary incisors creating space between upper and lower incisor surfaces",
        "A condition where the upper posterior teeth fit inside the lower posterior teeth"
      ],
      correctAnswer: 2
    },
    {
      id: 98016,
      question: "What defines an overbite?",
      options: [
        "A horizontal protrusion of the maxillary incisors beyond the mandibular incisors",
        "An increased vertical overlap of the maxillary incisors over the mandibular incisors",
        "An absence of vertical overlap creating an open space between anterior teeth when biting",
        "A condition where one or more teeth are not aligned with their opposing counterpart"
      ],
      correctAnswer: 1
    },
    {
      id: 98017,
      question: "What is a cross-bite?",
      options: [
        "A condition where the upper and lower dental midlines do not align symmetrically",
        "A forward horizontal projection of the maxillary incisors beyond the lower incisors",
        "A vertical gap between upper and lower anterior teeth when the posterior teeth are in occlusion",
        "A condition where a tooth is not properly aligned with its opposing tooth in the other arch"
      ],
      correctAnswer: 3
    },
    {
      id: 98018,
      question: "Which of the following best describes crowding as a type of malalignment?",
      options: [
        "A lack of vertical overlap of the maxillary incisors resulting in anterior open bite",
        "An excessive protrusion of maxillary incisors causing horizontal space between arches",
        "One or many teeth involved in misplacement, making it the most common contributor to malocclusion",
        "A condition where upper teeth occlude on the lingual side of the lower posterior teeth"
      ],
      correctAnswer: 2
    },
    {
      id: 98019,
      question: "What is used in the orthodontic records process to evaluate specific orthodontic concerns?",
      options: [
        "A periapical radiograph series covering all teeth in both the maxillary and mandibular arches",
        "A dental history as part of the overall medical and dental history assessment",
        "A full-mouth debridement to assess periodontal health prior to orthodontic appliance placement",
        "A CBCT scan to evaluate three-dimensional bone volume and tooth root positions"
      ],
      correctAnswer: 1
    },
    {
      id: 98020,
      question: "What is the purpose of the physical growth evaluation in orthodontic records?",
      options: [
        "To determine the patient's nutritional habits and assess their impact on dental development",
        "To screen for systemic diseases that may affect healing after orthodontic band placement",
        "To evaluate the family's dental history and establish a hereditary risk for malocclusion",
        "Because orthodontic treatment in children is closely related to growth stages"
      ],
      correctAnswer: 3
    },
    {
      id: 98021,
      question: "What does the clinical examination in orthodontics evaluate?",
      options: [
        "The patient's nutritional status, vitamin D levels, and calcium intake for bone support",
        "The degree of tooth discoloration, surface wear, and enamel erosion from dietary acids",
        "Facial esthetics, oral health, and jaw and occlusal function",
        "The periodontal pocket depths, furcation involvement, and bone loss around all teeth"
      ],
      correctAnswer: 2
    },
    {
      id: 98022,
      question: "Photographs in orthodontics are useful as an aid in which of the following?",
      options: [
        "Determining the correct arch wire size and material for initial bracket placement",
        "Patient identification, treatment planning, case presentation, case documentation, and education",
        "Selecting the appropriate cement type for molar band cementation procedures",
        "Calculating the tooth size discrepancy between the maxillary and mandibular arches"
      ],
      correctAnswer: 1
    },
    {
      id: 98023,
      question: "How many standard extraoral photographs are routinely taken in orthodontics?",
      options: [
        "Four photographs: frontal, profile, three-quarter view, and submental vertex view",
        "Three photographs: frontal smiling, frontal resting, and profile view with lips closed",
        "Two photographs: a frontal view and a profile view",
        "Five photographs covering all facial angles and submental perspectives for full analysis"
      ],
      correctAnswer: 2
    },
    {
      id: 98024,
      question: "What is the panoramic radiograph used for in orthodontics?",
      options: [
        "To evaluate the bone density, trabecular pattern, and height of the alveolar crestal bone",
        "To measure the cephalometric landmarks and calculate facial growth patterns and angles",
        "To view the eruption process of primary and permanent teeth and evaluate available space",
        "To assess root morphology, periapical pathology, and periodontal bone levels of individual teeth"
      ],
      correctAnswer: 2
    },
    {
      id: 98025,
      question: "What is cephalometric analysis performed on?",
      options: [
        "A three-dimensional CBCT reconstruction of the patient's maxilla and mandible",
        "A tracing or computerized drawing that emphasizes the relationships among selected landmark points",
        "A panoramic radiograph with measurement overlays applied directly to the original image",
        "A set of diagnostic study casts trimmed and articulated in the patient's occlusal relationship"
      ],
      correctAnswer: 1
    },
    {
      id: 98026,
      question: "What are diagnostic casts primarily used for in orthodontics?",
      options: [
        "To take impressions for the fabrication of custom mouthguards and night guards",
        "To create a record of the patient's occlusion at the start and end of treatment",
        "For the diagnosis, case presentation of the orthodontic patient, and space analysis of the dentition",
        "To fabricate retainers and positioners after the completion of active orthodontic treatment"
      ],
      correctAnswer: 2
    },
    {
      id: 98027,
      question: "What is the function of the orthodontic scaler?",
      options: [
        "To remove supragingival and subgingival calculus during periodontal maintenance appointments",
        "To help seat and remove molar bands during the cementation and debanding procedures",
        "Used in bracket placement, removal of elastomeric rings, and removal of excess cement or bonding material",
        "To guide the arch wire into the bracket slot during the initial wire placement appointment"
      ],
      correctAnswer: 2
    },
    {
      id: 98028,
      question: "What is the ligature director used for?",
      options: [
        "To carry and precisely place the bonded bracket onto the tooth surface during bonding",
        "To help seat the molar band firmly against the gingival margin during cementation",
        "To hold, bend, and adjust the shape of arch wires during adjustment appointments",
        "To guide the elastic or wire ligature tie around the bracket and tuck the cut end under the arch wire"
      ],
      correctAnswer: 3
    },
    {
      id: 98029,
      question: "What is the band plugger used for?",
      options: [
        "To carry and place the bonded bracket onto the prepared tooth surface during bonding",
        "To guide the wire ligature tie into position around the bracket wings and arch wire",
        "To help seat a molar band for a fixed appliance by pressing it snugly into position",
        "To remove a cemented molar band at the end of active orthodontic treatment"
      ],
      correctAnswer: 2
    },
    {
      id: 98030,
      question: "What is the function of the bracket placement tweezers?",
      options: [
        "To help seat the molar band by applying occlusal pressure during cementation procedures",
        "To cut the ligature wire during removal of the arch wire at adjustment appointments",
        "To guide the elastic or wire ligature tie around the bracket wings of the fixed appliance",
        "To carry and place the bonded bracket onto the tooth surface during bracket bonding"
      ],
      correctAnswer: 3
    },
    {
      id: 98031,
      question: "What are bird-beak pliers used for in orthodontics?",
      options: [
        "To remove molar bands by breaking the seal of cement at the gingival margin",
        "To form and bend wires into the desired shapes for orthodontic appliances",
        "To place and ligate the arch wire through the bracket slots during wire insertion",
        "To close and adjust clasps on removable orthodontic appliances"
      ],
      correctAnswer: 1
    },
    {
      id: 98032,
      question: "What is the primary use of Weingart utility pliers?",
      options: [
        "To confer and adjust the contour of the stainless steel molar bands before cementation",
        "To close and tighten the clasps on removable appliances like Hawley retainers",
        "To form, bend, and shape orthodontic wires for fixed and removable appliances",
        "In placing arch wires through the edgewise bracket slots and buccal tubes"
      ],
      correctAnswer: 3
    },
    {
      id: 98033,
      question: "What is the function of three-prong pliers in orthodontics?",
      options: [
        "To hold and stabilize the arch wire while ligating it to the bracket with elastic ties",
        "To remove molar bands by applying occlusal force through the biting surface",
        "To close and adjust clasps on removable orthodontic appliances",
        "To confer the shape of stainless steel molar bands to match individual tooth anatomy"
      ],
      correctAnswer: 2
    },
    {
      id: 98034,
      question: "What makes Howe (110) pliers versatile in orthodontic practice?",
      options: [
        "They have a curved, narrow tip that allows precise insertion of wires into bracket slots",
        "They are spring-loaded, allowing single-handed operation during arch wire ligating",
        "They have a round, flat, wide tip making them suitable for holding orthodontic materials and appliances intraorally",
        "They have serrated beaks specifically designed for gripping and carrying bonded brackets"
      ],
      correctAnswer: 2
    },
    {
      id: 98035,
      question: "What is the correct sequence of appointments for fixed appliance therapy?",
      options: [
        "Bonding of brackets, cementation of molar bands, placement of separators, insertion of arch wire, adjustments, removal, retention",
        "Placement of separators, cementation of molar bands, bonding of brackets, insertion of arch wire, adjustments, removal, retention",
        "Cementation of molar bands, placement of separators, bonding of brackets, insertion of arch wire, adjustments, removal, retention",
        "Insertion of arch wire, placement of separators, bonding of brackets, cementation of molar bands, adjustments, removal, retention"
      ],
      correctAnswer: 1
    },
    {
      id: 98036,
      question: "What is the purpose of placing separators before molar band placement?",
      options: [
        "To apply fluoride to the proximal surfaces and reduce the risk of white spot lesions",
        "To create space between the teeth so that the molar bands can be properly fitted",
        "To stabilize the arch and prevent tooth movement during the initial bonding appointment",
        "To reduce patient anxiety and sensitivity before the cementation appointment begins"
      ],
      correctAnswer: 1
    },
    {
      id: 98037,
      question: "What are orthodontic bands made of and where are they placed?",
      options: [
        "Ceramic or composite materials bonded directly to the labial surfaces of anterior teeth",
        "Flexible plastic formed over a model and fitted over all teeth in the arch",
        "Gold alloy cast in the laboratory and cemented to all posterior teeth in both arches",
        "Pre-formed stainless steel bands that are fitted and cemented to molar teeth"
      ],
      correctAnswer: 3
    },
    {
      id: 98038,
      question: "In what six directions can a fixed appliance move a tooth?",
      options: [
        "Anteriorly, posteriorly, superiorly, inferiorly, clockwise, and counterclockwise",
        "Mesially, distally, lingually, facially, apically, and occlusally",
        "Buccally, lingually, vertically, horizontally, rotationally, and torquingly",
        "Labially, palatally, inferiorly, superiorly, medially, and laterally"
      ],
      correctAnswer: 1
    },
    {
      id: 98039,
      question: "What is the function of headgear tubes?",
      options: [
        "Rectangular tubes placed on the buccal surfaces of molar bands to receive the arch wire",
        "Hooks located on the facial surface of molar bands to hold interarch rubber elastics",
        "Round tubes on maxillary first molar bands used for insertion of the inner bow of a facebow",
        "Button attachments on the lingual portion of bands to stabilize the arch and reinforce anchorage"
      ],
      correctAnswer: 2
    },
    {
      id: 98040,
      question: "What is the purpose of edgewise tubes in orthodontic treatment?",
      options: [
        "Round tubes placed on maxillary first molar bands for insertion of the inner bow of the facebow",
        "Rectangular tubes placed on buccal surfaces of upper and lower first molar bands to receive the arch wire",
        "Hooks on the facial surfaces of molar bands used to hold interarch elastics in position",
        "Lingual buttons or brackets that stabilize the arch and reinforce anchorage and tooth movement"
      ],
      correctAnswer: 1
    },
    {
      id: 98041,
      question: "What is the purpose of labial hooks in orthodontic appliances?",
      options: [
        "To receive the end of the arch wire as it exits the buccal tube on the molar band",
        "To ligate the arch wire to the bracket wings using steel wire or elastic ties",
        "To hold interarch elastics by being located on the facial surfaces of first and second molar bands",
        "To stabilize the arch on the lingual side and reinforce anchorage during tooth movement"
      ],
      correctAnswer: 2
    },
    {
      id: 98042,
      question: "What is an arch wire and what does it do in orthodontic treatment?",
      options: [
        "A stainless steel band that encircles the molar to provide anchorage for the fixed appliance",
        "A preformed thin wire placed within the bracket that provides a pattern for the dental arch and guides tooth movement",
        "An elastic product used in chains to close spaces between teeth and correct rotated teeth",
        "A wire ligature tied around the bracket wings to secure the arch wire in the bracket slot"
      ],
      correctAnswer: 1
    },
    {
      id: 98043,
      question: "Which arch wire material is used specifically for its flexibility to initiate movement?",
      options: [
        "Stainless steel wire, which provides the stiffest and strongest forces for final detailing",
        "Beta titanium (TMA), which combines strength, flexibility, and shape memory properties",
        "Optiflex wire, which is used specifically for its esthetic appearance in the anterior region",
        "Nickel titanium (NiTi), which is selected for its flexibility to initiate tooth movement"
      ],
      correctAnswer: 3
    },
    {
      id: 98044,
      question: "What property distinguishes beta titanium (TMA) arch wire from other wire types?",
      options: [
        "It is the most flexible wire available and is used exclusively in the earliest stages of alignment",
        "It is the stiffest wire and is used only during the final stage of treatment for root positioning",
        "It provides a combination of strength, flexibility, and memory for mid-stage treatment",
        "It is completely esthetic and tooth-colored, making it ideal for adult orthodontic patients"
      ],
      correctAnswer: 2
    },
    {
      id: 98045,
      question: "When are square or rectangular arch wires typically used in treatment?",
      options: [
        "During the initial stages of treatment to begin leveling, aligning, and correcting crowding",
        "During the final stages of treatment to position the crown and root in the correct relationship",
        "During the retention phase to maintain tooth positions after appliance removal",
        "During the separator appointment to pre-align teeth before molar band placement"
      ],
      correctAnswer: 1
    },
    {
      id: 98046,
      question: "What are Kobayashi hooks in orthodontic treatment?",
      options: [
        "Round tubes soldered to molar bands to receive the inner bow of the facebow appliance",
        "Hooks formed from spot-welded ligature ties used for the attachment of elastics",
        "Pliers with three prongs specifically designed to close and adjust clasps on retainers",
        "Edgewise rectangular tubes welded to the buccal surfaces of molar bands for arch wire insertion"
      ],
      correctAnswer: 1
    },
    {
      id: 98047,
      question: "What are elastic chain ties used for in orthodontics?",
      options: [
        "To ligate the arch wire to individual brackets by wrapping around the bracket wings",
        "To hold the inner bow of the facebow appliance in the headgear tube on the molar band",
        "To close space between teeth or to correct rotated teeth by forming a continuous chain",
        "To protect the patient from discomfort by covering the protruding end of the arch wire"
      ],
      correctAnswer: 2
    },
    {
      id: 98048,
      question: "What is comfort tubing used for in orthodontic treatment?",
      options: [
        "To connect elastic chains between adjacent brackets to close spaces in the dental arch",
        "To hold interarch rubber bands between the upper and lower molar band hooks",
        "To close space or aid in the eruption of impacted teeth through elastic force",
        "To cover an arch wire that may be causing discomfort and aid in patient comfort"
      ],
      correctAnswer: 3
    },
    {
      id: 98049,
      question: "What is the vacuum-formed clear aligner used for in modern orthodontic treatment?",
      options: [
        "To replace all fixed appliances entirely and treat all forms of dental malocclusion",
        "For simple alignment of teeth using a computer-designed series of clear aligners",
        "To retain teeth in their final positions permanently after active treatment is complete",
        "To provide the same forces as headgear without the need for extraoral components"
      ],
      correctAnswer: 1
    },
    {
      id: 98050,
      question: "What does the chairside assistant check during an orthodontic adjustment visit?",
      options: [
        "Tooth color, gingival health, plaque levels, and the need for professional cleaning",
        "The patient's compliance with diet restrictions and elastic-wearing instructions",
        "Broken or missing arch wires, loose brackets and bands, and loose or missing ligatures and elastics",
        "The amount of tooth movement achieved and whether new records need to be taken"
      ],
      correctAnswer: 2
    },
    {
      id: 98051,
      question: "Why should sugar-containing foods be avoided during orthodontic treatment?",
      options: [
        "They cause staining of the elastic ties and brackets, making the appliance look unattractive",
        "They weaken cement beneath the bands and adhere to enamel, causing cavities",
        "They increase saliva production, which interferes with the bonding of brackets to enamel",
        "They reduce the effectiveness of the arch wire by chemically altering the metal alloy"
      ],
      correctAnswer: 1
    },
    {
      id: 98052,
      question: "What type of food is sticky food classified as in dietary guidelines for orthodontic patients?",
      options: [
        "A food that should be limited because it stains the brackets and elastic ties",
        "A food that is acceptable in small quantities because it does not affect the appliance",
        "A food that loosens bands, pulls out ligature ties, and may bend arch wires",
        "A food that should be avoided only during the first week after appliance placement"
      ],
      correctAnswer: 2
    },
    {
      id: 98053,
      question: "What is the facebow used for in orthodontic headgear treatment?",
      options: [
        "To apply occlusal force that extrudes the mandibular first molar in the lower arch",
        "To stabilize or move the maxillary first molar distally and create more room in the arch",
        "To hold the mandible in a forward position to stimulate growth and correct Class II cases",
        "To apply lingual pressure to the mandibular anterior teeth to correct anterior crowding"
      ],
      correctAnswer: 1
    },
    {
      id: 98054,
      question: "How is band removal accomplished at the end of orthodontic treatment?",
      options: [
        "By using a bracket debonding instrument to fracture the resin bonding material",
        "By dissolving the bonding agent with a solvent and peeling the bracket from the surface",
        "By breaking the seal of cement and lifting the bands off the tooth with a band remover",
        "By using an ultrasonic scaler to vibrate the cemented band loose from the molar tooth"
      ],
      correctAnswer: 2
    },
    {
      id: 98055,
      question: "Why is retention necessary after active orthodontic treatment?",
      options: [
        "To continue applying pressure to move teeth into their final corrected positions",
        "To allow gingival and periodontal tissues time for reorganization and to support teeth in an unstable position",
        "To prevent the patient from needing future orthodontic treatment later in life",
        "To replace the fixed appliance with a permanent wire bonded to the anterior teeth"
      ],
      correctAnswer: 1
    },
    {
      id: 98056,
      question: "What are the three types of retention appliances described in the lecture?",
      options: [
        "Clear aligner, fixed retainer, and removable positioner worn only during sleep",
        "Hawley retainer, lingual retainer, and Essix retainer made of clear thermoplastic material",
        "Orthodontic positioner, Hawley retainer, and lingual retainer",
        "Functional appliance, Hawley retainer, and vacuum-formed clear thermoplastic retainer"
      ],
      correctAnswer: 2
    },
    {
      id: 98057,
      question: "What are the three functions of the orthodontic positioner?",
      options: [
        "To close remaining spaces, align anterior teeth, and prevent relapse after treatment",
        "To retain teeth in position, allow the alveolus to rebuild support, and massage the gingiva",
        "To replace the arch wire during the final stage, reduce crowding, and align the midline",
        "To correct residual rotation, improve overbite, and prepare the arch for retainer delivery"
      ],
      correctAnswer: 1
    },
    {
      id: 98058,
      question: "What is a Hawley retainer?",
      options: [
        "A fixed lingual wire bonded from canine to canine on the lingual surfaces of lower incisors",
        "A vacuum-formed thermoplastic aligner that covers all teeth and provides passive retention",
        "A removable retainer worn to passively retain teeth in their new position after active treatment",
        "A spring-loaded removable appliance used to continue active tooth movement after braces"
      ],
      correctAnswer: 2
    },
    {
      id: 98059,
      question: "Where is a lingual retainer bonded and what is its purpose?",
      options: [
        "On the lingual surface of all posterior teeth from first molar to first molar in both arches",
        "On the buccal surfaces of the maxillary incisors to hold them in their corrected position",
        "From canine to canine on the lingual surfaces to maintain lower incisor position during late growth",
        "On the palatal surface of the maxillary arch to prevent relapse of the posterior crossbite"
      ],
      correctAnswer: 2
    },
    {
      id: 98060,
      question: "What is the primary benefit of orthodontic treatment for psychosocial problems?",
      options: [
        "It prevents the development of temporomandibular joint disorders and chronic facial pain",
        "It reduces the risk of periodontal disease by improving plaque removal access around teeth",
        "It improves swallowing patterns and eliminates oral dysfunction caused by jaw discrepancies",
        "It addresses the social impact of malocclusion and improves patients' self-esteem and feelings about themselves"
      ],
      correctAnswer: 3
    },
    {
      id: 98061,
      question: "Which statement best describes how dental trauma throughout life contributes to malocclusion?",
      options: [
        "Trauma causes ankylosis of the primary teeth, preventing them from exfoliating at the correct time",
        "Trauma can damage permanent tooth buds, cause tooth drift from premature primary tooth loss, or directly injure permanent teeth",
        "Trauma disrupts the eruption sequence by damaging the crypt of developing premolars",
        "Trauma causes resorption of the alveolar bone, reducing the space available for erupting teeth"
      ],
      correctAnswer: 1
    },
    {
      id: 98062,
      question: "How does the arch wire initiate tooth movement in a fixed appliance system?",
      options: [
        "By expanding the dental arch through activation of the expansion screw in the palatal plate",
        "By applying intermittent pressure through rubber elastics connected between upper and lower arches",
        "By the forces from the arch wire being transmitted to the tooth through the stabilized bracket",
        "By the cement bonding the molar band to the tooth, which transfers force directly to the root"
      ],
      correctAnswer: 2
    },
    {
      id: 98063,
      question: "What are the four types of arch wire materials described in the lecture?",
      options: [
        "Gold, stainless steel, titanium, and composite wires used in different stages of treatment",
        "Nickel titanium, stainless steel, beta titanium (TMA), and Optiflex",
        "Copper nickel titanium, stainless steel, cobalt chromium, and fiber-reinforced composite",
        "Nitinol, elgiloy, stainless steel, and beta titanium used in sequential stages"
      ],
      correctAnswer: 1
    },
    {
      id: 98064,
      question: "Why is the bite stick used in orthodontic appliance placement?",
      options: [
        "To guide the arch wire through the bracket slot and into the buccal tube on the molar",
        "To aid in seating a molar band for a fixed appliance",
        "To carry the bonded bracket to the tooth and position it at the correct height",
        "To remove excess cement from around the bracket base after band cementation"
      ],
      correctAnswer: 1
    },
    {
      id: 98065,
      question: "What is contouring pliers used for in orthodontic treatment?",
      options: [
        "To place and remove arch wires from the edgewise bracket slots during appointments",
        "To cut and trim excess ligature wire that extends beyond the bracket wings",
        "To close and adjust the clasps on removable orthodontic appliances",
        "In fitting bands by contouring the stainless steel to match the tooth anatomy"
      ],
      correctAnswer: 3
    },
    {
      id: 98066,
      question: "What is the lingual arch attachment's role in orthodontic treatment?",
      options: [
        "To provide attachment points for elastic chain ties to close spaces between anterior teeth",
        "To receive the inner bow of the facebow appliance through the headgear tube on the band",
        "A button or bracket on the lingual portion of the bands that stabilizes the arch and reinforces anchorage and tooth movement",
        "To hold the arch wire in the molar region and prevent it from sliding distally"
      ],
      correctAnswer: 2
    },
    {
      id: 98067,
      question: "What is the role of elastic thread in orthodontic treatment?",
      options: [
        "To ligate the arch wire to the bracket slots using a continuous chain of elastic rings",
        "A type of tubing used to close space or aid in the eruption of impacted teeth",
        "To connect the outer bow of the facebow to the neck strap or headcap for traction",
        "To cover a sharp or protruding arch wire end to improve patient comfort"
      ],
      correctAnswer: 1
    },
    {
      id: 98068,
      question: "True or False: Orthodontics includes dentofacial orthopedics, which involves using appliances to correct problems related to jaw growth and tooth movement.",
      options: [
        "True",
        "False",
      ],
      correctAnswer: 0
    },
    {
      id: 98069,
      question: "True or False: Class II malocclusion is also referred to as mesioclusion because the mandible is in an abnormal mesial relationship to the maxilla.",
      options: [
        "True",
        "False",
      ],
      correctAnswer: 1
    },
    {
      id: 98070,
      question: "True or False: The panoramic radiograph is used to view the eruption process of primary and permanent teeth and to evaluate the amount of space available for eruption.",
      options: [
        "True",
        "False",
      ],
      correctAnswer: 0
    },
    {
      id: 98071,
      question: "True or False: Nickel titanium (NiTi) arch wire is used during the final stages of orthodontic treatment because it is the stiffest and strongest wire material available.",
      options: [
        "True",
        "False",
      ],
      correctAnswer: 1
    },
    {
      id: 98072,
      question: "True or False: The Hawley retainer is a fixed lingual wire bonded from canine to canine on the lingual surfaces of the mandibular anterior teeth.",
      options: [
        "True",
        "False",
      ],
      correctAnswer: 1
    },
    {
      id: 98073,
      question: "True or False: Malocclusion can contribute to dental decay and periodontal disease because proper plaque removal becomes difficult when normal occlusion and natural cleansing are absent.",
      options: [
        "True",
        "False",
      ],
      correctAnswer: 0
    },
    {
      id: 98074,
      question: "True or False: The cephalometric analysis is performed directly on the radiograph by drawing measurements over the original radiographic image.",
      options: [
        "True",
        "False",
      ],
      correctAnswer: 1
    },
    {
      id: 98075,
      question: "True or False: Bird-beak pliers are used to form and bend orthodontic wires, while Weingart utility pliers are used in placing arch wires.",
      options: [
        "True",
        "False",
      ],
      correctAnswer: 0
    },
    {
      id: 98076,
      question: "True or False: The orthodontic positioner is worn after active treatment to retain the teeth in their desired positions, allow the alveolus to rebuild support, and massage the gingiva.",
      options: [
        "True",
        "False",
      ],
      correctAnswer: 0
    },
    {
      id: 98077,
      question: "True or False: Sticky foods such as caramel and licorice should be avoided during orthodontic treatment because they weaken the cement beneath the bands and cause dental cavities.",
      options: [
        "True",
        "False",
      ],
      correctAnswer: 1
    }
  ],
  "8. Introduction to Orthodontics (Part 1)": [
    {
      id: 991001,
      question: "What is orthodontics?",
      options: [
        "The branch of dentistry that diagnoses, prevents, and treats dental and facial irregularities",
        "The branch of dentistry that focuses only on the surgical removal of impacted teeth",
        "The branch of dentistry that treats diseases of the gums and supporting bone",
        "The branch of dentistry that restores decayed teeth with crowns and fillings"
      ],
      correctAnswer: 0
    },
    {
      id: 991002,
      question: "What does the term dentofacial orthopedics refer to?",
      options: [
        "Using only surgery to reshape the bones of the upper and lower jaws entirely",
        "Using a fixed or removable appliance to correct tooth movement or jaw growth problems",
        "Using bleaching agents to change the color and shade of the natural teeth",
        "Using dental implants to permanently replace teeth that have been lost"
      ],
      correctAnswer: 1
    },
    {
      id: 991003,
      question: "Which of the following is a type of treatment provided by orthodontics?",
      options: [
        "Whitening teeth that have become stained from coffee, tea, and tobacco use",
        "Filling cavities that have formed on the chewing surfaces of the molars",
        "Straightening teeth that are rotated, tilted, or otherwise improperly aligned",
        "Treating infections found deep within the pulp chamber of a tooth"
      ],
      correctAnswer: 2
    },
    {
      id: 991004,
      question: "According to the content, why will more people choose orthodontic treatment at any age?",
      options: [
        "Orthodontic treatment has become completely painless and requires no appliances",
        "Orthodontists no longer require any diagnostic records before beginning treatment",
        "Dental schools have eliminated all training related to orthodontic procedures",
        "Insurance companies are increasing their benefits for continued orthodontic care"
      ],
      correctAnswer: 3
    },
    {
      id: 991005,
      question: "How can severe malocclusion create a psychosocial problem?",
      options: [
        "It can be a social handicap and influence self-esteem and positive feelings",
        "It permanently changes the color of the enamel on all of the front teeth",
        "It always causes complete loss of the ability to taste and smell food",
        "It prevents the salivary glands from producing any saliva in the mouth"
      ],
      correctAnswer: 0
    },
    {
      id: 991006,
      question: "How can malocclusion contribute to oral malfunction?",
      options: [
        "It increases the rate at which the permanent teeth erupt into the mouth",
        "Jaw discrepancies can force changes in the manner of swallowing",
        "It strengthens the muscles used during normal chewing and biting motions",
        "It improves the natural cleansing action of the tongue against the teeth"
      ],
      correctAnswer: 1
    },
    {
      id: 991007,
      question: "How can malocclusion contribute to dental decay and periodontal disease?",
      options: [
        "It causes the teeth to produce excess enamel that traps food and bacteria inside",
        "It forces the gum tissue to grow upward and completely cover the crowns of teeth",
        "Without normal occlusion and natural cleansing, proper plaque removal becomes difficult",
        "It makes the salivary glands secrete strong acids that slowly dissolve the enamel"
      ],
      correctAnswer: 2
    },
    {
      id: 991008,
      question: "What is the emphasis of study for the orthodontist?",
      options: [
        "Restorative materials, crown fabrication, denture design, and bridge cementation",
        "Root canal therapy, pulp testing, apex location, and infection control methods",
        "Periodontal surgery, gum grafting, bone regeneration, and implant placement work",
        "Orofacial growth and development, new techniques, biomechanics, and research"
      ],
      correctAnswer: 3
    },
    {
      id: 991009,
      question: "The patient care area of the orthodontic office can be sectioned off to serve which three functions?",
      options: [
        "To obtain records, to take radiographs, and to provide clinical care at all stages",
        "To prepare meals, to store patient luggage, and to sell retail dental products",
        "To bill insurance, to schedule cleanings, and to train new front-desk staff members",
        "To extract teeth, to fabricate dentures, and to perform emergency root canal therapy"
      ],
      correctAnswer: 0
    },
    {
      id: 991010,
      question: "Which area of practice can be more expansive in the orthodontic setting?",
      options: [
        "The sterilization room",
        "The dental laboratory",
        "The front reception desk",
        "The patient waiting area"
      ],
      correctAnswer: 1
    },
    {
      id: 991011,
      question: "What is the most common cause of malocclusion?",
      options: [
        "A buildup of hardened plaque and calculus along the gumline of the molars",
        "An overuse of fluoride toothpaste during the early years of childhood development",
        "A disproportion in size between the jaw and teeth or between the upper and lower jaws",
        "A diet that is too high in soft foods that do not require any chewing effort"
      ],
      correctAnswer: 2
    },
    {
      id: 991012,
      question: "How is malocclusion defined?",
      options: [
        "Occlusion in which all of the teeth meet together in their ideal and perfect positions",
        "Occlusion that occurs only in patients who have lost one or more of their molars",
        "Occlusion that is present at birth and corrects itself naturally as a child grows",
        "Occlusion that deviates from a Class I normal occlusion as a result of irregularities"
      ],
      correctAnswer: 3
    },
    {
      id: 991013,
      question: "What results in congenitally missing teeth?",
      options: [
        "Interruption or absence of tooth bud formation",
        "Excessive grinding of the teeth during sleep",
        "Early removal of the primary baby teeth",
        "An overgrowth of the surrounding gum tissue"
      ],
      correctAnswer: 0
    },
    {
      id: 991014,
      question: "Which of the following is a developmental cause of malocclusion?",
      options: [
        "Heavy staining of the enamel from drinking dark-colored beverages daily",
        "Ectopic eruption, the abnormal direction of tooth eruption",
        "Excessive wear of the chewing surfaces from eating very hard foods",
        "A temporary swelling of the gums after a routine dental cleaning visit"
      ],
      correctAnswer: 1
    },
    {
      id: 991015,
      question: "How can genetic factors cause malocclusion?",
      options: [
        "A child may develop cavities faster than other children of the same age",
        "A child may produce too much saliva, which washes away the protective enamel",
        "A child may inherit a small jaw and large teeth, causing overcrowding",
        "A child may grind the teeth at night, which shifts them out of alignment"
      ],
      correctAnswer: 2
    },
    {
      id: 991016,
      question: "According to the genetic causes content, what is likely true if you have a missing tooth?",
      options: [
        "You will eventually lose all of the teeth that surround the missing space",
        "Your remaining teeth will become stronger to make up for the missing one",
        "The missing tooth will grow back on its own once you reach adulthood",
        "One of your parents or grandparents likely has the same missing tooth"
      ],
      correctAnswer: 3
    },
    {
      id: 991017,
      question: "What is fetal molding as a cause of malocclusion?",
      options: [
        "When an arm or leg of the fetus presses against another part of the body",
        "When the mother eats foods that are too soft during the pregnancy term",
        "When the infant is fed only liquids during the first months of its life",
        "When the child sucks a thumb repeatedly during the early growth years"
      ],
      correctAnswer: 0
    },
    {
      id: 991018,
      question: "Birth injuries that can cause malocclusion fall into which two major categories?",
      options: [
        "Poor nutrition during pregnancy and a lack of fluoride in the water supply",
        "Fetal molding and trauma during birth, such as an injury to the jaw",
        "Early loss of baby teeth and delayed eruption of the permanent teeth",
        "Excessive thumb sucking and frequent breathing through the open mouth"
      ],
      correctAnswer: 1
    },
    {
      id: 991019,
      question: "Dental trauma can lead to malocclusion in which of the following ways?",
      options: [
        "Strengthening of the roots that hold the permanent teeth in their sockets",
        "Improvement of the alignment of teeth that were previously crowded together",
        "Damage to permanent tooth buds when an injury to primary teeth has occurred",
        "An increase in the speed at which the permanent teeth replace primary teeth"
      ],
      correctAnswer: 2
    },
    {
      id: 991020,
      question: "Which is one of the three ways dental trauma can lead to malocclusion?",
      options: [
        "Hardening of the enamel surface after a tooth has been chipped or cracked",
        "Faster healing of the gum tissue after a primary tooth falls out naturally",
        "Permanent whitening of a tooth that has been bumped during a sports injury",
        "Movement of a tooth as a result of premature loss of a primary tooth"
      ],
      correctAnswer: 3
    },
    {
      id: 991021,
      question: "Which of the following is listed as a habit that can cause malocclusion?",
      options: [
        "Tongue thrusting",
        "Daily flossing",
        "Drinking water",
        "Chewing slowly"
      ],
      correctAnswer: 0
    },
    {
      id: 991022,
      question: "What does bruxism, a habit that can cause malocclusion, refer to?",
      options: [
        "Breathing through the nose",
        "Teeth grinding or clenching",
        "Swallowing food quickly",
        "Biting the lower lip"
      ],
      correctAnswer: 1
    },
    {
      id: 991023,
      question: "What is the system that classifies any deviation from normal occlusion as malocclusion?",
      options: [
        "The Black's classification of dental cavities",
        "The Miller's classification of gum recession",
        "The Angle's classification of malocclusion",
        "The Glickman's classification of bone loss"
      ],
      correctAnswer: 2
    },
    {
      id: 991024,
      question: "How many classes are included in Angle's classification of malocclusion?",
      options: [
        "Two classes: Class A and Class B malocclusion",
        "Four classes: Class I, II, III, and Class IV malocclusion",
        "Five classes: Class I through Class V malocclusion",
        "Three classes: Class I, Class II, and Class III"
      ],
      correctAnswer: 3
    },
    {
      id: 991025,
      question: "What characterizes a Class I malocclusion?",
      options: [
        "A normal molar relationship but anterior teeth that are malpositioned or rotated",
        "A complete absence of any contact between the upper and lower molar teeth",
        "A jaw that is positioned far behind its normal location relative to the skull",
        "A condition in which all of the teeth are perfectly aligned and well spaced"
      ],
      correctAnswer: 0
    },
    {
      id: 991026,
      question: "Class II malocclusion is also referred to by which term?",
      options: [
        "Mesioclusion",
        "Distoclusion",
        "Neutroclusion",
        "Crossoclusion"
      ],
      correctAnswer: 1
    },
    {
      id: 991027,
      question: "What is the facial profile associated with Class II malocclusion known as?",
      options: [
        "Prognathic",
        "Orthognathic",
        "Retrognathic",
        "Mesognathic"
      ],
      correctAnswer: 2
    },
    {
      id: 991028,
      question: "In Class II malocclusion, the body of the mandible is in what relationship to the maxilla?",
      options: [
        "An abnormal mesial relationship to the maxilla",
        "A perfectly normal and balanced relationship to the maxilla",
        "A vertically overlapped relationship to the maxilla",
        "An abnormal distal relationship to the maxilla"
      ],
      correctAnswer: 3
    },
    {
      id: 991029,
      question: "Class III malocclusion is also referred to by which term?",
      options: [
        "Mesioclusion",
        "Distoclusion",
        "Neutroclusion",
        "Linguoclusion"
      ],
      correctAnswer: 0
    },
    {
      id: 991030,
      question: "What is the facial profile associated with Class III malocclusion known as?",
      options: [
        "Retrognathic",
        "Prognathic",
        "Orthognathic",
        "Distognathic"
      ],
      correctAnswer: 1
    },
    {
      id: 991031,
      question: "What happens to the teeth in a Class III malocclusion?",
      options: [
        "The maxillary anterior teeth protrude far in front of the lower front teeth",
        "All of the molar teeth fail to make any contact when the jaw is closed",
        "The mandibular anterior teeth protrude in front of the maxillary anterior teeth",
        "The upper and lower teeth meet together in an ideal and balanced position"
      ],
      correctAnswer: 2
    },
    {
      id: 991032,
      question: "What is the most common contributor to malocclusion, in which one or many teeth are misplaced?",
      options: [
        "Open bite",
        "Cross-bite",
        "Spacing",
        "Crowding"
      ],
      correctAnswer: 3
    },
    {
      id: 991033,
      question: "What does overjet describe?",
      options: [
        "Excessive protrusion of the maxillary incisors creating space from the mandibular incisors",
        "An increased vertical overlap of the upper incisors covering the lower incisors",
        "A tooth that is positioned incorrectly against its opposing tooth in the bite",
        "A complete lack of contact between the front teeth when the jaw is closed"
      ],
      correctAnswer: 0
    },
    {
      id: 991034,
      question: "What is an overbite?",
      options: [
        "A sideways shift of a single tooth against its opposing tooth",
        "An increased vertical overlap of the maxillary incisors",
        "An excessive horizontal protrusion of the upper front teeth",
        "A gap between the upper and lower teeth during chewing"
      ],
      correctAnswer: 1
    },
    {
      id: 991035,
      question: "What is an open bite?",
      options: [
        "An excessive sideways overlap of the molar teeth on one entire side of the mouth",
        "A condition in which the lower front teeth completely hide the upper teeth at rest",
        "A lack of vertical overlap of the maxillary incisors, leaving an opening when occluded",
        "An increased forward position of the lower jaw relative to the upper jaw and teeth"
      ],
      correctAnswer: 2
    },
    {
      id: 991036,
      question: "What is a cross-bite?",
      options: [
        "When the front teeth fail to touch as the back teeth close together",
        "When the upper incisors stick out far ahead of the lower incisors",
        "When too many teeth are crowded into a space that is too small",
        "When a tooth is not properly aligned with its opposing tooth"
      ],
      correctAnswer: 3
    },
    {
      id: 991037,
      question: "Who is trained to recognize and treat preventive and interceptive orthodontic cases?",
      options: [
        "Pediatric and general practitioners",
        "Dental hygienists only",
        "Oral surgeons only",
        "Dental laboratory technicians"
      ],
      correctAnswer: 0
    },
    {
      id: 991038,
      question: "What happens to more extensive orthodontic cases?",
      options: [
        "They are managed entirely by the patient at home with online instructions",
        "They are referred to the orthodontist for diagnosis and treatment",
        "They are left untreated until the patient reaches full adulthood and stops growing",
        "They are treated only by the dental laboratory technician who makes the models"
      ],
      correctAnswer: 1
    },
    {
      id: 991039,
      question: "What does corrective orthodontics include?",
      options: [
        "Tooth whitening, dental cleanings, and routine fluoride treatment applications",
        "Cavity fillings, root canals, and the placement of porcelain crowns on teeth",
        "Fixed appliances, removable appliances, and orthognathic surgery",
        "Gum grafting, bone smoothing, and the surgical removal of wisdom teeth"
      ],
      correctAnswer: 2
    },
    {
      id: 991040,
      question: "How are fixed appliances defined?",
      options: [
        "Devices that the patient can easily take in and out and that gradually whiten teeth",
        "Devices placed beneath the gums to fight infection and reduce the swelling of tissue",
        "Devices worn only at nighttime that prevent the patient from grinding the teeth hard",
        "Devices attached to the teeth that cannot be removed by the patient and cause tooth movement"
      ],
      correctAnswer: 3
    },
    {
      id: 991041,
      question: "What is the dental history used for in orthodontic treatment planning?",
      options: [
        "To evaluate specific orthodontic concerns",
        "To determine the patient's billing arrangements",
        "To schedule the patient's future cleaning visits",
        "To select the color of the patient's braces"
      ],
      correctAnswer: 0
    },
    {
      id: 991042,
      question: "Why is a physical growth evaluation important in orthodontics?",
      options: [
        "Because it determines exactly how much the treatment will cost the patient",
        "Because orthodontic treatment in children is closely related to growth stages",
        "Because it identifies which teeth have the most plaque and calculus buildup",
        "Because it predicts the color and shade the teeth will become after treatment"
      ],
      correctAnswer: 1
    },
    {
      id: 991043,
      question: "What does the social and behavioral evaluation determine?",
      options: [
        "The exact shade of the tooth enamel",
        "The total number of teeth in the mouth",
        "The motivation for seeking treatment",
        "The patient's preferred appointment times"
      ],
      correctAnswer: 2
    },
    {
      id: 991044,
      question: "The clinical examination is used to do which of the following?",
      options: [
        "Determine the cost of treatment and arrange the patient's payment schedule plan",
        "Choose the colors of the elastics and the style of the brackets to be used",
        "Sterilize the instruments and prepare the dental laboratory for cast fabrication",
        "Document, measure, and analyze facial proportions and evaluate oral health and function"
      ],
      correctAnswer: 3
    },
    {
      id: 991045,
      question: "Diagnostic records are required in which forms?",
      options: [
        "Photographs, radiographs, and diagnostic models",
        "Blood tests, urine samples, and saliva cultures",
        "Insurance forms, consent waivers, and billing statements",
        "Handwritten notes, voice recordings, and patient surveys"
      ],
      correctAnswer: 0
    },
    {
      id: 991046,
      question: "Photographs are useful as an aid in which of the following?",
      options: [
        "Sterilizing equipment, mixing cement, and bending the orthodontic arch wires",
        "Patient identification, treatment planning, case presentation, and patient education",
        "Calculating insurance costs, ordering supplies, and scheduling future appointments",
        "Removing plaque, polishing enamel, and applying fluoride to the patient's teeth"
      ],
      correctAnswer: 1
    },
    {
      id: 991047,
      question: "Which two standard extraoral photographs are routinely taken?",
      options: [
        "The maxillary view and a mandibular view",
        "The buccal view and an occlusal view",
        "The frontal view and a profile view",
        "The lingual view and a palatal view"
      ],
      correctAnswer: 2
    },
    {
      id: 991048,
      question: "Which of the following is one of the three standard intraoral photographs taken?",
      options: [
        "The full skull profile view",
        "The extraoral frontal view",
        "The neck and shoulder view",
        "The maxillary occlusal view"
      ],
      correctAnswer: 3
    },
    {
      id: 991049,
      question: "What is a panoramic radiograph used for?",
      options: [
        "To view the eruption process and evaluate space available for eruption",
        "To measure the exact temperature inside the patient's open mouth area",
        "To detect the color and shade of the enamel on each individual tooth",
        "To record the patient's bite force when chewing on hard food items"
      ],
      correctAnswer: 0
    },
    {
      id: 991050,
      question: "What do cephalometric (extraoral) radiographs make it possible to evaluate?",
      options: [
        "The exact amount of plaque present on the surface of each tooth crown",
        "The anatomic basis for malocclusion as well as the skull, bones, and soft tissue",
        "The color of the gums and the amount of bleeding present during brushing",
        "The total number of cavities hidden between the patient's back teeth surfaces"
      ],
      correctAnswer: 1
    },
    {
      id: 991051,
      question: "How is cephalometric analysis performed?",
      options: [
        "Directly on the radiograph itself using a marker to circle the problem areas",
        "By measuring the patient's bite force with a special pressure-sensitive device",
        "As a tracing or computerized drawing that emphasizes relationships among selected points",
        "By taking a series of color photographs of the teeth from many different angles"
      ],
      correctAnswer: 2
    },
    {
      id: 991052,
      question: "What can the orthodontist recognize through cephalometric analysis?",
      options: [
        "The exact shade of enamel needed to match the patient's whitened teeth",
        "The brand of toothpaste the patient has been using at home each day",
        "The number of cavities that will form in the patient's mouth over time",
        "Growth patterns that reveal the type of treatment that should be provided"
      ],
      correctAnswer: 3
    },
    {
      id: 991053,
      question: "What are diagnostic casts used for?",
      options: [
        "Diagnosis, case presentation, and space analysis of the dentition",
        "Whitening the teeth and removing surface stains before treatment begins",
        "Sterilizing instruments and storing the orthodontic bands between visits",
        "Measuring the bite force and recording the patient's chewing patterns"
      ],
      correctAnswer: 0
    },
    {
      id: 991054,
      question: "The orthodontic diagnostic cast is commonly made from which material?",
      options: [
        "Stainless steel, polished to a smooth and shiny finished surface",
        "Plaster, constructed in a precise and finished manner",
        "Soft rubber, molded quickly to capture the shape of the teeth",
        "Clear plastic, heated and pressed over the patient's dental arch"
      ],
      correctAnswer: 1
    },
    {
      id: 991055,
      question: "What is the orthodontic scaler used for?",
      options: [
        "Bending the arch wires and adjusting the clasps on removable appliances",
        "Taking radiographs and developing the films in the darkroom afterward",
        "Bracket placement, removal of elastomeric rings, and removal of excess cement",
        "Whitening the teeth and polishing the enamel after the braces are removed"
      ],
      correctAnswer: 2
    },
    {
      id: 991056,
      question: "What is the ligature director used for?",
      options: [
        "To form and bend the arch wires into the shape of the dental arch",
        "To remove bands from the molar teeth at the completion of treatment",
        "To seat a molar band onto a tooth for the placement of a fixed appliance",
        "To guide the ligature tie around the bracket and tuck it under the arch wire"
      ],
      correctAnswer: 3
    },
    {
      id: 991057,
      question: "What is the band plugger used for?",
      options: [
        "To help seat a molar band for a fixed appliance",
        "To bend the arch wire into the correct shape",
        "To cut the ligature wire during removal",
        "To carry the bonded bracket to the tooth"
      ],
      correctAnswer: 0
    },
    {
      id: 991058,
      question: "What are bracket placement tweezers used for?",
      options: [
        "To remove the molar bands at the end of treatment",
        "To carry and place the bonded bracket on the tooth",
        "To close and adjust the clasps on a removable retainer",
        "To cut the stainless steel ligature ties for removal"
      ],
      correctAnswer: 1
    },
    {
      id: 991059,
      question: "What are bird-beak pliers used for?",
      options: [
        "To fit the molar bands",
        "To remove the bands",
        "To form and bend wires",
        "To adjust the clasps"
      ],
      correctAnswer: 2
    },
    {
      id: 991060,
      question: "What are Weingart utility pliers used for?",
      options: [
        "Closing clasps",
        "Fitting bands",
        "Cutting ligatures",
        "Placing arch wires"
      ],
      correctAnswer: 3
    },
    {
      id: 991061,
      question: "What are contouring pliers used for?",
      options: [
        "Fitting bands",
        "Bending wires",
        "Cutting ties",
        "Removing bands"
      ],
      correctAnswer: 0
    },
    {
      id: 991062,
      question: "What are three-prong pliers used for?",
      options: [
        "To form and bend the wires",
        "To close and adjust clasps",
        "To place the arch wires",
        "To fit the molar bands"
      ],
      correctAnswer: 1
    },
    {
      id: 991063,
      question: "What are posterior band remover pliers used for?",
      options: [
        "To place wires",
        "To fit bands",
        "To remove bands",
        "To bend wires"
      ],
      correctAnswer: 2
    },
    {
      id: 991064,
      question: "What are wire-bending pliers used for?",
      options: [
        "To close and adjust the clasps on a removable retainer device",
        "To carry and place the bonded brackets onto the tooth surfaces",
        "To seat the molar bands during placement of a fixed appliance",
        "To hold, bend, and adjust arch wires to create movement"
      ],
      correctAnswer: 3
    },
    {
      id: 991065,
      question: "What is the pin and ligature cutter used for?",
      options: [
        "Cutting the ligature wire for removal",
        "Bending the arch wire for movement",
        "Fitting the bands onto the molars",
        "Placing the brackets onto teeth"
      ],
      correctAnswer: 0
    },
    {
      id: 991066,
      question: "What are ligature-tying pliers used for?",
      options: [
        "For removing the molar bands",
        "For ease in ligature tying",
        "For bending the arch wires",
        "For fitting the molar bands"
      ],
      correctAnswer: 1
    },
    {
      id: 991067,
      question: "What are Howe (110) pliers used for?",
      options: [
        "Whitening the teeth and polishing the enamel after treatment is finished",
        "Taking the diagnostic photographs of the patient from several angles",
        "Placement, removal, and making adjustment bends in the arch wire",
        "Sterilizing the other instruments before each patient appointment begins"
      ],
      correctAnswer: 2
    },
    {
      id: 991068,
      question: "Why are Howe (110) pliers considered versatile?",
      options: [
        "They are made of a special plastic that never needs to be sterilized again",
        "They can take radiographs and develop the film all within a single device",
        "They automatically bend the wire into the perfect arch shape without effort",
        "They have a round, flat, wide tip suitable for holding materials intraorally"
      ],
      correctAnswer: 3
    },
    {
      id: 991069,
      question: "What does orthodontic treatment refer to?",
      options: [
        "Using fixed or removable appliances or both to mechanically move the jaw or teeth",
        "Using bleaching agents to lighten the natural color of the patient's teeth",
        "Using surgery alone to remove all of the crowded teeth from the mouth",
        "Using daily rinses and gels to strengthen the enamel against future decay"
      ],
      correctAnswer: 0
    },
    {
      id: 991070,
      question: "Fixed appliances, also referred to as braces, are a combination of which components?",
      options: [
        "Trays, gels, and bleaching lights",
        "Bands, brackets, and auxiliaries",
        "Crowns, posts, and cement layers",
        "Implants, screws, and abutments"
      ],
      correctAnswer: 1
    },
    {
      id: 991071,
      question: "Fixed appliances can move a tooth in how many directions?",
      options: [
        "Two directions: only forward and backward within the dental arch space",
        "Three directions: up, down, and sideways within the mouth cavity area",
        "Six directions: mesially, distally, lingually, facially, apically, and occlusally",
        "Four directions: left, right, forward, and backward but never vertically"
      ],
      correctAnswer: 2
    },
    {
      id: 991072,
      question: "What is the first step in the sequence of appointments for fixed appliances?",
      options: [
        "Removal of the appliance",
        "Bonding of the brackets",
        "Insertion of the arch wire",
        "Placement of separators"
      ],
      correctAnswer: 3
    },
    {
      id: 991073,
      question: "What is the final step in the sequence of appointments for fixed appliances?",
      options: [
        "Retention of teeth",
        "Placement of separators",
        "Cementation of molar bands",
        "Insertion of the arch wire"
      ],
      correctAnswer: 0
    },
    {
      id: 991074,
      question: "In the sequence of appointments, what step comes immediately after bonding of brackets?",
      options: [
        "Placement of the separators between the molar teeth in the arch",
        "Insertion of arch wire and tying in with ligature ties or elastomeric ties",
        "Cementation of the molar bands onto the back teeth of the patient",
        "Complete removal of the appliance and all of its attached components"
      ],
      correctAnswer: 1
    },
    {
      id: 991075,
      question: "When are teeth separated using separators?",
      options: [
        "After the appliance has been completely removed from the mouth",
        "During the retention phase once treatment has been finished",
        "Before fitting and placement of the molar bands",
        "Only after the arch wire has been tied into all of the brackets"
      ],
      correctAnswer: 2
    },
    {
      id: 991076,
      question: "Which tool is used for the placement of separators?",
      options: [
        "Posterior band remover pliers",
        "The band plugger and bite stick",
        "The pin and ligature cutter",
        "Bird beak pliers or separating pliers"
      ],
      correctAnswer: 3
    },
    {
      id: 991077,
      question: "Where are pre-formed stainless steel bands fitted and cemented?",
      options: [
        "To molar teeth",
        "To the front incisors",
        "To the canine teeth",
        "To the premolar teeth"
      ],
      correctAnswer: 0
    },
    {
      id: 991078,
      question: "What is attached to orthodontic bands for the arch wire and power products?",
      options: [
        "Hooks, screws, and plates",
        "Buttons, tubes, and cleats",
        "Wires, springs, and coils",
        "Pins, rings, and clasps"
      ],
      correctAnswer: 1
    },
    {
      id: 991079,
      question: "On a bonded bracket, how is the arch wire positioned?",
      options: [
        "Glued permanently to the front surface so it can never be removed again",
        "Wrapped tightly around the entire tooth and then cemented into the gum",
        "Placed horizontally through the wings of the bracket and then ligated in place",
        "Inserted vertically through the center of the tooth into the jaw bone"
      ],
      correctAnswer: 2
    },
    {
      id: 991080,
      question: "How does the bonded bracket initiate tooth movement?",
      options: [
        "By releasing a chemical that softens the bone around the tooth root",
        "By applying heat directly to the enamel to loosen the tooth in place",
        "By creating suction that pulls the tooth toward the front of the mouth",
        "By allowing forces from the arch wire to be transmitted to the tooth"
      ],
      correctAnswer: 3
    },
    {
      id: 991081,
      question: "What are headgear tubes used for?",
      options: [
        "Insertion of the inner bow of a facebow appliance",
        "Holding the interarch elastics between the two arches",
        "Receiving the arch wire on the buccal surfaces of molars",
        "Stabilizing the arch on the lingual portion of the bands"
      ],
      correctAnswer: 0
    },
    {
      id: 991082,
      question: "What are edgewise tubes used for?",
      options: [
        "Inserting the inner bow of the facebow appliance into the molar band",
        "Receiving the arch wire on the buccal surfaces of upper and lower first molar bands",
        "Holding the interarch elastics between the upper and lower dental arches",
        "Stabilizing the lingual arch and reinforcing anchorage for tooth movement"
      ],
      correctAnswer: 1
    },
    {
      id: 991083,
      question: "What do labial hooks hold?",
      options: [
        "The inner facebow bow",
        "The lingual arch wire",
        "The interarch elastics",
        "The molar separators"
      ],
      correctAnswer: 2
    },
    {
      id: 991084,
      question: "What does the lingual arch attachment do?",
      options: [
        "Holds the interarch elastics between the upper and lower arches",
        "Receives the inner bow of the facebow appliance during treatment",
        "Covers the arch wire to increase patient comfort during eating",
        "Stabilizes the arch and reinforces anchorage and tooth movement"
      ],
      correctAnswer: 3
    },
    {
      id: 991085,
      question: "What is the purpose of the arch wire?",
      options: [
        "To provide a pattern for the dental arch and guide the teeth in movement",
        "To permanently glue the brackets to the front surfaces of the teeth",
        "To whiten the enamel of the teeth during the course of treatment",
        "To cover the gums and protect them from irritation during chewing"
      ],
      correctAnswer: 0
    },
    {
      id: 991086,
      question: "Why is nickel titanium (NiTi) wire used?",
      options: [
        "For final positioning because it is stiff",
        "For movement because of its flexibility",
        "For its bright and attractive appearance",
        "For its ability to whiten the enamel"
      ],
      correctAnswer: 1
    },
    {
      id: 991087,
      question: "What is a characteristic of stainless steel arch wire?",
      options: [
        "It is the most flexible wire available",
        "It is used mainly for its esthetics",
        "It is stiffer and stronger",
        "It is used only for light force"
      ],
      correctAnswer: 2
    },
    {
      id: 991088,
      question: "What does beta titanium (TMA) arch wire provide?",
      options: [
        "Only flexibility with no strength or memory at all",
        "Only a pleasing esthetic appearance for the patient",
        "Only stiffness with no flexibility for the final stages",
        "A combination of strength, flexibility, and memory"
      ],
      correctAnswer: 3
    },
    {
      id: 991089,
      question: "Why is Optiflex arch wire used?",
      options: [
        "For light force and its esthetics",
        "For its stiffness and great strength",
        "For its ability to remove plaque buildup",
        "For seating the molar bands onto teeth"
      ],
      correctAnswer: 0
    },
    {
      id: 991090,
      question: "When are round arch wires used?",
      options: [
        "Only at the very end of treatment to finish positioning the tooth roots",
        "In the initial and intermediate stages to correct crowding and level the arch",
        "Exclusively during the retention phase after the braces have been removed",
        "Only when seating the molar bands during the very first appointment visit"
      ],
      correctAnswer: 1
    },
    {
      id: 991091,
      question: "When are square or rectangular arch wires used?",
      options: [
        "During the initial stages to correct crowding and open up the bite",
        "Only during the separator placement at the start of all treatment",
        "During the final stages to position the crown and root correctly",
        "Exclusively for cleaning plaque from around the brackets and bands"
      ],
      correctAnswer: 2
    },
    {
      id: 991092,
      question: "What is a ligature tie?",
      options: [
        "A soft rubber pad placed over the wire to increase patient comfort",
        "A pre-formed band cemented around the molar tooth during treatment",
        "A plaster model used to plan the movement of the teeth before treatment",
        "A 0.01-gauge stainless steel wire used to tie in arch wires"
      ],
      correctAnswer: 3
    },
    {
      id: 991093,
      question: "What are Kobayashi hooks?",
      options: [
        "Ligature ties spot welded at the tip to form hooks for attaching elastics",
        "Round tubes welded to molar bands for the inner bow of a facebow",
        "Plastic covers placed over the wire to reduce irritation to the cheek",
        "Plaster attachments added to the diagnostic cast for treatment planning"
      ],
      correctAnswer: 0
    },
    {
      id: 991094,
      question: "What are elastic chain ties used for?",
      options: [
        "To take radiographs of the patient's teeth and supporting bone",
        "To close space between teeth or to correct rotated teeth",
        "To seat the molar bands during the placement of fixed appliances",
        "To whiten the teeth after the orthodontic appliances are removed"
      ],
      correctAnswer: 1
    },
    {
      id: 991095,
      question: "How are elastics, commonly called rubber bands, used?",
      options: [
        "Cemented permanently around each molar to anchor the entire appliance",
        "Bonded directly to the front of each tooth to whiten the enamel surface",
        "Placed from one tooth to another to close spaces and correct occlusal relationships",
        "Wrapped over the gums to protect the soft tissue from wire irritation"
      ],
      correctAnswer: 2
    },
    {
      id: 991096,
      question: "What is elastic thread used for?",
      options: [
        "To cover the arch wire and increase the patient's overall comfort",
        "To take the diagnostic photographs of the patient before treatment",
        "To cement the molar bands onto the back teeth during the first visit",
        "To close space or aid in the eruption of impacted teeth"
      ],
      correctAnswer: 3
    },
    {
      id: 991097,
      question: "What is comfort tubing used for?",
      options: [
        "To aid patient comfort by covering an arch wire that may cause discomfort",
        "To close spaces between the teeth and correct any rotated teeth present",
        "To assist in the eruption of teeth that have become impacted in the bone",
        "To stabilize the lingual arch and reinforce anchorage during tooth movement"
      ],
      correctAnswer: 0
    },
    {
      id: 991098,
      question: "What is the new orthodontic alignment technique used for simple alignment of teeth?",
      options: [
        "The stainless steel headgear device",
        "The vacuum formed clear aligner",
        "The fixed lingual canine-to-canine wire",
        "The bonded metal bracket and band system"
      ],
      correctAnswer: 1
    },
    {
      id: 991099,
      question: "How do the patient's teeth move with a clear aligner system?",
      options: [
        "Instantly after the first aligner is placed into the mouth once",
        "Only after surgery is performed to reposition the jaw bones first",
        "Gradually as a result of the pressure that the aligner creates",
        "Through a chemical reaction that dissolves the bone around the roots"
      ],
      correctAnswer: 2
    },
    {
      id: 991100,
      question: "Which statement about the clear aligner system is true?",
      options: [
        "It is suitable for every possible case of malocclusion equally",
        "It is fabricated by hand without the use of any computer at all",
        "It is permanently fixed to the teeth and cannot ever be removed",
        "It is not suitable for all cases of malocclusion"
      ],
      correctAnswer: 3
    },
    {
      id: 991101,
      question: "What does the chairside assistant check the patient's appliance for during adjustment visits?",
      options: [
        "Broken arch wires, loose brackets and bands, and loose or missing ligatures and elastics",
        "The exact shade of the tooth enamel and the level of staining present on each tooth",
        "The total number of hidden cavities present between all of the patient's back teeth",
        "The amount of plaque on the patient's tongue and the level of bleeding from the gums"
      ],
      correctAnswer: 0
    },
    {
      id: 991102,
      question: "According to the toothbrushing instructions, how should you floss with braces?",
      options: [
        "Avoid flossing entirely until the braces are removed at the end",
        "Floss your teeth using a floss threader for easy application",
        "Floss only once each month to avoid loosening the brackets and wires",
        "Use a metal pick to scrape between the brackets instead of flossing"
      ],
      correctAnswer: 1
    },
    {
      id: 991103,
      question: "After brushing with braces, what should you do to remove any debris?",
      options: [
        "Chew a piece of sticky gum thoroughly",
        "Press hard on each bracket with a finger",
        "Rinse and swish water around the mouth",
        "Skip rinsing to keep the toothpaste on longer"
      ],
      correctAnswer: 2
    },
    {
      id: 991104,
      question: "Why should sugar-containing foods be avoided during orthodontic treatment?",
      options: [
        "They cause the arch wire to permanently change its color over time",
        "They make the elastics stretch out and lose their ability to close spaces",
        "They cause the gums to grow over the brackets and cover the teeth fully",
        "They weaken cement beneath the bands and adhere to enamel, causing cavities"
      ],
      correctAnswer: 3
    },
    {
      id: 991105,
      question: "Why should hard foods such as ice and jawbreakers be avoided with braces?",
      options: [
        "They loosen bands and bend and occasionally break arch wires",
        "They dissolve the bonding cement and cause the brackets to fall off",
        "They stain the brackets and elastics a dark and unattractive color",
        "They cause the gums to swell and bleed around the bands and wires"
      ],
      correctAnswer: 0
    },
    {
      id: 991106,
      question: "Why should sticky foods such as caramel and taffy be avoided with braces?",
      options: [
        "They lodge between bands and beneath wires, irritating the gum tissues",
        "They loosen bands, pull out ligature ties, and may bend arch wires",
        "They weaken the cement and adhere to the enamel, causing tooth decay",
        "They cause the brackets to change color and become permanently stained"
      ],
      correctAnswer: 1
    },
    {
      id: 991107,
      question: "What is headgear used to control?",
      options: [
        "Tooth color and enamel shade",
        "Plaque buildup and gum bleeding",
        "Growth and tooth movement",
        "Saliva production and bad breath"
      ],
      correctAnswer: 2
    },
    {
      id: 991108,
      question: "What is the facebow used for?",
      options: [
        "To apply fluoride to the teeth and strengthen the enamel against decay",
        "To whiten the front teeth and remove stains caused by food and drink",
        "To take photographs of the patient's face from the front and side views",
        "To stabilize or move the maxillary first molar distally and create more room"
      ],
      correctAnswer: 3
    },
    {
      id: 991109,
      question: "What are traction devices used for?",
      options: [
        "To apply the extraoral force necessary to achieve the desired treatment results",
        "To take the diagnostic radiographs of the patient's skull and jaw bones",
        "To clean the plaque from around the brackets during each adjustment visit",
        "To cement the molar bands onto the back teeth during the first appointment"
      ],
      correctAnswer: 0
    },
    {
      id: 991110,
      question: "How is band removal accomplished at the completion of treatment?",
      options: [
        "By dissolving the cement with a special chemical rinse over several weeks",
        "By breaking the seal of cement and lifting the bands off with a band remover",
        "By heating each band until the metal softens and slides off the tooth easily",
        "By allowing the bands to fall off naturally as the teeth shift into position"
      ],
      correctAnswer: 1
    },
    {
      id: 991111,
      question: "How are bonded brackets removed at the completion of treatment?",
      options: [
        "By breaking the cement seal and lifting them with a band remover tool",
        "By soaking them in a chemical solution until the bond dissolves completely",
        "By creating a fracture within the resin bonding material",
        "By waiting until they loosen on their own once the arch wire is taken out"
      ],
      correctAnswer: 2
    },
    {
      id: 991112,
      question: "Why is retention necessary after orthodontic treatment?",
      options: [
        "To whiten the teeth and remove any stains that built up during treatment",
        "To strengthen the enamel and protect the teeth from future decay and cavities",
        "To take final photographs and radiographs for the patient's permanent record",
        "To allow tissue reorganization, support unstable teeth, and control growth changes"
      ],
      correctAnswer: 3
    },
    {
      id: 991113,
      question: "Which of the following is a type of appliance used for retention?",
      options: [
        "The Hawley retainer",
        "The bird-beak plier",
        "The orthodontic scaler",
        "The molar band plugger"
      ],
      correctAnswer: 0
    },
    {
      id: 991114,
      question: "What does the orthodontic positioner do?",
      options: [
        "Whitens the teeth, removes the surface stains, and polishes all of the enamel smooth",
        "Retains teeth in position, lets the alveolus rebuild support, and massages the gingiva",
        "Takes the radiographs, records the bite force, and measures the patient's jaw movements",
        "Cements the bands, bonds the brackets, and ties in the arch wire firmly and securely"
      ],
      correctAnswer: 1
    },
    {
      id: 991115,
      question: "What is the purpose of a Hawley retainer?",
      options: [
        "This fixed appliance actively moves the teeth into their new position quickly",
        "This device whitens the teeth and removes stains after treatment is finished",
        "This removable retainer passively retains the teeth in their new position",
        "This appliance applies extraoral force to move the molars back in the arch"
      ],
      correctAnswer: 2
    },
    {
      id: 991116,
      question: "What is a lingual retainer?",
      options: [
        "A removable plate worn over the palate to passively retain the front teeth",
        "A clear vacuum-formed tray that covers all of the teeth in the dental arch",
        "A round tube on the molar band used for the inner bow of a facebow device",
        "A fixed lingual wire bonded canine-to-canine on the lingual surfaces"
      ],
      correctAnswer: 3
    },
    {
      id: 991117,
      question: "What does the lingual retainer provide?",
      options: [
        "Lower incisor position during late growth",
        "Whitening of the lower front teeth",
        "Movement of the maxillary molars distally",
        "Extraoral force to reshape the jaw"
      ],
      correctAnswer: 0
    },
    {
      id: 991118,
      question: "Orthodontics is the specialized branch of dentistry that diagnoses, prevents, and treats dental and facial irregularities.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 991119,
      question: "The most common cause of malocclusion is a buildup of plaque and calculus along the gumline.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 991120,
      question: "Bruxism, which refers to teeth grinding or clenching, is listed as a habit that can cause malocclusion.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 991121,
      question: "Class II malocclusion is also referred to as mesioclusion and produces a prognathic facial profile.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 991122,
      question: "Crowding is the most common contributor to malocclusion, in which one or many teeth are misplaced.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 991123,
      question: "Nickel titanium (NiTi) arch wire is used for movement because of its flexibility.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 991124,
      question: "The first step in the sequence of appointments for fixed appliances is the bonding of brackets.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 991125,
      question: "Round arch wires are used during the final stages of treatment to position the crown and root.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 991126,
      question: "Pre-formed stainless steel orthodontic bands are fitted and cemented to the molar teeth.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 991127,
      question: "A Hawley retainer is a fixed appliance that actively moves teeth into a new position.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 991128,
      question: "Headgear is an orthodontic device used to control growth and tooth movement.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 991129,
      question: "The vacuum formed clear aligner system is suitable for all cases of malocclusion.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    }
  ],
  "8. Introduction to Orthodontics (Part 2)": [
    {
      id: 992001,
      question: "Orthodontics is best defined as a dental specialty dealing with the recognition, prevention, and treatment of:",
      options: [
        "diseases of the tongue, throat, and glands",
        "infections of the pulp, roots, and apex",
        "disorders of the sinuses, airway, and nose",
        "irregularities of the teeth, jaws, and face"
      ],
      correctAnswer: 3
    },
    {
      id: 992002,
      question: "Which of the following is a stated goal of orthodontic treatment?",
      options: [
        "Establish or maintain a normal functioning occlusion",
        "Eliminate the future need for any restorative work",
        "Remove every primary tooth before it can erupt",
        "Prevent the permanent teeth from ever erupting"
      ],
      correctAnswer: 0
    },
    {
      id: 992003,
      question: "Improving facial esthetics is considered to be:",
      options: [
        "a recognized goal of orthodontic treatment",
        "an unrelated concern of cosmetic dentistry only",
        "a side effect that is generally best avoided",
        "a goal limited to surgical jaw procedures only"
      ],
      correctAnswer: 0
    },
    {
      id: 992004,
      question: "One goal of orthodontic treatment is to establish the best physiologic position of the:",
      options: [
        "incisor along the anterior border of bone",
        "molar against the opposing arch surface",
        "condyle in the temporomandibular joint",
        "canine within the curve of the dental arch"
      ],
      correctAnswer: 2
    },
    {
      id: 992005,
      question: "Among the goals of orthodontic treatment is to establish healthy and stable:",
      options: [
        "short-term enamel whiteness",
        "long-term salivary output",
        "long-term periodontal health",
        "short-term jaw muscle bulk"
      ],
      correctAnswer: 2
    },
    {
      id: 992006,
      question: "Which of the following can arise from untreated malocclusion?",
      options: [
        "Psychosocial problems for the individual",
        "Permanent fusion of the upper and lower jaws",
        "Complete loss of all feeling in the lower lip",
        "Spontaneous regrowth of previously lost teeth"
      ],
      correctAnswer: 0
    },
    {
      id: 992007,
      question: "Untreated malocclusion can lead to injury caused by trauma to and breakage of:",
      options: [
        "protruding teeth",
        "the salivary glands",
        "the facial nerve",
        "the nasal septum"
      ],
      correctAnswer: 0
    },
    {
      id: 992008,
      question: "The dental hygienist's role in orthodontics includes identifying malocclusions and:",
      options: [
        "bending and adjusting the archwires during treatment",
        "maintaining dental and periodontal health during treatment",
        "prescribing the surgical plan for the jaw repositioning",
        "selecting the bracket system placed on each single tooth"
      ],
      correctAnswer: 1
    },
    {
      id: 992009,
      question: "In most cases, a malocclusion is caused by a combination of:",
      options: [
        "viral and bacterial infections",
        "dietary and hormonal imbalances",
        "skeletal and dental discrepancies",
        "muscular and neural injuries"
      ],
      correctAnswer: 2
    },
    {
      id: 992010,
      question: "A skeletal discrepancy exists when the malocclusion is caused by the:",
      options: [
        "shade and surface texture of the enamel",
        "number of fillings present in the mouth",
        "direction the tongue rests during sleep",
        "position of the jaws relative to one another"
      ],
      correctAnswer: 3
    },
    {
      id: 992011,
      question: "The three basic spatial planes used to describe malocclusion are:",
      options: [
        "anterior, posterior, and occlusal",
        "buccal, lingual, and incisal edge",
        "horizontal, vertical, and transverse",
        "mesial, distal, and apical level"
      ],
      correctAnswer: 2
    },
    {
      id: 992012,
      question: "Horizontal malocclusions are classified as:",
      options: [
        "open bites or severe overbites cases",
        "anterior or posterior crossbite cases",
        "primate or developmental space cases",
        "class II or class III malocclusions"
      ],
      correctAnswer: 3
    },
    {
      id: 992013,
      question: "Which condition is an example of a vertical malocclusion?",
      options: [
        "A posterior or an anterior crossbite",
        "An open bite or a severe overbite",
        "A class II or a class III relationship",
        "A midline diastema or tooth rotation"
      ],
      correctAnswer: 1
    },
    {
      id: 992014,
      question: "Which of the following is classified as a transverse malocclusion?",
      options: [
        "An open bite of the anterior teeth",
        "A crossbite of the posterior teeth",
        "A class II molar relationship pattern",
        "A severe overbite of the front teeth"
      ],
      correctAnswer: 1
    },
    {
      id: 992015,
      question: "An anterior open bite is a malocclusion that occurs in the:",
      options: [
        "vertical dimension",
        "transverse dimension",
        "horizontal dimension",
        "rotational dimension"
      ],
      correctAnswer: 0
    },
    {
      id: 992016,
      question: "An anterior open bite can occur if the:",
      options: [
        "posterior teeth erupt too far into the mouth",
        "anterior teeth erupt too far out of the mouth",
        "posterior teeth fail to develop any roots",
        "anterior teeth fuse together at the midline"
      ],
      correctAnswer: 0
    },
    {
      id: 992017,
      question: "In long face syndrome, the mandible is positioned:",
      options: [
        "too far downward and backward",
        "too far upward and forward",
        "too far to the left and inward",
        "too far to the right and outward"
      ],
      correctAnswer: 0
    },
    {
      id: 992018,
      question: "A skeletal short face with insufficient posterior eruption predisposes the client to:",
      options: [
        "a severe anterior overbite",
        "a severe posterior open bite",
        "a severe unilateral crossbite",
        "a severe midline diastema"
      ],
      correctAnswer: 0
    },
    {
      id: 992019,
      question: "Treatment of an open bite or severe overbite requires correction of:",
      options: [
        "alignment problems of the anterior teeth",
        "color problems of the enamel surfaces",
        "spacing problems of the lower incisors",
        "eruption problems of the posterior teeth"
      ],
      correctAnswer: 3
    },
    {
      id: 992020,
      question: "Treatment of a class II or III malocclusion caused by malpositioned teeth alone is:",
      options: [
        "identical to one caused by skeletal relationships",
        "different from one caused by skeletal relationships",
        "impossible without major orthognathic jaw surgery",
        "always delayed until all third molars erupt fully"
      ],
      correctAnswer: 1
    },
    {
      id: 992021,
      question: "According to the eruption sequence, which primary tooth erupts first?",
      options: [
        "The mandibular central incisor",
        "The maxillary central incisor",
        "The mandibular first molar tooth",
        "The maxillary lateral incisor"
      ],
      correctAnswer: 0
    },
    {
      id: 992022,
      question: "According to the eruption sequence, the last primary tooth to erupt is the:",
      options: [
        "mandibular first molar",
        "maxillary central incisor",
        "mandibular lateral incisor",
        "maxillary second molar"
      ],
      correctAnswer: 3
    },
    {
      id: 992023,
      question: "Angle's classification of malocclusion applies only to the:",
      options: [
        "primary dentition",
        "mixed dentition",
        "transitional dentition",
        "permanent dentition"
      ],
      correctAnswer: 3
    },
    {
      id: 992024,
      question: "Classification of the primary dentition's occlusion uses the distal surfaces of the:",
      options: [
        "primary maxillary and mandibular central incisors",
        "permanent maxillary and mandibular first molars",
        "primary maxillary and mandibular second molars",
        "permanent maxillary and mandibular canine teeth"
      ],
      correctAnswer: 2
    },
    {
      id: 992025,
      question: "Angle's classification and the primary classification systems are both described as:",
      options: [
        "the final word in any occlusal assessment work",
        "only a starting point for occlusal assessment",
        "useful only for adults over forty years of age",
        "valid only after all third molars have erupted"
      ],
      correctAnswer: 1
    },
    {
      id: 992026,
      question: "Eruption time is considered normal if it occurs within:",
      options: [
        "2 months before or 2 months after the expected age",
        "6 months before or 6 months after the expected age",
        "1 year before or 1 year after the expected age",
        "3 weeks before or 3 weeks after the expected age"
      ],
      correctAnswer: 1
    },
    {
      id: 992027,
      question: "Primate space is described as spacing that occurs predominantly in:",
      options: [
        "one location and is permanent in all human beings",
        "four locations and is temporary in subhuman apes",
        "two locations and is permanent in subhuman primates",
        "three locations and is temporary in young children"
      ],
      correctAnswer: 2
    },
    {
      id: 992028,
      question: "In the maxilla, primate space occurs between the:",
      options: [
        "central incisors and the midline",
        "first molars and the second molars",
        "lateral incisors and the canines",
        "canines and the first premolars"
      ],
      correctAnswer: 2
    },
    {
      id: 992029,
      question: "In the mandible, primate space occurs between the:",
      options: [
        "lateral incisors and the canines",
        "central incisors and the midline",
        "first molars and the second molars",
        "canines and the first molars"
      ],
      correctAnswer: 3
    },
    {
      id: 992030,
      question: "Developmental spacing between the incisors is an indication that:",
      options: [
        "the permanent teeth will erupt in the wrong order",
        "the primary teeth are about to become ankylosed",
        "the tongue is pushing the teeth out of position",
        "alveolar growth is adequate for the permanent teeth"
      ],
      correctAnswer: 3
    },
    {
      id: 992031,
      question: "Spacing in the primary anterior teeth is a positive sign of arch development unless it is related to:",
      options: [
        "a recent change in the child's daily diet plan",
        "a normal eruption of all the primary canines",
        "a tongue thrust or congenitally missing incisors",
        "a healthy growth pattern of the lower jawbone"
      ],
      correctAnswer: 2
    },
    {
      id: 992032,
      question: "The absence of spacing in the primary dentition is a clear sign that:",
      options: [
        "growth of the jaws has stopped completely now",
        "the permanent teeth will never erupt at all",
        "the child has an unusually small tongue size",
        "teeth will be crowded in the permanent dentition"
      ],
      correctAnswer: 3
    },
    {
      id: 992033,
      question: "According to the permanent eruption sequence, the first permanent teeth to erupt are the:",
      options: [
        "maxillary central incisors",
        "mandibular lateral incisors",
        "mandibular first molars",
        "maxillary second premolars"
      ],
      correctAnswer: 2
    },
    {
      id: 992034,
      question: "According to the permanent eruption sequence, the third molars typically erupt at about:",
      options: [
        "12 years of age",
        "16 years of age",
        "20 years of age",
        "25 years of age"
      ],
      correctAnswer: 2
    },
    {
      id: 992035,
      question: "Transitional dentition occurs after eruption of the first permanent tooth but before the teeth:",
      options: [
        "come into full occlusion",
        "finish forming their roots",
        "begin to show heavy wear",
        "develop their first cavities"
      ],
      correctAnswer: 0
    },
    {
      id: 992036,
      question: "In the young adolescent, posterior teeth appear to have short clinical crowns because of:",
      options: [
        "slow continued eruption tied to growth of the ramus",
        "rapid wear of the enamel during heavy chewing",
        "early loss of the overlying primary molar teeth",
        "a thick layer of plaque covering the crown tips"
      ],
      correctAnswer: 0
    },
    {
      id: 992037,
      question: "Compared with the age of eruption, a change in the sequence of eruption is a:",
      options: [
        "less reliable sign of a developmental problem",
        "more reliable sign of a developmental problem",
        "completely unrelated sign of a jaw fracture",
        "normal finding that requires no further action"
      ],
      correctAnswer: 1
    },
    {
      id: 992038,
      question: "Asymmetrical tooth eruption may be a sign of:",
      options: [
        "excellent arch development",
        "developmental discrepancies",
        "normal primate spacing",
        "complete dental maturity"
      ],
      correctAnswer: 1
    },
    {
      id: 992039,
      question: "Skeletal age refers to the development of the skeletal system in relation to the client's:",
      options: [
        "dental age",
        "chronologic age",
        "mental age",
        "gingival age"
      ],
      correctAnswer: 1
    },
    {
      id: 992040,
      question: "Chronologic age is defined as the client's age measured in:",
      options: [
        "weeks and days",
        "decades and years",
        "hours and minutes",
        "years and months"
      ],
      correctAnswer: 3
    },
    {
      id: 992041,
      question: "Dental age refers to the maturation of the teeth, including their:",
      options: [
        "enamel coloring",
        "clinical eruption",
        "surface roughness",
        "chewing strength"
      ],
      correctAnswer: 1
    },
    {
      id: 992042,
      question: "Besides eruption, shift, and position of the teeth, occlusion also depends on the:",
      options: [
        "skeletal growth of the mandible and maxilla",
        "daily intake of sugar in the child's diet",
        "frequency of professional dental cleanings",
        "thickness of the enamel on the front teeth"
      ],
      correctAnswer: 0
    },
    {
      id: 992043,
      question: "According to equilibrium theory, an object will move only if it is subjected to:",
      options: [
        "forces of equal magnitude",
        "no external force at all",
        "forces of unequal magnitude",
        "only the pull of gravity"
      ],
      correctAnswer: 2
    },
    {
      id: 992044,
      question: "In causing tooth movement, the duration of the force applied is:",
      options: [
        "less important than the strength of the force",
        "more important than the strength of the force",
        "exactly as important as the color of tooth",
        "unrelated to whether the tooth will move"
      ],
      correctAnswer: 1
    },
    {
      id: 992045,
      question: "Which of the following contributes to the equilibrium of forces applied to the teeth?",
      options: [
        "Mineral deposits within the tooth enamel",
        "Elastic gingival fibers around the teeth",
        "Air pressure inside the maxillary sinus",
        "Blood flow through the facial arteries"
      ],
      correctAnswer: 1
    },
    {
      id: 992046,
      question: "Tooth eruption and position within the arches are determined by forces from the tongue, cheeks, and lips, the periodontal ligament, and the:",
      options: [
        "mineral content of the saliva",
        "elasticity of the gingival fibers",
        "thickness of the cheek muscles",
        "pressure inside the ear canal"
      ],
      correctAnswer: 1
    },
    {
      id: 992047,
      question: "In order to affect the position of the teeth, a force must be applied for at least:",
      options: [
        "about 2 hours each day",
        "about 1 hour each day",
        "about 12 hours each day",
        "about 6 hours each day"
      ],
      correctAnswer: 3
    },
    {
      id: 992048,
      question: "Forces from the lips, tongue, and cheeks during mastication do not determine tooth position because their:",
      options: [
        "duration is much too short",
        "direction is always upward",
        "strength is much too great",
        "timing is always at night"
      ],
      correctAnswer: 0
    },
    {
      id: 992049,
      question: "Relapse after orthodontic treatment is prevented by the use of:",
      options: [
        "retainers and/or incision of the gingival fibers",
        "antibiotics and/or removal of the wisdom teeth",
        "fluoride gels and/or whitening of the enamel",
        "mouthguards and/or extraction of the molars"
      ],
      correctAnswer: 0
    },
    {
      id: 992050,
      question: "Frontal resorption is the process in which osteoclasts attack the lamina dura and:",
      options: [
        "add new bone on the pressure side of tooth",
        "remove bone on the pressure side of the tooth",
        "remove bone on the tension side of tooth",
        "add new enamel on the surface of tooth"
      ],
      correctAnswer: 1
    },
    {
      id: 992051,
      question: "After osteoclasts remove bone, the cells needed to remodel that bone are the:",
      options: [
        "fibroblasts",
        "odontoblasts",
        "ameloblasts",
        "osteoblasts"
      ],
      correctAnswer: 3
    },
    {
      id: 992052,
      question: "Osteoclastic and osteoblastic activities during tooth movement are stimulated by:",
      options: [
        "vitamin D pills",
        "prostaglandin E",
        "adrenaline rush",
        "insulin release"
      ],
      correctAnswer: 1
    },
    {
      id: 992053,
      question: "Forces considered ideal for orthodontic tooth movement are:",
      options: [
        "heavy and intermittent, producing rapid bone loss",
        "light and continuous, producing only frontal resorption",
        "light and intermittent, producing no bone change",
        "heavy and continuous, producing fast jaw growth"
      ],
      correctAnswer: 1
    },
    {
      id: 992054,
      question: "As the periodontal ligament becomes compressed during tooth movement, there is pain, altered blood flow, and:",
      options: [
        "immediate hardening of the enamel on the crown",
        "permanent loss of all sensation around the tooth",
        "release of cellular mediators within the ligament",
        "rapid growth of new nerves inside the tooth pulp"
      ],
      correctAnswer: 2
    },
    {
      id: 992055,
      question: "Differentiation into osteoclasts and osteoblasts occurs after sustained pressure lasting about:",
      options: [
        "6 days",
        "6 hours",
        "6 weeks",
        "6 months"
      ],
      correctAnswer: 1
    },
    {
      id: 992056,
      question: "During orthodontic tooth movement, the job of the osteoclasts is to:",
      options: [
        "form enamel",
        "remove bone",
        "build dentin",
        "close pulp"
      ],
      correctAnswer: 1
    },
    {
      id: 992057,
      question: "Osteoblasts remodel bone on the pressure side and also form new bone on the:",
      options: [
        "surface of the visible tooth crown",
        "side to which tension is applied",
        "roof of the maxillary sinus cavity",
        "floor of the mandibular canal space"
      ],
      correctAnswer: 1
    },
    {
      id: 992058,
      question: "A hyalinized area develops when sustained force is great enough to:",
      options: [
        "increase blood flow and speed up the healing rate",
        "stimulate new nerve growth within the dental pulp",
        "occlude blood vessels and cut off the blood supply",
        "harden the enamel surface of the affected tooth"
      ],
      correctAnswer: 2
    },
    {
      id: 992059,
      question: "Orthodontic appointments are typically scheduled no more frequently than every:",
      options: [
        "about 1 week apart",
        "about 2 days apart",
        "about 4 weeks apart",
        "about 6 months apart"
      ],
      correctAnswer: 2
    },
    {
      id: 992060,
      question: "Orthodontic force has implications on which of the following areas?",
      options: [
        "The salivary glands and the tongue muscles",
        "The facial nerve and the parotid gland duct",
        "The root structure and height of alveolar bone",
        "The nasal sinuses and the bony eye sockets"
      ],
      correctAnswer: 2
    },
    {
      id: 992061,
      question: "Removable appliances are used for which of the following purposes?",
      options: [
        "Permanent fusion of two adjacent teeth",
        "Complete closure of all extraction sites",
        "Rapid surgical repositioning of the jaws",
        "Retention after the completion of treatment"
      ],
      correctAnswer: 3
    },
    {
      id: 992062,
      question: "In orthodontic treatment, fixed appliances are described as:",
      options: [
        "useful for no cases",
        "required for most cases",
        "banned in most cases",
        "optional in all cases"
      ],
      correctAnswer: 1
    },
    {
      id: 992063,
      question: "One advantage of removable appliances is that they:",
      options: [
        "can never be lost or thrown away",
        "can be removed for social functions",
        "can complete the most complex moves",
        "can work without any cooperation"
      ],
      correctAnswer: 1
    },
    {
      id: 992064,
      question: "One disadvantage of removable appliances is that:",
      options: [
        "treatment depends heavily on client compliance",
        "they require far more chair time than fixed",
        "they cannot be removed for social functions",
        "they make complex tooth movement very easy"
      ],
      correctAnswer: 0
    },
    {
      id: 992065,
      question: "More modification of skeletal growth is possible with:",
      options: [
        "fixed appliances than with removable ones",
        "neither removable nor fixed appliances ever",
        "surgery alone, without any appliances used",
        "removable appliances than with fixed appliances"
      ],
      correctAnswer: 3
    },
    {
      id: 992066,
      question: "A cause of malaligned teeth in the early mixed dentition is:",
      options: [
        "lack of adequate space in the dental arch",
        "excess saliva production during the night",
        "early eruption of all the third molars",
        "complete absence of any primary teeth"
      ],
      correctAnswer: 0
    },
    {
      id: 992067,
      question: "Which of the following is a sign for the need for early orthodontic intervention?",
      options: [
        "Mandibular second molars erupt before second premolars",
        "Mandibular central incisors erupt before first molars",
        "Maxillary canines erupt before the lateral incisors",
        "Maxillary first molars erupt before the second molars"
      ],
      correctAnswer: 0
    },
    {
      id: 992068,
      question: "Which finding is a sign for the need for early orthodontic intervention?",
      options: [
        "Even spacing between all the primary front teeth",
        "Overretention or early loss of the primary teeth",
        "Symmetrical eruption on both sides of the mouth",
        "On-time eruption of every permanent tooth present"
      ],
      correctAnswer: 1
    },
    {
      id: 992069,
      question: "Leeway space is the difference in mesiodistal crown width between the primary canines and molars and their:",
      options: [
        "adjacent incisors",
        "opposing molars",
        "primary neighbors",
        "permanent successors"
      ],
      correctAnswer: 3
    },
    {
      id: 992070,
      question: "Which of the following is listed as a sign for early orthodontic intervention?",
      options: [
        "A complete absence of any tooth decay",
        "An even and symmetrical eruption order",
        "A midline diastema or impacted canines",
        "A normal amount of developmental spacing"
      ],
      correctAnswer: 2
    },
    {
      id: 992071,
      question: "A main goal of comprehensive orthodontic treatment is to make the occlusion as ideal as possible through:",
      options: [
        "repositioning of the teeth",
        "whitening of the teeth",
        "extraction of the teeth",
        "splinting of the teeth"
      ],
      correctAnswer: 0
    },
    {
      id: 992072,
      question: "Which is one of the three major stages of comprehensive orthodontic treatment?",
      options: [
        "Extraction of every primary tooth in the mouth",
        "Whitening of the enamel on all the front teeth",
        "Removal of the temporomandibular joint disc",
        "Alignment of teeth and leveling of the occlusal planes"
      ],
      correctAnswer: 3
    },
    {
      id: 992073,
      question: "Retention is necessary after orthodontic treatment partly because:",
      options: [
        "the brackets must stay bonded for several more years",
        "the teeth become permanently fixed once they align",
        "gingival and periodontal tissues need time to reorganize",
        "the jaws stop growing the moment braces come off"
      ],
      correctAnswer: 2
    },
    {
      id: 992074,
      question: "Reorganization of the periodontium after orthodontic treatment takes about:",
      options: [
        "about 3 to 4 months",
        "about 1 to 2 days",
        "about 5 to 6 years",
        "about 9 to 10 hours"
      ],
      correctAnswer: 0
    },
    {
      id: 992075,
      question: "The most common type of retainer is the:",
      options: [
        "fixed bracket worn on the mandibular arch",
        "clear aligner worn on both arches at once",
        "Hawley appliance worn on the maxillary arch",
        "metal band worn around each molar tooth"
      ],
      correctAnswer: 2
    },
    {
      id: 992076,
      question: "Fixed retainers are bonded to the teeth and are used for the:",
      options: [
        "short-term whitening of the enamel surface",
        "rapid extraction of the impacted canine teeth",
        "gradual closure of the maxillary sinus space",
        "long-term control of orthodontic alignment"
      ],
      correctAnswer: 3
    },
    {
      id: 992077,
      question: "The AAO recommends that a child first be examined by an orthodontist by the age of:",
      options: [
        "about 3 years old",
        "about 12 years old",
        "about 16 years old",
        "about 7 years old"
      ],
      correctAnswer: 3
    },
    {
      id: 992078,
      question: "For a client with multiple dental problems, orthodontic treatment can begin only after:",
      options: [
        "carious teeth are restored and disease is controlled",
        "all retainers have been worn for several years",
        "the crowns and bridges are completely finished",
        "the client reaches the age of forty or older"
      ],
      correctAnswer: 0
    },
    {
      id: 992079,
      question: "Definitive periodontal therapy such as osseous surgery is delayed until after orthodontic treatment because:",
      options: [
        "the gingiva cannot be numbed during treatment",
        "the alveolar bone changes during the treatment",
        "the teeth are too clean to operate on safely",
        "the insurance will not cover earlier surgery"
      ],
      correctAnswer: 1
    },
    {
      id: 992080,
      question: "Definitive restorative procedures such as crowns and bridges are completed:",
      options: [
        "before any disease is controlled",
        "during the very first appointment",
        "instead of any orthodontic care",
        "after the orthodontic treatment"
      ],
      correctAnswer: 3
    },
    {
      id: 992081,
      question: "The stated goals of orthodontic treatment planning are ideal occlusion, facial esthetics, and:",
      options: [
        "periodontal health and stability",
        "complete whitening of enamel",
        "removal of the wisdom teeth",
        "permanent fusion of the jaws"
      ],
      correctAnswer: 0
    },
    {
      id: 992082,
      question: "One of the three goals of profile analysis is to determine the position of the jaws in the:",
      options: [
        "horizontal plane of the eyes",
        "vertical plane of the nose",
        "anteroposterior plane of space",
        "transverse plane of the ears"
      ],
      correctAnswer: 2
    },
    {
      id: 992083,
      question: "A goal of profile analysis is to assess the posture of the lips and the position of the:",
      options: [
        "sinuses",
        "tonsils",
        "earlobes",
        "incisors"
      ],
      correctAnswer: 3
    },
    {
      id: 992084,
      question: "Which of the following is included among the orthodontic diagnostic records?",
      options: [
        "A complete blood count and a clean urine sample",
        "A daily food diary and an electronic sleep tracker",
        "Diagnostic dental casts and a wax bite registration",
        "A handwriting sample and a standard vision test"
      ],
      correctAnswer: 2
    },
    {
      id: 992085,
      question: "Which is listed as a baseline factor to be assessed during orthodontic diagnosis?",
      options: [
        "Shoe size, including width and arch height",
        "Hair color, including any recent dye changes",
        "Handedness, including grip strength on each side",
        "Health history, including diseases and medications"
      ],
      correctAnswer: 3
    },
    {
      id: 992086,
      question: "For the adult with periodontal disease, dental hygiene care is considered complete only when:",
      options: [
        "every tooth has been crowned and root canal treated",
        "the client agrees to wear a retainer for the rest of life",
        "inflammation is controlled enough for safe tooth movement",
        "all of the wisdom teeth have been surgically removed"
      ],
      correctAnswer: 2
    },
    {
      id: 992087,
      question: "Clients with periodontal disease must be seen for professional supportive periodontal maintenance every:",
      options: [
        "2 to 3 months",
        "2 to 3 years",
        "2 to 3 days",
        "2 to 3 weeks"
      ],
      correctAnswer: 0
    },
    {
      id: 992088,
      question: "Control of which factor is described as key to managing the adult with periodontal disease?",
      options: [
        "Saliva flow",
        "Plaque biofilm",
        "Jaw width",
        "Tooth shade"
      ],
      correctAnswer: 1
    },
    {
      id: 992089,
      question: "Care of the orthodontic client by the dental hygienist includes:",
      options: [
        "providing nutritional assessment and counseling",
        "bending and adjusting the metal archwires",
        "performing the orthognathic surgery on jaws",
        "diagnosing the underlying skeletal growth"
      ],
      correctAnswer: 0
    },
    {
      id: 992090,
      question: "Clients with fixed appliances are advised to brush:",
      options: [
        "three times a day with a fluoride dentifrice",
        "once a week with a whitening dentifrice only",
        "only at night with a non-fluoride toothpaste",
        "every other day with plain lukewarm water"
      ],
      correctAnswer: 0
    },
    {
      id: 992091,
      question: "A floss threader or super floss is recommended to clean:",
      options: [
        "subgingivally on the proximal tooth surfaces",
        "the chewing surfaces of the front teeth only",
        "the outside of the metal orthodontic brackets",
        "the roof of the mouth near the back of throat"
      ],
      correctAnswer: 0
    },
    {
      id: 992092,
      question: "When using an oral irrigator, the client should set it on:",
      options: [
        "high power and aim it straight at the gums",
        "low power and aim it underneath the tongue",
        "low power and aim it just above the papilla",
        "high power and aim it at the cheek lining"
      ],
      correctAnswer: 2
    },
    {
      id: 992093,
      question: "When chlorhexidine is prescribed, it should be separated from fluoride use by about:",
      options: [
        "5 minutes for the effective use of each",
        "60 minutes for the effective use of each",
        "12 hours for the effective use of each",
        "3 days for the effective use of each"
      ],
      correctAnswer: 1
    },
    {
      id: 992094,
      question: "A floss threader is used during interdental cleaning to:",
      options: [
        "polish the surface of brackets",
        "remove a loose metal band",
        "tighten the elastic ties on",
        "place floss under the archwire"
      ],
      correctAnswer: 3
    },
    {
      id: 992095,
      question: "During interdental cleaning, a rubber-tip stimulator is used to:",
      options: [
        "thread the floss beneath the archwire",
        "place fluoride gel into the deep pockets",
        "bend the archwire back into proper shape",
        "disrupt plaque and massage the papillae"
      ],
      correctAnswer: 3
    },
    {
      id: 992096,
      question: "Which food should be avoided when wearing fixed orthodontic appliances?",
      options: [
        "Soft yogurt and applesauce",
        "Cooked pasta and low-sugar foods",
        "Fruit cut into small soft pieces",
        "Hard candy and whole apples"
      ],
      correctAnswer: 3
    },
    {
      id: 992097,
      question: "Which food is recommended for clients wearing fixed orthodontic appliances?",
      options: [
        "Caramels and chewing gum",
        "Popcorn and corn on the cob",
        "Hard pretzels and crunchy ice",
        "Applesauce and plain yogurt"
      ],
      correctAnswer: 3
    },
    {
      id: 992098,
      question: "While in the hospital, oral hygiene care for the surgical client consists of frequent:",
      options: [
        "whitening treatment with a high-powered laser unit",
        "scaling appointment with an ultrasonic hand instrument",
        "saline irrigation with a 30-ml syringe and blunt needle",
        "fluoride varnish application with a small foam brush"
      ],
      correctAnswer: 2
    },
    {
      id: 992099,
      question: "For the first 2 weeks after orthognathic surgery, clients continue to:",
      options: [
        "floss aggressively around every single bracket",
        "irrigate with the use of saline and a syringe",
        "brush the lingual surfaces several times a day",
        "chew sugarless gum to strengthen the jaw bones"
      ],
      correctAnswer: 1
    },
    {
      id: 992100,
      question: "Surgical orthodontic clients require instruction in physical therapy techniques to restore:",
      options: [
        "color of the enamel and shine of the surfaces",
        "growth of the roots and length of the crowns",
        "function of the lips and ability to open the jaws",
        "flow of the saliva and moisture of the tongue"
      ],
      correctAnswer: 2
    },
    {
      id: 992101,
      question: "After surgical incisions have healed, the recommended antimicrobial agent for postsurgical rinsing is:",
      options: [
        "hydrogen peroxide, valued for its foaming action",
        "table salt water, valued for its very low cost",
        "chlorhexidine, valued for its low alcohol content",
        "rubbing alcohol, valued for its strong odor"
      ],
      correctAnswer: 2
    },
    {
      id: 992102,
      question: "From 2 to 8 weeks after surgery, plaque control may include:",
      options: [
        "vigorous scrubbing with a stiff hard-bristled brush",
        "complete avoidance of all toothbrushing for weeks",
        "daily polishing with a coarse abrasive whitener",
        "modified sulcular brushing with a soft-bristled brush"
      ],
      correctAnswer: 3
    },
    {
      id: 992103,
      question: "In postsurgical dietary recommendations, clients are advised to avoid:",
      options: [
        "all nutritious liquid drinks",
        "all plain drinking water",
        "any carbonated beverages",
        "all high-caloric liquids"
      ],
      correctAnswer: 2
    },
    {
      id: 992104,
      question: "Compared with a dentist, an orthodontist is best described as a:",
      options: [
        "specialist in tooth and jaw alignment",
        "generalist in all dental and oral health",
        "specialist in root canals and pulp therapy",
        "generalist in gum disease and cleanings"
      ],
      correctAnswer: 0
    },
    {
      id: 992105,
      question: "Angle's classification of malocclusion applies only to the permanent dentition.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 992106,
      question: "In causing tooth movement, the strength of the force is more important than its duration.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 992107,
      question: "The most common type of retainer is the Hawley appliance, which is worn on the maxillary arch.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 992108,
      question: "Definitive restorative procedures such as crowns and bridges are completed before orthodontic treatment begins.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 992109,
      question: "The duration of a force must be at least about 6 hours per day to affect the position of the teeth.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 992110,
      question: "Developmental spacing between the primary incisors indicates that the teeth will be crowded in the permanent dentition.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 992111,
      question: "The AAO recommends that a child be examined by an orthodontist by the age of 7 years.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 992112,
      question: "During orthodontic tooth movement, the job of the osteoclasts is to form new bone.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 992113,
      question: "Forces that are light and continuous and produce only frontal resorption are considered ideal for tooth movement.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 992114,
      question: "The three basic spatial planes used to describe malocclusion are horizontal, vertical, and transverse.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 992115,
      question: "Fixed appliances are required for most orthodontic cases.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 992116,
      question: "Reorganization of the periodontium after orthodontic treatment takes 3 to 4 months.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    }
  ],
  "8. Introduction to Orthodontics (Part 3)": [
    {
      id: 993001,
      question: "Orthodontics is best defined as a dental specialty that deals with the:",
      options: [
        "recognition, prevention, and treatment of irregularities of the teeth, jaws, and face",
        "restoration, cleaning, and polishing of damaged teeth, gums, and tooth roots",
        "extraction, replacement, and implantation of decayed teeth and oral tissues",
        "diagnosis, scaling, and whitening of stained teeth and other oral surfaces"
      ],
      correctAnswer: 0
    },
    {
      id: 993002,
      question: "Which of the following is one of the stated goals of orthodontics?",
      options: [
        "Eliminate the need for any future restorative dental treatment",
        "Increase the total number of erupted teeth in both dental arches",
        "Reduce the natural curvature of the jaw to a perfectly flat line",
        "Establish the best physiological position of the condyle in the TMJ"
      ],
      correctAnswer: 3
    },
    {
      id: 993003,
      question: "According to the listed goals, orthodontics aims to promote:",
      options: [
        "long-term stability of the corrected dentition and the occlusion",
        "rapid tooth movement regardless of any long-term outcome at all",
        "complete removal of all bacteria from the entire oral cavity area",
        "permanent fusion of the maxillary and mandibular dental arches"
      ],
      correctAnswer: 0
    },
    {
      id: 993004,
      question: "Preventive orthodontics refers to procedures designed to:",
      options: [
        "reverse all damage caused by previously untreated malocclusions",
        "replace missing teeth with fixed appliances and dental implants",
        "prevent or minimize the degree of severity of future problems",
        "realign only the molars while leaving the front teeth untouched"
      ],
      correctAnswer: 2
    },
    {
      id: 993005,
      question: "Corrective orthodontic treatment involves the movement of teeth and the:",
      options: [
        "complete prevention of any decay forming on the treated surfaces",
        "whitening of discolored enamel using force from fixed appliances",
        "removal of all primary teeth before the permanent teeth can erupt",
        "correction of malrelationships and malformations of the structures"
      ],
      correctAnswer: 3
    },
    {
      id: 993006,
      question: "Occlusion is defined as the contact relationship between maxillary and mandibular teeth when the jaws are:",
      options: [
        "separated widely apart during the act of chewing on tough foods",
        "in a fully closed position, and between the teeth in the same arch",
        "moving rapidly from side to side during normal patterns of speech",
        "held in a resting state with the lips kept slightly parted open"
      ],
      correctAnswer: 1
    },
    {
      id: 993007,
      question: "As the primary teeth erupt in a child, the developing occlusion is influenced by the development of the:",
      options: [
        "salivary glands and the surrounding lymph node structures",
        "facial muscles and the established neuromuscular patterns",
        "nasal cavity and the position of the developing sinus areas",
        "tongue papillae and the taste receptors located along them"
      ],
      correctAnswer: 1
    },
    {
      id: 993008,
      question: "Which term describes the condition in which one or more teeth are congenitally missing?",
      options: [
        "Microdontia, which results in unusually small but present teeth",
        "Supernumerary, which is the presence of additional extra teeth",
        "Anodontia, which may be partial or complete and can be genetic",
        "Macrodontia, which results in unusually large but present teeth"
      ],
      correctAnswer: 2
    },
    {
      id: 993009,
      question: "The terms microdontia and macrodontia are used to describe teeth that:",
      options: [
        "vary in shape, such as peg-shaped lateral incisors and the molars",
        "erupt early or late compared to the normal eruption schedule",
        "are missing entirely from one or from both of the dental arches",
        "vary in size, being either very small or very large in their form"
      ],
      correctAnswer: 3
    },
    {
      id: 993010,
      question: "Supernumerary teeth are best described as:",
      options: [
        "teeth that fail to erupt because their path is fully blocked off",
        "teeth that erupt into an abnormal position within the dental arch",
        "extra teeth that are present beyond the normal expected number",
        "teeth that are congenitally absent from one of the dental arches"
      ],
      correctAnswer: 2
    },
    {
      id: 993011,
      question: "When the eruption of a tooth is blocked and prevented from erupting, the condition is called:",
      options: [
        "ectopic eruption into an abnormal position within the dental arch",
        "supraversion, in which the tooth erupts beyond the occlusal plane",
        "anodontia, in which the tooth is congenitally absent at the birth",
        "impaction, in which the normal eruption is completely blocked"
      ],
      correctAnswer: 3
    },
    {
      id: 993012,
      question: "Ectopic eruption occurs when a tooth is:",
      options: [
        "completely prevented from erupting due to a physical blockage",
        "present in addition to the normal complement of erupted teeth",
        "forced to erupt into an abnormal position within the dental arch",
        "shed much earlier than the expected schedule for that one tooth"
      ],
      correctAnswer: 2
    },
    {
      id: 993013,
      question: "Genetic causes are responsible for malocclusion mainly when there are discrepancies in the:",
      options: [
        "size of the jaw and/or the size of the teeth in the dental arches",
        "color of the enamel and/or the thickness of the soft gum tissue",
        "number of taste buds and/or the strength of the chewing force",
        "amount of saliva produced and/or the speed of the tooth eruption"
      ],
      correctAnswer: 0
    },
    {
      id: 993014,
      question: "A genetically based malocclusion happens most commonly when a child inherits:",
      options: [
        "identical jaw and identical tooth sizes from both of the parents",
        "a small jaw from one parent and larger teeth from the other one",
        "a large jaw from one parent and smaller teeth from the other one",
        "weakened enamel from one parent and strong roots from the other"
      ],
      correctAnswer: 1
    },
    {
      id: 993015,
      question: "If a person has a congenitally missing tooth, it is most likely that:",
      options: [
        "the tooth was lost due to trauma during early childhood years",
        "the tooth was removed during a previous orthodontic treatment",
        "a parent or grandparent has that same tooth missing as well",
        "the missing tooth has no connection to any inherited patterns"
      ],
      correctAnswer: 2
    },
    {
      id: 993016,
      question: "According to the material, tooth development and physical development are:",
      options: [
        "always perfectly synchronized throughout a person's whole lifetime",
        "entirely controlled by the diet a person consumes while still young",
        "independent of one another and follow two separate timelines",
        "determined only by the environment and never by any genetic factor"
      ],
      correctAnswer: 2
    },
    {
      id: 993017,
      question: "Which of the following can significantly impact the development of the teeth?",
      options: [
        "The frequency of toothbrushing during the adolescent years",
        "Serious illness, nutritional deprivation, and physical trauma",
        "The type of toothpaste used during early childhood development",
        "The total number of dental checkups attended before adulthood"
      ],
      correctAnswer: 1
    },
    {
      id: 993018,
      question: "As teeth erupt into function, genetics and the environment determine tooth position, but tooth arrangement is affected by:",
      options: [
        "the total volume of saliva that is secreted into the oral cavity",
        "muscle pressure exerted on the teeth from the surrounding tissues",
        "the order in which the primary teeth were originally shed earlier",
        "the temperature of the foods that are most frequently consumed"
      ],
      correctAnswer: 1
    },
    {
      id: 993019,
      question: "According to the notes on dental development, girls compared with boys generally:",
      options: [
        "have noticeably larger teeth across both of the two dental arches",
        "experience tooth eruption at a considerably later average age",
        "develop a greater total number of supernumerary extra teeth",
        "shed primary teeth and receive permanent teeth slightly earlier"
      ],
      correctAnswer: 3
    },
    {
      id: 993020,
      question: "Which of the following is an environmental cause of malocclusion related to injury?",
      options: [
        "Inheritance of a small jaw combined with larger sized teeth",
        "Damage to permanent tooth buds when primary teeth are injured",
        "A tooth being congenitally absent because of a genetic pattern",
        "Variation in the natural shape of the lateral incisor crowns"
      ],
      correctAnswer: 1
    },
    {
      id: 993021,
      question: "The premature loss of a primary tooth can lead to malocclusion because it may cause:",
      options: [
        "the movement of nearby teeth into the space that was created",
        "the immediate eruption of supernumerary teeth into the open gap",
        "a permanent halt to the development of the underlying tooth bud",
        "the complete fusion of the adjacent teeth across the empty space"
      ],
      correctAnswer: 0
    },
    {
      id: 993022,
      question: "Sucking habits involving the thumb, tongue, lip, or finger during the primary dentition years are:",
      options: [
        "always a sign of a serious underlying skeletal jaw deformity",
        "guaranteed to cause permanent damage to the developing teeth",
        "considered normal and have few long-term effects at that stage",
        "never of any concern even if they continue into the adult years"
      ],
      correctAnswer: 2
    },
    {
      id: 993023,
      question: "An ideal occlusion with 138 occlusal contacts among the 32 permanent teeth in closure:",
      options: [
        "is found in the great majority of adults with permanent teeth",
        "develops naturally once all of the primary teeth have been shed",
        "rarely, if ever, actually exists in a real human dentition",
        "can only be achieved through completed orthodontic treatment"
      ],
      correctAnswer: 2
    },
    {
      id: 993024,
      question: "Centric occlusion is defined as the relation of opposing occlusal surfaces that provides the:",
      options: [
        "maximum planned contact and/or intercuspation when teeth close",
        "widest possible separation of the arches during a chewing motion",
        "least amount of tooth contact while still allowing normal speech",
        "earliest point of contact as the lower jaw first begins to close"
      ],
      correctAnswer: 0
    },
    {
      id: 993025,
      question: "In a normal occlusion at centric position, each tooth occludes with two opposing teeth, except for the:",
      options: [
        "maxillary central incisors and the mandibular molar teeth",
        "mandibular canine teeth and the maxillary premolar teeth",
        "maxillary lateral incisors and the mandibular canine teeth",
        "mandibular central incisors and the maxillary molar teeth"
      ],
      correctAnswer: 3
    },
    {
      id: 993026,
      question: "Overjet is best described as the:",
      options: [
        "vertical overlap of the maxillary teeth, also called a deep bite",
        "horizontal overlap of the maxillary teeth, also called protrusion",
        "complete absence of any contact between the front teeth at all",
        "lingual tipping of the lower incisors behind the upper incisors"
      ],
      correctAnswer: 1
    },
    {
      id: 993027,
      question: "The measurement of overjet is taken from the:",
      options: [
        "lingual surface of the maxillary molar to the mandibular cusp",
        "labial surface of the mandibular incisor to the maxillary edge",
        "incisal edge of the lower canine to the upper canine surface",
        "gingival margin of the upper incisor to the lower root apex"
      ],
      correctAnswer: 1
    },
    {
      id: 993028,
      question: "Overbite is best described as the:",
      options: [
        "horizontal overlap of the maxillary teeth, also called protrusion",
        "vertical overlap of the maxillary teeth, also called a deep bite",
        "sideways shifting of the lower arch relative to the upper arch",
        "failure of the front teeth to make any contact while biting down"
      ],
      correctAnswer: 1
    },
    {
      id: 993029,
      question: "A normal overbite is classified as approximately:",
      options: [
        "a complete overlap reaching all the way down to the gingiva",
        "a one-third overlap of the lower incisors by the upper teeth",
        "an overlap of only the very tip of the lower incisor edges",
        "an overlap covering the middle third of the lower front teeth"
      ],
      correctAnswer: 1
    },
    {
      id: 993030,
      question: "The first guidelines clearly describing normal and abnormal tooth relationships were developed in the 1890s by:",
      options: [
        "G. V. Black, using the mandibular incisors as the main key",
        "Pierre Fauchard, using the maxillary canines as the main key",
        "Willoughby Miller, using the second molars as the central key",
        "Edward H. Angle, using the maxillary first molars as the key"
      ],
      correctAnswer: 3
    },
    {
      id: 993031,
      question: "A recognized limitation of Angle's classification system is that it:",
      options: [
        "requires expensive radiographic equipment that is hard to use",
        "can only be applied accurately to the primary tooth dentition",
        "only considers the anteroposterior plane of space for the teeth",
        "ignores the position of the molars when classifying the bite"
      ],
      correctAnswer: 2
    },
    {
      id: 993032,
      question: "In a Class I occlusion, the mesiobuccal cusp of the maxillary first molar occludes:",
      options: [
        "with the occlusal fossa of the maxillary second molar tooth",
        "in the interdental space mesial to the mandibular canine",
        "in the buccal groove of the mandibular first molar tooth",
        "against the lingual surface of the mandibular lateral incisor"
      ],
      correctAnswer: 2
    },
    {
      id: 993033,
      question: "Class II, Division 1 malocclusion is characterized by Class II molars and:",
      options: [
        "protruded anterior teeth, and is the most common deformity",
        "retroclined central incisors overlapped by the lateral teeth",
        "a prognathic appearance caused by an overgrown lower jaw",
        "a perfectly normal molar relationship with aligned front teeth"
      ],
      correctAnswer: 0
    },
    {
      id: 993034,
      question: "Class II, Division 2 malocclusion is distinguished from Division 1 by:",
      options: [
        "anterior teeth that are clearly protruded and flared outward",
        "a mandible that sits in a mesial relationship to the maxilla",
        "molar relationships that are entirely within the normal range",
        "retroclined centrals with the lateral teeth overlapping them"
      ],
      correctAnswer: 3
    },
    {
      id: 993035,
      question: "A Class III deformity typically yields an appearance described as:",
      options: [
        "retrognathic, or a weak and clearly recessed lower chin profile",
        "prognathic, or a strong chin, from differences in jaw size",
        "a long, gummy smile caused by over-erupted upper front incisors",
        "a perfectly balanced facial profile with no noticeable changes"
      ],
      correctAnswer: 1
    },
    {
      id: 993036,
      question: "A malocclusion is defined as any deviation from the normal relationship of the:",
      options: [
        "enamel surface of a tooth to its underlying dentin layer",
        "gingival tissue to the cementum along the root surface area",
        "temporomandibular joint to the base of the cranial skull",
        "maxillary arch or teeth to the mandibular arch or teeth"
      ],
      correctAnswer: 3
    },
    {
      id: 993037,
      question: "Which of the following is listed as a problem that can arise from untreated malocclusion?",
      options: [
        "A permanent increase in the total saliva flow within the mouth",
        "An automatic strengthening of the periodontal support tissues",
        "The spontaneous correction of any crowded or rotated teeth",
        "Temporomandibular dysfunction affecting chewing and speech"
      ],
      correctAnswer: 3
    },
    {
      id: 993038,
      question: "For the classification of skeletal malocclusion, the three basic spatial planes involved are the:",
      options: [
        "sagittal, transverse, and occlusal planes of the structures",
        "frontal, lateral, and horizontal planes of the facial bones",
        "mesial, distal, and incisal planes of the individual teeth",
        "buccal, lingual, and apical planes of the supporting tissues"
      ],
      correctAnswer: 0
    },
    {
      id: 993039,
      question: "Vertical skeletal malocclusions include:",
      options: [
        "open bites and severe overbites, also called deep overbites",
        "crossbites occurring on the sides and the front of the mouth",
        "Class II and Class III anteroposterior molar relationships",
        "edge-to-edge contact between the upper and lower front teeth"
      ],
      correctAnswer: 0
    },
    {
      id: 993040,
      question: "A crossbite occurs when one or more upper teeth:",
      options: [
        "bite on the inside of the lower teeth, at the front or the sides",
        "fail to make any contact at all with the opposing lower teeth",
        "overlap the lower teeth vertically by more than one-third deep",
        "are positioned too far ahead of the corresponding lower teeth"
      ],
      correctAnswer: 0
    },
    {
      id: 993041,
      question: "An underbite, in which the lower teeth protrude past the front teeth, is usually caused by:",
      options: [
        "a horizontal overlap of the upper teeth far beyond the lower ones",
        "over-eruption of the upper incisors past the edge of the top lip",
        "undergrowth of the upper jaw, overgrowth of the lower jaw, or both",
        "the upper teeth biting on the inside of the lower posterior teeth"
      ],
      correctAnswer: 2
    },
    {
      id: 993042,
      question: "\"Long face syndrome\" refers to an anterior open bite in which the mandible is:",
      options: [
        "rotated upward and forward with insufficiently erupted posterior teeth",
        "shifted sideways so the upper teeth sit inside the lower posterior teeth",
        "aligned quite normally while only the anterior teeth are tipped outward",
        "positioned too far downward and backward with over-erupted posteriors"
      ],
      correctAnswer: 3
    },
    {
      id: 993043,
      question: "\"Short face syndrome\" is described as insufficient eruption of the posterior teeth and a:",
      options: [
        "flat mandibular plane creating a severe anterior overbite",
        "steep mandibular plane creating a wide anterior open bite",
        "sideways crossbite affecting the entire posterior segment",
        "protrusion of the anterior teeth beyond the lower front teeth"
      ],
      correctAnswer: 0
    },
    {
      id: 993044,
      question: "A posterior crossbite exists in the transverse plane when the buccal cusps of the maxillary teeth are:",
      options: [
        "lingual to their normal relationship with the mandibular teeth",
        "positioned far ahead of their normal contact with the lower teeth",
        "erupted well beyond the normal level of the whole occlusal plane",
        "absent entirely from any contact with the opposing lower teeth"
      ],
      correctAnswer: 0
    },
    {
      id: 993045,
      question: "Facioversion describes a tooth that is positioned:",
      options: [
        "toward the tongue, lingual to its normal position in the arch",
        "beyond the occlusal plane due to a lack of opposing contact",
        "toward the face or cheek, away from its normal arch alignment",
        "rotated around its own long axis within the dental arch space"
      ],
      correctAnswer: 2
    },
    {
      id: 993046,
      question: "Linguoversion describes a tooth that is positioned:",
      options: [
        "toward the tongue, lingual to its normal location in the arch",
        "toward the cheek, facial to its normal location in the arch",
        "higher than the occlusal plane because of over-eruption issues",
        "twisted on its own long axis relative to the neighboring teeth"
      ],
      correctAnswer: 0
    },
    {
      id: 993047,
      question: "Supraversion, also called over-eruption, refers to a tooth that has:",
      options: [
        "been forced toward the tongue side of the dental arch line",
        "erupted beyond the normal occlusal plane of the dental arch",
        "rotated around its own long axis within its place in the arch",
        "failed to erupt at all because its path was completely blocked"
      ],
      correctAnswer: 1
    },
    {
      id: 993048,
      question: "According to the material, in most cases a malocclusion is caused by:",
      options: [
        "a single isolated genetic factor passed down from one parent",
        "the premature loss of one primary tooth during the childhood",
        "an oral habit such as thumb sucking that was never corrected",
        "a combination of both skeletal and dental discrepancies"
      ],
      correctAnswer: 3
    },
    {
      id: 993049,
      question: "The eruption of the permanent teeth is affected by the shedding of the primary teeth and will in turn affect the occlusion.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 993050,
      question: "According to the material, teeth are slightly larger in boys than in girls.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 993051,
      question: "Class II, Division 1 is described as probably the most common skeletal deformity.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 993052,
      question: "When teeth do not occlude properly, the resulting unnatural stress on the teeth and periodontium may lead to pain and/or occlusal trauma.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 993053,
      question: "Habits that contribute to malalignment do NOT need to be corrected for orthodontic treatment to be successful.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    }
  ],
  "8. Introduction to Orthodontics (Part 4)": [
    {
      id: 994001,
      question: "What is an orthodontic band?",
      options: [
        "A grooved metal piece bonded to the facial surface of a tooth",
        "A metal ring that encircles a tooth and carries a tube or bracket",
        "A thin elastic donut that ties the main wire into a bracket",
        "A small metal extension that holds elastics onto the braces"
      ],
      correctAnswer: 1
    },
    {
      id: 994002,
      question: "In orthodontics, what is an attachment?",
      options: [
        "A tube or bracket that is welded onto a band",
        "A wire that ties the archwire into each bracket groove",
        "A metal ring that is cemented around a molar tooth",
        "A spring that is placed between two adjacent brackets"
      ],
      correctAnswer: 0
    },
    {
      id: 994003,
      question: "How is an orthodontic bracket best described?",
      options: [
        "A ring of metal that fully surrounds a tooth on every side",
        "A grooved piece on a band or tooth that holds the main wire",
        "A pipe into which the archwire or night brace is inserted",
        "A rubber connector that ties the wire into a tooth groove"
      ],
      correctAnswer: 1
    },
    {
      id: 994004,
      question: "The archwire is the main wire on which the teeth slide like:",
      options: [
        "A bead sliding along a length of string",
        "A door swinging on a fixed metal hinge",
        "A train moving along a set of rails",
        "A wheel turning around a center axle"
      ],
      correctAnswer: 2
    },
    {
      id: 994005,
      question: "What is the function of a ligature?",
      options: [
        "To tie or lash the archwire into the groove on each bracket",
        "To weld a tube or bracket securely onto a metal band",
        "To create space between teeth before bands are cemented",
        "To attach rubber bands between the upper and lower arches"
      ],
      correctAnswer: 0
    },
    {
      id: 994006,
      question: "What are hooks used for on braces?",
      options: [
        "To hold the main archwire in the bracket",
        "To attach rubber bands onto the braces",
        "To create space between crowded teeth",
        "To roughen the enamel before bonding"
      ],
      correctAnswer: 1
    },
    {
      id: 994007,
      question: "A spring placed on the archwire between two brackets is used to:",
      options: [
        "Push teeth apart or pull two teeth together",
        "Tie the archwire firmly into each bracket",
        "Hold elastics between the two dental arches",
        "Cement a band around the first molar tooth"
      ],
      correctAnswer: 0
    },
    {
      id: 994008,
      question: "What is a tube in orthodontic appliances?",
      options: [
        "A grooved piece that holds the main wire on a tooth",
        "A rubber ring that ties the wire into the bracket slot",
        "A pipe into which the archwire or night brace is inserted",
        "A metal hook used to attach elastics to the braces"
      ],
      correctAnswer: 2
    },
    {
      id: 994009,
      question: "What attaches a bracket to the tooth?",
      options: [
        "A ligature elastic or a colored o-ring",
        "A power chain or a small coil spring",
        "A periodontal probe or a mouth mirror",
        "Bonding material (glue) or a metal band"
      ],
      correctAnswer: 3
    },
    {
      id: 994010,
      question: "Brackets that do not need elastic ligatures are called:",
      options: [
        "Direct-bonded brackets",
        "Ceramic mesh brackets",
        "Self-ligating brackets",
        "Preformed band brackets"
      ],
      correctAnswer: 2
    },
    {
      id: 994011,
      question: "The initial archwire, called a twist wire, behaves like:",
      options: [
        "A solid bar that resists any kind of bending",
        "A soft ribbon that keeps its curved shape",
        "A small cable that wants to remain straight",
        "A rigid rod that returns to a coiled shape"
      ],
      correctAnswer: 2
    },
    {
      id: 994012,
      question: "The temperature inside the mouth is roughly how much above room temperature?",
      options: [
        "About 5 to 10 degrees",
        "About 20 to 25 degrees",
        "About 35 to 40 degrees",
        "About 50 to 55 degrees"
      ],
      correctAnswer: 1
    },
    {
      id: 994013,
      question: "In braided or twisted wires, separate strands may be as small as:",
      options: [
        "0.005 or 0.010",
        "0.025 or 0.030",
        "0.050 or 0.075",
        "0.100 or 0.150"
      ],
      correctAnswer: 0
    },
    {
      id: 994014,
      question: "Braided or twisted wires are typically made of how many strands around a central wire?",
      options: [
        "Five or seven strands",
        "Two or three strands",
        "Nine or ten strands",
        "Twelve or fifteen strands"
      ],
      correctAnswer: 0
    },
    {
      id: 994015,
      question: "A triple-stranded multi-stranded wire is made of:",
      options: [
        "Three wires twisted together",
        "Five wires around a core wire",
        "Eight strands in a rectangle",
        "Two wires welded side by side"
      ],
      correctAnswer: 0
    },
    {
      id: 994016,
      question: "A coaxial wire is described as:",
      options: [
        "Three wires twisted around each other",
        "Eight strands formed into a rectangle",
        "Two wires braided around a center",
        "Five wires wrapped around a core wire"
      ],
      correctAnswer: 3
    },
    {
      id: 994017,
      question: "A braided multi-stranded wire is described as:",
      options: [
        "An eight-strand rectangular wire",
        "A three-strand twisted round wire",
        "A five-strand coaxial round wire",
        "A two-strand welded flat wire"
      ],
      correctAnswer: 0
    },
    {
      id: 994018,
      question: "The solid wires used later in treatment are made of:",
      options: [
        "A pure soft copper alloy",
        "A coated stainless lead alloy",
        "A heavy solid platinum alloy",
        "A nickel-titanium alloy"
      ],
      correctAnswer: 3
    },
    {
      id: 994019,
      question: "About how long does the osteoclast (breakdown) process take to get fully going?",
      options: [
        "About 10 days",
        "About 90 days",
        "About 10 months",
        "About 72 hours"
      ],
      correctAnswer: 3
    },
    {
      id: 994020,
      question: "About how long does the osteoblast (rebuild) process take?",
      options: [
        "About 72 hours",
        "About 7 days",
        "About 90 days",
        "About 10 months"
      ],
      correctAnswer: 2
    },
    {
      id: 994021,
      question: "Stabilizing the orthodontic result takes about how long, making a retainer important?",
      options: [
        "About 72 hours",
        "About 10 months",
        "About 30 days",
        "About 5 years"
      ],
      correctAnswer: 1
    },
    {
      id: 994022,
      question: "Bonding is the process by which orthodontic brackets are:",
      options: [
        "Welded onto a metal band",
        "Removed at the end of care",
        "Tied onto the main archwire",
        "Affixed to the tooth surface"
      ],
      correctAnswer: 3
    },
    {
      id: 994023,
      question: "The resin frequently used in bonding is:",
      options: [
        "Calcium-releasing and heat-activated",
        "Fluoride-releasing and light-activated",
        "Chlorine-releasing and air-activated",
        "Mineral-releasing and acid-activated"
      ],
      correctAnswer: 1
    },
    {
      id: 994024,
      question: "Direct bonding is best described as:",
      options: [
        "A two-step procedure using a transfer tray or template",
        "A method that cements metal bands onto the molars",
        "A process that removes the brackets from the teeth",
        "A single-step procedure bonding attachments individually"
      ],
      correctAnswer: 3
    },
    {
      id: 994025,
      question: "Indirect bonding uses a template or tray because it:",
      options: [
        "Transfers attachments from a study cast at one time",
        "Bonds each attachment individually inside the mouth",
        "Removes residual adhesive after the brackets come off",
        "Creates space between teeth before bands are placed"
      ],
      correctAnswer: 0
    },
    {
      id: 994026,
      question: "Stainless steel bands are cemented to the permanent first molar because:",
      options: [
        "They are quicker and easier to place than the brackets",
        "They allow better plaque control at the cervical third",
        "They give the strength to hold palatal bars and elastics",
        "They can be bonded onto teeth that are partly erupted"
      ],
      correctAnswer: 2
    },
    {
      id: 994027,
      question: "Brackets are bonded to which surfaces to retain the archwire?",
      options: [
        "The lingual surfaces of the teeth",
        "The occlusal surfaces of the teeth",
        "The proximal surfaces of the teeth",
        "The facial surfaces of the teeth"
      ],
      correctAnswer: 3
    },
    {
      id: 994028,
      question: "Which is an advantage of bonded brackets over bands?",
      options: [
        "The attachment has more surface area on the tooth",
        "Rebonding a loose bracket is quicker than a band",
        "Placement is faster and easier than placing bands",
        "Debonding causes no potential damage to the enamel"
      ],
      correctAnswer: 2
    },
    {
      id: 994029,
      question: "Which is a disadvantage of bonded brackets?",
      options: [
        "They give worse access for plaque control at the gumline",
        "They can detach more readily due to less surface contact",
        "They cannot ever be placed on partially erupted teeth",
        "They hide proximal caries until the bracket is removed"
      ],
      correctAnswer: 1
    },
    {
      id: 994030,
      question: "Separators are placed proximally in order to:",
      options: [
        "Hold the archwire firmly inside each bracket slot",
        "Attach elastics between the upper and lower arches",
        "Create space between teeth before fitting the bands",
        "Remove residual adhesive from the enamel surface"
      ],
      correctAnswer: 2
    },
    {
      id: 994031,
      question: "During bonding, isolation is crucial because saliva or blood will:",
      options: [
        "Speed up the chemical curing of the resin",
        "Improve the grip of the bracket on enamel",
        "Strengthen the adhesive layer under bracket",
        "Contaminate the bond and cause bond failure"
      ],
      correctAnswer: 3
    },
    {
      id: 994032,
      question: "Etching is done using 30% phosphoric acid for how long?",
      options: [
        "30 to 45 seconds",
        "10 to 15 seconds",
        "60 to 90 seconds",
        "3 to 5 minutes"
      ],
      correctAnswer: 1
    },
    {
      id: 994033,
      question: "Which etch consistency stays in one place but is more difficult to rinse off?",
      options: [
        "Liquid etch",
        "Foam etch",
        "Gel etch",
        "Powder etch"
      ],
      correctAnswer: 2
    },
    {
      id: 994034,
      question: "When etching, the area covered should be:",
      options: [
        "The entire facial surface of the crown of the tooth",
        "As large as the bracket base but not the whole tooth",
        "Only the very tip and edge of the bracket base pad",
        "The whole crown including the incisal biting edge"
      ],
      correctAnswer: 1
    },
    {
      id: 994035,
      question: "After etching, the surface should be rinsed for how long?",
      options: [
        "2 to 5 seconds",
        "15 to 30 seconds",
        "60 to 90 seconds",
        "4 to 6 minutes"
      ],
      correctAnswer: 1
    },
    {
      id: 994036,
      question: "After seating a bracket, the 'flash' that must be removed refers to:",
      options: [
        "The thin oxide layer left on the metal band",
        "The bright reflection seen under the curing light",
        "Excess bonding material around the bracket base",
        "The leftover etch trapped beneath the bracket"
      ],
      correctAnswer: 2
    },
    {
      id: 994037,
      question: "A chemical cure has a 7-minute total set that gives a tie strength of:",
      options: [
        "20 percent",
        "60 percent",
        "80 percent",
        "100 percent"
      ],
      correctAnswer: 1
    },
    {
      id: 994038,
      question: "The light cure set time for a metal bracket is about:",
      options: [
        "10 seconds",
        "20 seconds",
        "50 seconds",
        "30 seconds"
      ],
      correctAnswer: 3
    },
    {
      id: 994039,
      question: "The light cure set time for a molar bracket is about:",
      options: [
        "40 seconds",
        "10 seconds",
        "20 seconds",
        "30 seconds"
      ],
      correctAnswer: 0
    },
    {
      id: 994040,
      question: "Fuji Glass Ionomer is a cement that:",
      options: [
        "Is a ready-made paste with only a light cure set",
        "Is a single liquid with only a chemical cure set",
        "Is a powder/liquid mix with chemical and light cure",
        "Is a metal primer with no curing step at all"
      ],
      correctAnswer: 2
    },
    {
      id: 994041,
      question: "A thermal (thermally activated) wire is:",
      options: [
        "Soft at room temperature and stiffer at body temperature",
        "Stiff at room temperature and softer once in the mouth",
        "Equally stiff at every temperature it is exposed to",
        "Active only when it is cooled well below room temperature"
      ],
      correctAnswer: 0
    },
    {
      id: 994042,
      question: "The three preformed archwire shapes shown are square, tapered, and:",
      options: [
        "Conical",
        "Ovoid",
        "Oblong",
        "Circular"
      ],
      correctAnswer: 1
    },
    {
      id: 994043,
      question: "Why is physically 'tightening' braces no longer necessary?",
      options: [
        "Brackets are now glued much more firmly to the teeth",
        "Patients wear elastics that pull the teeth in tighter",
        "Power chains remove the need for any archwire at all",
        "Thermal wires stiffen on their own at mouth temperature"
      ],
      correctAnswer: 3
    },
    {
      id: 994044,
      question: "A power chain is best described as:",
      options: [
        "A rigid metal bar that locks the teeth together",
        "A coil spring that pushes two teeth far apart",
        "An elastic plastic chain that gradually applies force",
        "A wire ligature that ties a single bracket shut"
      ],
      correctAnswer: 2
    },
    {
      id: 994045,
      question: "The colored part of braces that patients can choose is the:",
      options: [
        "Ligature (donut or o-ring)",
        "Bracket made of metal",
        "Archwire across the teeth",
        "Band around the molar"
      ],
      correctAnswer: 0
    },
    {
      id: 994046,
      question: "Auxiliary elastics are placed between which structures to move teeth?",
      options: [
        "The maxillary and mandibular arches",
        "The two halves of a single bracket",
        "The archwire and the curing light",
        "The band and the periodontal probe"
      ],
      correctAnswer: 0
    },
    {
      id: 994047,
      question: "The two main steps in debonding are bracket removal and:",
      options: [
        "Fresh archwire placement",
        "New separator insertion",
        "Final fluoride etching",
        "Residual adhesive cleaning"
      ],
      correctAnswer: 3
    },
    {
      id: 994048,
      question: "In the peeling force technique for bracket removal, the plier tips are placed:",
      options: [
        "Across the incisal tip and the gingival margin of crown",
        "Around the entire outer circumference of the metal band",
        "Onto the center of the bracket mesh pad and main wire",
        "Against the mesial and distal edges of the bonding base"
      ],
      correctAnswer: 3
    },
    {
      id: 994049,
      question: "An orthodontic ligature elastic (o-ring) is usually changed at each adjustment visit.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 994050,
      question: "Bracket positioning landmarks can be measured with a periodontal probe.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 994051,
      question: "Besides molding the arch form, the archwire serves as a guide to slide the teeth along.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 994052,
      question: "If one or two teeth are too far out of line, they must always be extracted before treatment can continue.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 994053,
      question: "During bonding, the prophy step can be bypassed when the enamel is clean because the etch will penetrate the pellicle.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    }
  ],
  "8. Introduction to Orthodontics (Part 5)": [
    {
      id: 995001,
      question: "The diagnosis and treatment planning process in orthodontics follows what kind of approach?",
      options: [
        "A problem-oriented approach based on client data",
        "A symptom-based approach based on laboratory results",
        "A budget-based approach based on insurance limits",
        "A random-trial approach based on repeated testing"
      ],
      correctAnswer: 0
    },
    {
      id: 995002,
      question: "Once the problem list has been developed, the problems are then:",
      options: [
        "Combined so they form one single overarching concern",
        "Postponed until the client specifically requests action",
        "Prioritized so the most important one is treated first",
        "Discarded whenever the client cannot afford the care"
      ],
      correctAnswer: 2
    },
    {
      id: 995003,
      question: "The best treatment options are presented to the client in terms of:",
      options: [
        "Color, durability, comfort, and total weight",
        "Cost, effectiveness, complexity, and risk",
        "Speed, brand, popularity, and product warranty",
        "Size, texture, flavor, and surface appearance"
      ],
      correctAnswer: 1
    },
    {
      id: 995004,
      question: "The chief complaint must be treated as a priority because it is:",
      options: [
        "The main concern the client wants to have addressed",
        "The cheapest dental problem to correct in the mouth",
        "Always the most severe skeletal abnormality present",
        "A legal requirement to complete before any imaging"
      ],
      correctAnswer: 0
    },
    {
      id: 995005,
      question: "The age of a client is important because it may affect the client's:",
      options: [
        "Exact total duration required for the treatment",
        "Particular type of radiograph that is needed",
        "Motivation and cooperation during the treatment",
        "Need for any diagnostic records at all to begin"
      ],
      correctAnswer: 2
    },
    {
      id: 995006,
      question: "Compared with children, adult orthodontic clients are generally:",
      options: [
        "Treated only because their parents wish it done",
        "Unable to cooperate with any appliance therapy",
        "Internally motivated to complete their treatment",
        "Excluded from the problem-oriented planning method"
      ],
      correctAnswer: 2
    },
    {
      id: 995007,
      question: "The history of previous treatment that should be reviewed includes that of the:",
      options: [
        "Client and the client's neighbors or coworkers",
        "Dentist and the dentist's parents or siblings",
        "Client and the client's parents or siblings",
        "Hygienist and the hygienist's former employers"
      ],
      correctAnswer: 2
    },
    {
      id: 995008,
      question: "A history of trauma to the teeth or jaws can provide insight into:",
      options: [
        "The cause of an existing skeletal asymmetry",
        "The exact cost of the planned appliance therapy",
        "The client's overall motivation for the treatment",
        "The presence of a nickel or a latex sensitivity"
      ],
      correctAnswer: 0
    },
    {
      id: 995009,
      question: "The implication of temporomandibular joint osteoarthritis for orthodontics is that treatment:",
      options: [
        "Must always be doubled in its total duration",
        "Will fully reverse the existing joint damage",
        "Will not improve the degenerative joint changes",
        "Should begin without any radiographs being taken"
      ],
      correctAnswer: 2
    },
    {
      id: 995010,
      question: "A nickel or latex allergy matters during planning because:",
      options: [
        "Metal appliances contain latex and elastics contain nickel",
        "Both the appliances and the elastics are made only of plastic",
        "Neither the appliances nor the elastics ever touch the gingiva",
        "Metal appliances contain nickel and elastics contain latex"
      ],
      correctAnswer: 3
    },
    {
      id: 995011,
      question: "Medications for hypertension, epilepsy, and organ transplants carry a risk of:",
      options: [
        "Permanent loss of all of the anterior teeth",
        "Complete bony fusion of both dental arches",
        "Immediate resorption of the mandibular condyles",
        "Gingival enlargement and increased plaque retention"
      ],
      correctAnswer: 3
    },
    {
      id: 995012,
      question: "With osteoporosis and its treatment, the dental hygienist should expect that:",
      options: [
        "Bone remodeling will stop entirely during care",
        "Bone remodeling will speed beyond safe limits",
        "Bone remodeling stays unaffected by the disease",
        "Bone remodeling may occur at a slower rate"
      ],
      correctAnswer: 3
    },
    {
      id: 995013,
      question: "Indomethacin, a potent prostaglandin inhibitor used for arthritis, may:",
      options: [
        "Increase the speed of the tooth movement greatly",
        "Cause an immediate enlargement of the gingival tissue",
        "Trigger a sudden allergy to the nickel in the brackets",
        "Reduce the response of the teeth to orthodontic forces"
      ],
      correctAnswer: 3
    },
    {
      id: 995014,
      question: "Corticosteroids and nonsteroidal anti-inflammatory agents used on a chronic basis may:",
      options: [
        "Improve the response of the teeth to the applied forces",
        "Reduce the response of the teeth to orthodontic forces",
        "Shift the maxillary midline toward the nasal columna",
        "Create supernumerary teeth within the dental arches"
      ],
      correctAnswer: 1
    },
    {
      id: 995015,
      question: "Tricyclic antidepressants, antimalarial agents, and methylxanthines may affect orthodontics by:",
      options: [
        "Raising prostaglandin levels and speeding the tooth response",
        "Influencing prostaglandin levels and lowering tooth response",
        "Causing a latex allergy to develop within the client",
        "Producing degenerative changes in the joint surfaces"
      ],
      correctAnswer: 1
    },
    {
      id: 995016,
      question: "Before orthodontic treatment, dental caries and endodontic pathology must be:",
      options: [
        "Ignored until the appliances have been fully placed",
        "Treated only if the client reports any tooth pain",
        "Assessed and then controlled or treated beforehand",
        "Left alone because the braces protect the teeth"
      ],
      correctAnswer: 2
    },
    {
      id: 995017,
      question: "Areas of inadequate attached gingiva are corrected before treatment with:",
      options: [
        "Bitewing radiographs of the molar teeth",
        "A wax-bite registration of both arches",
        "Repositioning of the nearby anterior teeth",
        "Gingival grafting of the affected sites"
      ],
      correctAnswer: 3
    },
    {
      id: 995018,
      question: "In children, shifting of the mandible during closure may:",
      options: [
        "Improve the symmetry of the dental arches",
        "Affect the skeletal development of the mandible",
        "Remove the need for diagnostic study models",
        "Prevent caries from forming on the molars"
      ],
      correctAnswer: 1
    },
    {
      id: 995019,
      question: "Intraoral photographs are taken mainly in order to:",
      options: [
        "Replace the need for the diagnostic study models",
        "Measure the exact cost of the planned treatment",
        "Predict the client's motivation and cooperation",
        "Document the client's status before treatment begins"
      ],
      correctAnswer: 3
    },
    {
      id: 995020,
      question: "Which of the following is a standard intraoral photographic view?",
      options: [
        "An anterior view with the teeth in occlusion",
        "A full face view taken while the client smiles",
        "A lateral view of the skull and of the cranium",
        "A profile view of the relaxed soft tissue chin"
      ],
      correctAnswer: 0
    },
    {
      id: 995021,
      question: "A panoramic radiograph is exposed to examine the perioral structures for:",
      options: [
        "Active caries between the posterior tooth contacts",
        "The midline relationship of the maxillary arch",
        "Pathology or supernumerary or impacted teeth",
        "The bilateral symmetry of the whole facial form"
      ],
      correctAnswer: 2
    },
    {
      id: 995022,
      question: "On a panoramic film, the mandibular condyles are evaluated to determine the:",
      options: [
        "Possible need for additional radiographs of the TMJ",
        "Exact shade and the color of the enamel surfaces",
        "Predisposition of the anterior roots to resorption",
        "Latex content of the elastics and of the brackets"
      ],
      correctAnswer: 0
    },
    {
      id: 995023,
      question: "Anterior periapical films may be taken to evaluate the roots for:",
      options: [
        "The client's full smiling facial soft tissue",
        "The slower rate of future bone remodeling",
        "A possible latex content within the elastics",
        "A predisposition to apical root resorption"
      ],
      correctAnswer: 3
    },
    {
      id: 995024,
      question: "Bitewing radiographs are taken during orthodontic records to:",
      options: [
        "Trace the landmarks of the lateral skull view",
        "Rule out the presence of any active caries",
        "Assess the symmetry of the upper dental arch",
        "Predict the final results of the chosen plan"
      ],
      correctAnswer: 1
    },
    {
      id: 995025,
      question: "An adult with a history of periodontal disease requires:",
      options: [
        "Only a single bitewing radiograph of the molars",
        "A full set of periapical films plus the panoramic",
        "No radiographs until the appliances are removed",
        "A repeat facial profile photograph at each visit"
      ],
      correctAnswer: 1
    },
    {
      id: 995026,
      question: "The lateral cephalograph is always indicated in orthodontics to assess:",
      options: [
        "The skeletal relationship of the jaws and the cranium",
        "The active caries hidden between the posterior teeth",
        "The latex content of the elastics and the brackets",
        "The bilateral symmetry of the soft tissue profile"
      ],
      correctAnswer: 0
    },
    {
      id: 995027,
      question: "Cephalometrics is valuable because two similar-looking malocclusions may:",
      options: [
        "Always require the very same appliance and the timing",
        "Never need any radiographs taken before the treatment",
        "Produce identical results regardless of the chosen plan",
        "Differ greatly once the skeletal components are analyzed"
      ],
      correctAnswer: 3
    },
    {
      id: 995028,
      question: "During orthodontic care, cephalometric radiographs are taken:",
      options: [
        "Only once, on the very first appointment day",
        "Only after the appliances have been removed",
        "Only when the client reports pain in the joint",
        "Before, during, and after the orthodontic therapy"
      ],
      correctAnswer: 3
    },
    {
      id: 995029,
      question: "A cephalometric visualization treatment objective is used to:",
      options: [
        "Record the exact cost of the chosen appliance",
        "Replace the need for the diagnostic photographs",
        "Predict the results of the planned treatment",
        "Measure the latex sensitivity of the soft tissue"
      ],
      correctAnswer: 2
    },
    {
      id: 995030,
      question: "Before tracing a cephalogram, the x-ray should be examined for:",
      options: [
        "Abnormalities or pathology such as a pituitary tumour",
        "The exact shade and the color of the enamel surface",
        "The presence of active caries on the molar tooth",
        "The bilateral symmetry of the smiling soft tissue"
      ],
      correctAnswer: 0
    },
    {
      id: 995031,
      question: "Hand tracing of a cephalogram requires which proper equipment?",
      options: [
        "A wax-bite registration and a panoramic radiograph film",
        "A set of latex elastics and several of the metal brackets",
        "Tracing paper, a sharp pencil, and a built-in view box",
        "A full face photograph and a smiling profile photograph"
      ],
      correctAnswer: 2
    },
    {
      id: 995032,
      question: "From the frontal view, facial photographs are evaluated for the:",
      options: [
        "Bilateral symmetry of the soft tissue features",
        "Active caries between the posterior tooth contacts",
        "Predisposition of the anterior roots to resorption",
        "Slower rate of the remodeling within the jaw bone"
      ],
      correctAnswer: 0
    },
    {
      id: 995033,
      question: "The midline of the maxilla is assessed in relation to the:",
      options: [
        "Mandibular condyle and the temporomandibular joint",
        "Philtrum and the nasal columna of the face",
        "Posterior molars and the buccal tooth sextant",
        "Tracing paper and the built-in radiograph view box"
      ],
      correctAnswer: 1
    },
    {
      id: 995034,
      question: "Which of the following is one of the minimum four facial photographic views?",
      options: [
        "An occlusal view of the upper maxillary arch",
        "A full face view taken with the lips relaxed",
        "A buccal view of the lower posterior sextant",
        "A panoramic view of the perioral structures"
      ],
      correctAnswer: 1
    },
    {
      id: 995035,
      question: "Diagnostic dental casts or study models are used to assess the occlusion and the:",
      options: [
        "Latex content of the elastics and brackets",
        "Symmetry of the form of the dental arches",
        "Predisposition of the roots to resorption",
        "Pathology hidden within the soft tissues"
      ],
      correctAnswer: 1
    },
    {
      id: 995036,
      question: "To prepare diagnostic study models, impressions of both arches are taken with a:",
      options: [
        "Wax-bite registration of the client's occlusion",
        "Panoramic radiograph of the whole jaw region",
        "Smiling profile photograph of the lower face",
        "Latex elastic placed across both dental arches"
      ],
      correctAnswer: 0
    },
    {
      id: 995037,
      question: "According to the summary, complete diagnostic records typically include:",
      options: [
        "A history, clinical exam, study models, photos, and X-rays",
        "Only a single panoramic film and a wax-bite registration",
        "Only the facial photographs and the smiling profile views",
        "Only the chief complaint and the client's age at the start"
      ],
      correctAnswer: 0
    },
    {
      id: 995038,
      question: "Osteoarthritis of the temporomandibular joint can be improved through orthodontic treatment.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 995039,
      question: "A panoramic radiograph is used to examine the perioral structures for supernumerary or impacted teeth.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 995040,
      question: "Cephalometric radiographs are taken only after orthodontic therapy has been completed.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 995041,
      question: "Impressions of the maxillary and mandibular arches are taken with a wax-bite registration to prepare the study models.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    }
  ],
  "8. Introduction to Orthodontics (Part 6)": [
    {
      id: 996001,
      question: "Into how many main categories do orthodontic appliances fall?",
      options: [
        "Four categories of appliances",
        "Two categories of appliances",
        "Three categories of appliances",
        "Five categories of appliances"
      ],
      correctAnswer: 0
    },
    {
      id: 996002,
      question: "Which set correctly names the four main categories of orthodontic appliances?",
      options: [
        "Removable, fixed, passive, intra-oral",
        "Removable, fixed, functional, extra-oral",
        "Active, passive, fixed, lingual",
        "Removable, banded, bonded, extra-oral"
      ],
      correctAnswer: 1
    },
    {
      id: 996003,
      question: "What can happen if an appliance is selected poorly and used incorrectly?",
      options: [
        "It can shorten the treatment time",
        "It can improve client comfort",
        "It can make the malocclusion worse",
        "It can strengthen the tooth enamel"
      ],
      correctAnswer: 2
    },
    {
      id: 996004,
      question: "What kind of tooth movements are removable appliances capable of?",
      options: [
        "Only complex bodily movements",
        "Only rotational movements",
        "Only extrusive movements",
        "Only very simple movements"
      ],
      correctAnswer: 3
    },
    {
      id: 996005,
      question: "How are fixed appliances best described in terms of capability?",
      options: [
        "Sophisticated devices that precisely position teeth",
        "Simple devices that can only tip teeth slightly",
        "Passive devices that only hold the teeth still",
        "Removable devices that widen the upper arch fast"
      ],
      correctAnswer: 0
    },
    {
      id: 996006,
      question: "Functional appliances are primarily used for which malocclusion?",
      options: [
        "Class I Division II malocclusions",
        "Class II Division I malocclusions",
        "Class III Division I malocclusions",
        "Class II Division II malocclusions"
      ],
      correctAnswer: 1
    },
    {
      id: 996007,
      question: "What is the main purpose of extra-oral devices?",
      options: [
        "To replace missing teeth quickly",
        "To whiten the front teeth",
        "To re-enforce anchorage in the arch",
        "To clean beneath the gum line"
      ],
      correctAnswer: 2
    },
    {
      id: 996008,
      question: "In order of importance, what are the three basic requirements of an orthodontic appliance?",
      options: [
        "Esthetic, comfortable, functional",
        "Comfortable, functional, esthetic",
        "Functional, esthetic, comfortable",
        "Functional, comfortable, esthetic"
      ],
      correctAnswer: 3
    },
    {
      id: 996009,
      question: "Any oral prosthetic, in broad terms, must meet which set of conditions?",
      options: [
        "The same basic requirements as appliances",
        "A completely separate set of rules",
        "Only the comfort requirement alone",
        "Only the esthetic requirement alone"
      ],
      correctAnswer: 0
    },
    {
      id: 996010,
      question: "What does it mean for an orthodontic appliance to be functional?",
      options: [
        "It looks pleasing inside the mouth",
        "It performs the task it was designed for",
        "It feels soft against the gums",
        "It can be removed at any time"
      ],
      correctAnswer: 1
    },
    {
      id: 996011,
      question: "How is an appliance that cannot perform its function described?",
      options: [
        "It is considered esthetic",
        "It is considered passive",
        "It is considered worthless",
        "It is considered comfortable"
      ],
      correctAnswer: 2
    },
    {
      id: 996012,
      question: "Where does comfort rank relative to function for an appliance?",
      options: [
        "Above function in importance",
        "Equal to function exactly",
        "Above esthetics and function",
        "Below function in importance"
      ],
      correctAnswer: 3
    },
    {
      id: 996013,
      question: "Why is comfort important for appliance success?",
      options: [
        "The client may not wear it if uncomfortable",
        "The appliance will rust if uncomfortable",
        "The teeth will whiten if comfortable",
        "The gums will shrink if uncomfortable"
      ],
      correctAnswer: 0
    },
    {
      id: 996014,
      question: "What is needed when some appliance designs are uncomfortable regardless of effort?",
      options: [
        "A complete redesign of the device",
        "The client's commitment to treatment",
        "A switch to a fixed appliance",
        "An immediate stop to treatment"
      ],
      correctAnswer: 1
    },
    {
      id: 996015,
      question: "How does esthetics rank against function and comfort?",
      options: [
        "It is more important than both",
        "It is equal to both factors",
        "It is less important than both",
        "It is the single most important factor"
      ],
      correctAnswer: 2
    },
    {
      id: 996016,
      question: "Which appliance is given as one that is large, uncomfortable, and unsightly yet works?",
      options: [
        "Hawley retainer",
        "Lingual arch",
        "Bionator",
        "Headgear"
      ],
      correctAnswer: 3
    },
    {
      id: 996017,
      question: "When classified by how they are used in the mouth, appliances are separated into which three groups?",
      options: [
        "Passive, active, functional",
        "Passive, fixed, removable",
        "Active, fixed, esthetic",
        "Functional, fixed, extra-oral"
      ],
      correctAnswer: 0
    },
    {
      id: 996018,
      question: "What defines a passive appliance?",
      options: [
        "It exerts force on single teeth",
        "It does not exert force in the mouth",
        "It uses muscles to create change",
        "It widens the palate with a screw"
      ],
      correctAnswer: 1
    },
    {
      id: 996019,
      question: "What is the purpose of a passive appliance?",
      options: [
        "To rapidly move teeth into place",
        "To stretch the facial muscles",
        "To hold the teeth and inhibit movement",
        "To expand the upper dental arch"
      ],
      correctAnswer: 2
    },
    {
      id: 996020,
      question: "Which of these is given as an example of a passive appliance?",
      options: [
        "Rapid palatal expander and screws",
        "Finger spring and Z-spring",
        "Bionator and activator",
        "Lower Lingual Arch and retainers"
      ],
      correctAnswer: 3
    },
    {
      id: 996021,
      question: "What is the basic purpose of lingual arches as passive appliances?",
      options: [
        "To maintain space unilaterally in the arch",
        "To rotate the molars bodily forward",
        "To stretch the muscles of mastication",
        "To expand the midpalatal suture"
      ],
      correctAnswer: 0
    },
    {
      id: 996022,
      question: "How do active appliances accomplish tooth movement?",
      options: [
        "By stretching the oral muscles",
        "By placing forces upon the teeth",
        "By holding the teeth still",
        "By widening the air passages"
      ],
      correctAnswer: 1
    },
    {
      id: 996023,
      question: "Where are the forces of an active appliance generated?",
      options: [
        "From the muscles of the cheek",
        "From the back of the neck",
        "Within the appliance itself",
        "From the temporomandibular joint"
      ],
      correctAnswer: 2
    },
    {
      id: 996024,
      question: "Which of these are listed as active components of an appliance?",
      options: [
        "Bands and bonded brackets",
        "Clasps and acrylic plates",
        "Tubes and elastic bands",
        "Screws and wire springs"
      ],
      correctAnswer: 3
    },
    {
      id: 996025,
      question: "What do functional appliances use to create change in the orofacial complex?",
      options: [
        "The muscles of mastication and oral cavity",
        "Expansion screws turned by a small metal key",
        "Stainless steel bands cemented to the molars",
        "External neck anchorage straps and headgear"
      ],
      correctAnswer: 0
    },
    {
      id: 996026,
      question: "How do functional appliances generally produce their forces?",
      options: [
        "Through a coiled spring pushing on the teeth",
        "Through positioning and stretching of muscles",
        "Through a screw turned slowly with a key",
        "Through cement bonding the parts to enamel"
      ],
      correctAnswer: 1
    },
    {
      id: 996027,
      question: "Functional appliances are also referred to by which other name?",
      options: [
        "Retentive appliances",
        "Anchorage appliances",
        "Orthopedic appliances",
        "Cosmetic appliances"
      ],
      correctAnswer: 2
    },
    {
      id: 996028,
      question: "What changes do functional appliances mainly produce?",
      options: [
        "Changes to the tooth enamel color",
        "Changes to the saliva production",
        "Changes to the tongue muscle size",
        "Changes to the supporting structures"
      ],
      correctAnswer: 3
    },
    {
      id: 996029,
      question: "Functional appliances are also called by which name?",
      options: [
        "Myofunctional appliances",
        "Myorelaxant appliances",
        "Myostatic appliances",
        "Myotonic appliances"
      ],
      correctAnswer: 0
    },
    {
      id: 996030,
      question: "Myofunctional appliances are used for procedures aimed at what?",
      options: [
        "Whitening and polishing the front teeth surfaces",
        "Intercepting and treating jaw discrepancies",
        "Cleaning and scaling the gums around the teeth",
        "Sealing and filling the grooves of the molars"
      ],
      correctAnswer: 1
    },
    {
      id: 996031,
      question: "Which of these is an example of a removable myofunctional appliance?",
      options: [
        "Herbst appliance and Jasper jumper",
        "Hawley retainer and biteplane",
        "Activator and Bionator",
        "Lingual arch and Nance"
      ],
      correctAnswer: 2
    },
    {
      id: 996032,
      question: "Which of these is an example of a fixed myofunctional appliance?",
      options: [
        "Activator and Bionator",
        "Hawley retainer and biteplane",
        "Transpalatal bar and Nance",
        "Herbst appliance and Jasper jumper"
      ],
      correctAnswer: 3
    },
    {
      id: 996033,
      question: "When classified by how the appliance is retained, appliances divide into which two groups?",
      options: [
        "Removable and fixed",
        "Passive and active",
        "Active and functional",
        "Functional and esthetic"
      ],
      correctAnswer: 0
    },
    {
      id: 996034,
      question: "How are fixed appliances defined?",
      options: [
        "They can be removed at any time freely",
        "They cannot be removed without damaging them",
        "They use the muscles to create force",
        "They rest loosely against the palate"
      ],
      correctAnswer: 1
    },
    {
      id: 996035,
      question: "What are stainless steel bands used for in fixed appliances?",
      options: [
        "Whitening by fully covering the tooth enamel",
        "Cleaning by gently scraping the tooth surface",
        "Retention by fitting tightly around a tooth",
        "Cushioning by padding the inside of the cheeks"
      ],
      correctAnswer: 2
    },
    {
      id: 996036,
      question: "How are stainless steel bands held in the mouth?",
      options: [
        "With suction against the palate",
        "With clasps on adjacent teeth",
        "With elastic bands across teeth",
        "With cement around the tooth"
      ],
      correctAnswer: 3
    },
    {
      id: 996037,
      question: "After bands are placed, what is done to give a fixed appliance its function?",
      options: [
        "Components are soldered to the bands",
        "Acrylic is poured over the bands",
        "Clasps are clipped onto the bands",
        "Springs are glued to the gums"
      ],
      correctAnswer: 0
    },
    {
      id: 996038,
      question: "Besides bands, what other retention method is mentioned for fixed appliances?",
      options: [
        "Soft rubber suction cups on the palate",
        "Small mesh retentive pads (brackets)",
        "Adjustable metal clasps on the teeth",
        "Removable acrylic plates and bows"
      ],
      correctAnswer: 1
    },
    {
      id: 996039,
      question: "When is a space maintainer typically inserted?",
      options: [
        "When the upper front teeth are being whitened",
        "When the gums around the teeth become inflamed",
        "When posterior teeth are prematurely extracted",
        "When the upper palate has been fully expanded"
      ],
      correctAnswer: 2
    },
    {
      id: 996040,
      question: "How is a space maintainer attached to the mouth?",
      options: [
        "Permanently bonded to the gums",
        "Held in place by suction only",
        "Clipped on with adjustable clasps",
        "Temporarily cemented onto a tooth"
      ],
      correctAnswer: 3
    },
    {
      id: 996041,
      question: "When is a space maintainer removed?",
      options: [
        "When the permanent tooth is ready to erupt",
        "When the client first reports feeling discomfort",
        "When the upper front teeth become fully aligned",
        "When the palate has stopped widening at all"
      ],
      correctAnswer: 0
    },
    {
      id: 996042,
      question: "By which other names is the space maintainer known?",
      options: [
        "Bionator, activator, biteplane",
        "Spacer, band and loop, space regainer",
        "Hawley, Nance, lingual arch",
        "Headgear, facebow, expander"
      ],
      correctAnswer: 1
    },
    {
      id: 996043,
      question: "What defines a removable appliance?",
      options: [
        "It cannot be taken out once it has been placed",
        "It uses the muscles to move the jaw forward",
        "It can be removed from the mouth at any time",
        "It is cemented onto the upper molar teeth firmly"
      ],
      correctAnswer: 2
    },
    {
      id: 996044,
      question: "What holds a removable appliance in the mouth during function?",
      options: [
        "Cement applied to the molar bands",
        "Solder joining the metal parts",
        "Bonding glue on the bracket pads",
        "Clasps or another disengagable mechanism"
      ],
      correctAnswer: 3
    },
    {
      id: 996045,
      question: "Which is one stated advantage of removable appliances?",
      options: [
        "They can be removed on sensitive occasions",
        "They move teeth in complex ways",
        "They never depend on client effort",
        "They are built inside the mouth directly"
      ],
      correctAnswer: 0
    },
    {
      id: 996046,
      question: "Where are removable appliances fabricated?",
      options: [
        "Directly in the client's mouth",
        "In the laboratory, not in the mouth",
        "At the front desk during a visit",
        "Inside the imaging x-ray room"
      ],
      correctAnswer: 1
    },
    {
      id: 996047,
      question: "On what is the treatment response of a removable appliance heavily dependent?",
      options: [
        "The strength of the dental cement",
        "The color of the acrylic plate",
        "Client compliance with wearing it",
        "The brand of the metal clasps"
      ],
      correctAnswer: 2
    },
    {
      id: 996048,
      question: "What is usually the main limitation of removable appliances?",
      options: [
        "Their unusually bright acrylic coloring",
        "Their large external anchorage straps",
        "Their many soldered metal joint points",
        "Their retentive components, the clasps"
      ],
      correctAnswer: 3
    },
    {
      id: 996049,
      question: "Why do clasps limit removable appliance treatment?",
      options: [
        "Hard to get two-point contacts for complex movement",
        "They corrode quite quickly inside the moist mouth",
        "They make the whole appliance far too heavy to wear",
        "They block the client's speech almost entirely at times"
      ],
      correctAnswer: 0
    },
    {
      id: 996050,
      question: "Which is one of the three major indications for removable retainers?",
      options: [
        "Complex bodily movement of the lower molars",
        "Limited tipping movements for arch expansion",
        "Permanent replacement of teeth that are lost",
        "Surgical correction of the patient's lower jaw"
      ],
      correctAnswer: 1
    },
    {
      id: 996051,
      question: "Removable appliances are indicated for growth modification during which stage?",
      options: [
        "The fully adult dentition stage",
        "The newborn pre-eruption stage",
        "The mixed dentition stage",
        "The completed permanent stage"
      ],
      correctAnswer: 2
    },
    {
      id: 996052,
      question: "Removable retainers are indicated for retention at what point?",
      options: [
        "Before any treatment has started",
        "During the surgical procedure only",
        "Instead of any active treatment",
        "After comprehensive treatment is finished"
      ],
      correctAnswer: 3
    },
    {
      id: 996053,
      question: "How often should a client wearing an active removable appliance be seen?",
      options: [
        "Every four to six weeks",
        "Every one to two days",
        "Every six to eight months",
        "Every two to three years"
      ],
      correctAnswer: 0
    },
    {
      id: 996054,
      question: "To produce how much tooth movement should springs be adjusted at each visit?",
      options: [
        "Approximately one centimeter",
        "Approximately one millimeter",
        "Approximately five millimeters",
        "Approximately ten millimeters"
      ],
      correctAnswer: 1
    },
    {
      id: 996055,
      question: "What is done to the baseplate when a spring is adjusted?",
      options: [
        "It is thickened to add more support",
        "It is removed entirely from the mouth",
        "It is relieved to allow similar clearance",
        "It is cemented firmly onto the teeth"
      ],
      correctAnswer: 2
    },
    {
      id: 996056,
      question: "From what materials can the baseplate of a removable appliance be made?",
      options: [
        "Stainless steel bands set firmly with cement",
        "Soft rubber, silicone, and flexible foam pads",
        "Dental porcelain, fired ceramic, and clear glass",
        "Acrylic resins, thermoplastics, precious metals"
      ],
      correctAnswer: 3
    },
    {
      id: 996057,
      question: "Why are precious metals rarely used for the baseplate?",
      options: [
        "Increased cost and difficulty in fabricating",
        "They feel too soft inside the mouth",
        "They corrode rapidly in saliva",
        "They cannot be cleaned by the client"
      ],
      correctAnswer: 0
    },
    {
      id: 996058,
      question: "How must the acrylic plate fit against the palatal tissues?",
      options: [
        "Loosely placed with plenty of room to shift",
        "Closely adapted and seating snugly without rocking",
        "Cemented firmly onto the upper molar teeth",
        "Suspended above the palate by several wires"
      ],
      correctAnswer: 1
    },
    {
      id: 996059,
      question: "What is the average thickness of an acrylic plate in most cases?",
      options: [
        "About ten to twelve millimeters",
        "About one half of a millimeter",
        "About two to three millimeters",
        "About six to eight millimeters"
      ],
      correctAnswer: 2
    },
    {
      id: 996060,
      question: "How should the thickness of the acrylic plate be across its surface?",
      options: [
        "Thickest at the front edge",
        "Thinnest near the molar teeth",
        "Tapered toward the midline only",
        "Uniform across the plate"
      ],
      correctAnswer: 3
    },
    {
      id: 996061,
      question: "Why are maxillary removable appliances generally more successful than mandibular ones?",
      options: [
        "The maxillary framework is more stable",
        "The maxillary arch needs no clasps",
        "The mandibular arch grows much faster",
        "The mandibular teeth are always larger"
      ],
      correctAnswer: 0
    },
    {
      id: 996062,
      question: "What stabilizes the maxillary removable appliance?",
      options: [
        "A snug strap fastened behind the patient's neck",
        "A direct connection across the arch between molars",
        "A small screw turned each day with a metal key",
        "A wire bonded behind the lower front teeth firmly"
      ],
      correctAnswer: 1
    },
    {
      id: 996063,
      question: "Why is the horseshoe-shaped mandibular appliance less stable?",
      options: [
        "It is far too rigid to ever seat properly in the mouth",
        "It is built only from costly precious metal materials",
        "It is inevitably somewhat flexible and prone to breakage",
        "It is firmly cemented to just a single lower molar tooth"
      ],
      correctAnswer: 2
    },
    {
      id: 996064,
      question: "What is a second complication frequently found with mandibular appliances?",
      options: [
        "The complete lack of any clasps",
        "The excessive width of the arch",
        "The absence of palatal tissue",
        "The frequent presence of undercuts"
      ],
      correctAnswer: 3
    },
    {
      id: 996065,
      question: "Why can the mandibular baseplate not extend far gingivally?",
      options: [
        "Lingually inclined molars and a high mylohyoid ridge",
        "A very flat, shallow palate with little surface area",
        "An overly thick acrylic surface across the whole plate",
        "A missing direct connection across the dental arch"
      ],
      correctAnswer: 0
    },
    {
      id: 996066,
      question: "What results from a less stable framework and loose posterior fit in mandibular removables?",
      options: [
        "Faster and noticeably stronger tooth movement",
        "Less comfort and less effective tooth movement",
        "Improved esthetics and a better palate fit",
        "Greater overall stability than maxillary ones"
      ],
      correctAnswer: 1
    },
    {
      id: 996067,
      question: "What is the rapid palatal expansion appliance used to do?",
      options: [
        "Hold the lower front teeth in place",
        "Stretch the muscles of the cheek",
        "Expand the upper arch or roof of the mouth",
        "Pull the upper jaw backward gently"
      ],
      correctAnswer: 2
    },
    {
      id: 996068,
      question: "How can widening the upper arch with an RPE help the bite?",
      options: [
        "The upper front teeth gradually become much whiter",
        "The crowded molars can then be removed more easily",
        "The lower jaw is steadily pushed much further back",
        "Upper teeth may line up better with lower teeth"
      ],
      correctAnswer: 3
    },
    {
      id: 996069,
      question: "How does palatal expansion affect breathing?",
      options: [
        "It widens the air passages above the palate",
        "It narrows the nasal passage opening",
        "It blocks the throat during sleep",
        "It has no effect on the airway"
      ],
      correctAnswer: 0
    },
    {
      id: 996070,
      question: "How can widening the palate help crowded teeth?",
      options: [
        "It removes the need for any braces",
        "It makes more room for teeth to align",
        "It permanently fuses the loose teeth",
        "It shrinks the size of large teeth"
      ],
      correctAnswer: 1
    },
    {
      id: 996071,
      question: "When can a narrow palate be corrected easily with a palatal expander?",
      options: [
        "Only after age fifty",
        "Only during infancy",
        "Up until puberty",
        "Only after skeletal maturity"
      ],
      correctAnswer: 2
    },
    {
      id: 996072,
      question: "How is the expansion screw of a palatal expander activated?",
      options: [
        "A retentive clasp is carefully bent with pliers",
        "A metal band is cemented onto the molar tooth",
        "A coiled spring is compressed firmly by hand",
        "A key is inserted and the screw is turned"
      ],
      correctAnswer: 3
    },
    {
      id: 996073,
      question: "What happens after the palate has been fully expanded?",
      options: [
        "New bone tissue fills the space",
        "The old bone dissolves away",
        "The teeth fall out naturally",
        "The palate returns to normal"
      ],
      correctAnswer: 0
    },
    {
      id: 996074,
      question: "Roughly how long does it usually take to expand the upper arch enough with an RPE?",
      options: [
        "About one to two days",
        "About six to eight weeks",
        "About six to eight months",
        "About three to four years"
      ],
      correctAnswer: 1
    },
    {
      id: 996075,
      question: "What temporary effect does widening the palate have on the front teeth?",
      options: [
        "It noticeably darkens the two upper front teeth",
        "It loosens nearly all of the upper front teeth",
        "It causes a space between the two front teeth",
        "It slightly shortens the two upper front teeth"
      ],
      correctAnswer: 2
    },
    {
      id: 996076,
      question: "What sensation may the pressure of expansion cause?",
      options: [
        "A sharp pain in the lower jaw",
        "A complete loss of taste",
        "A ringing sound in the ears",
        "A tingling at the base of the nose"
      ],
      correctAnswer: 3
    },
    {
      id: 996077,
      question: "What is the primary purpose of the Transpalatal Bar, Nance, and Lingual Arch appliances?",
      options: [
        "To maintain space in the arch",
        "To whiten the anterior teeth",
        "To stretch the chewing muscles",
        "To pull the jaw forward"
      ],
      correctAnswer: 0
    },
    {
      id: 996078,
      question: "In which patients are transpalatal appliances primarily placed?",
      options: [
        "Patients with full adult dentition",
        "Patients in transitional dentition",
        "Patients before any teeth erupt",
        "Patients with no remaining teeth"
      ],
      correctAnswer: 1
    },
    {
      id: 996079,
      question: "Where is the Transpalatal Bar attached?",
      options: [
        "To the cheek-side of the lower front incisor teeth",
        "To a padded strap worn behind the patient's neck",
        "To the tongue-side of the upper first molar bands",
        "To the front surface of the upper canine teeth"
      ],
      correctAnswer: 2
    },
    {
      id: 996080,
      question: "Where is the Lingual Arch attached?",
      options: [
        "To the cheek-side of the upper first molar teeth",
        "To the front surface of the upper incisor teeth",
        "To a padded strap worn behind the patient's neck",
        "To the tongue-side of the lower first molar bands"
      ],
      correctAnswer: 3
    },
    {
      id: 996081,
      question: "When is the Lingual Arch recommended?",
      options: [
        "When baby teeth are lost prematurely",
        "When the adult teeth are all present",
        "When the palate is fully widened",
        "When the front teeth are whitened"
      ],
      correctAnswer: 0
    },
    {
      id: 996082,
      question: "What is the Bionator used to help correct?",
      options: [
        "A crossbite by widening the palate",
        "An overbite by promoting lower jaw growth",
        "A space by closing front teeth",
        "A rotation by tipping the molars"
      ],
      correctAnswer: 1
    },
    {
      id: 996083,
      question: "Since the Bionator is an orthopedic appliance, when should it be used?",
      options: [
        "After skeletal maturity is reached",
        "Only in fully grown adults",
        "During a period of maximum growth",
        "Only after the teeth are extracted"
      ],
      correctAnswer: 2
    },
    {
      id: 996084,
      question: "What happens if the patient does not grow while using the Bionator?",
      options: [
        "The jawbone grows much faster",
        "The appliance works even better",
        "The palate expands on its own",
        "Only changes in tooth position are seen"
      ],
      correctAnswer: 3
    },
    {
      id: 996085,
      question: "When is the Bionator no longer effective at influencing jaw growth?",
      options: [
        "When the patient reaches skeletal maturity",
        "When the patient first starts growing",
        "When the front teeth are aligned",
        "When the palate is fully expanded"
      ],
      correctAnswer: 0
    },
    {
      id: 996086,
      question: "What is the Biteplane used to reduce?",
      options: [
        "A wide crossbite of the molars",
        "A deep overbite of the front teeth",
        "A large gap between front teeth",
        "A narrow upper dental arch"
      ],
      correctAnswer: 1
    },
    {
      id: 996087,
      question: "How does the Biteplane work?",
      options: [
        "It steadily pushes the upper front teeth backward",
        "It widens the upper palate with an expansion screw",
        "It lets back teeth erupt by preventing full biting",
        "It stretches and positions the muscles of the cheek"
      ],
      correctAnswer: 2
    },
    {
      id: 996088,
      question: "What is the Biteplane made of?",
      options: [
        "Rubber and silicone",
        "Porcelain and glass",
        "Cement and steel bands",
        "Wire and acrylic"
      ],
      correctAnswer: 3
    },
    {
      id: 996089,
      question: "When is a removable Biteplane most effective?",
      options: [
        "When it is worn all the time",
        "When it is worn only at night",
        "When it is worn once a week",
        "When it is rarely worn at all"
      ],
      correctAnswer: 0
    },
    {
      id: 996090,
      question: "What is a Bitesplint?",
      options: [
        "A metal bar that is bonded across the upper palate",
        "A custom-fit rubber mouthpiece worn on the lower teeth",
        "A padded neck strap that is used for added anchorage",
        "A thin wire that is glued behind the front teeth"
      ],
      correctAnswer: 1
    },
    {
      id: 996091,
      question: "What is a Bitesplint primarily used to help correct?",
      options: [
        "A deep overbite affecting the back molar teeth",
        "A narrow upper palate that needs to be widened",
        "A crossbite, worn along with upper braces",
        "A wide space between the upper front teeth"
      ],
      correctAnswer: 2
    },
    {
      id: 996092,
      question: "How does a Bitesplint allow a tooth in crossbite to move?",
      options: [
        "It pushes directly on the crooked tooth",
        "It widens the whole upper arch",
        "It stretches the chewing muscles",
        "It prevents the patient from completely biting"
      ],
      correctAnswer: 3
    },
    {
      id: 996093,
      question: "What does the Fan-type Expander do?",
      options: [
        "Widens the front of the upper arch only",
        "Widens the back of the upper arch",
        "Holds the lower front teeth still",
        "Pulls the upper jaw far back"
      ],
      correctAnswer: 0
    },
    {
      id: 996094,
      question: "On which teeth are the Fan-type Expander bands placed?",
      options: [
        "The two front incisors",
        "The six-year molars",
        "The lower canine teeth",
        "The wisdom teeth in back"
      ],
      correctAnswer: 1
    },
    {
      id: 996095,
      question: "How is the main body of the Fan-type Expander joined at the center?",
      options: [
        "By a soft rubber pad",
        "By a bonded bracket",
        "By an expansion screw",
        "By a neck anchorage strap"
      ],
      correctAnswer: 2
    },
    {
      id: 996096,
      question: "For the Fan-type Expander, how does patient age affect the correction?",
      options: [
        "Older patient age gives a faster overall correction",
        "Patient age has no effect at all on the correction",
        "Only fully grown adults can be corrected with it",
        "Younger age gives more rapid, stable correction"
      ],
      correctAnswer: 3
    },
    {
      id: 996097,
      question: "What is a Fixed Lingual Retainer?",
      options: [
        "A wire bonded behind the front teeth",
        "A removable acrylic palate plate",
        "A metal strap behind the neck",
        "A screw that widens the palate"
      ],
      correctAnswer: 0
    },
    {
      id: 996098,
      question: "When is the lower fixed retainer wire bonded in place?",
      options: [
        "After the teeth are extracted",
        "Before the braces are removed",
        "Long before treatment begins",
        "Only after the palate widens"
      ],
      correctAnswer: 1
    },
    {
      id: 996099,
      question: "How long does the fixed lingual retainer wire remain in the mouth?",
      options: [
        "Only for a single day",
        "Only during the surgery",
        "Long term, as long as possible",
        "Only until the next visit"
      ],
      correctAnswer: 2
    },
    {
      id: 996100,
      question: "An upper fixed retainer is typically used for patients who had what before treatment?",
      options: [
        "A fully expanded upper palate",
        "A missing lower first molar",
        "A neck strap for anchorage",
        "A large space between the front teeth"
      ],
      correctAnswer: 3
    },
    {
      id: 996101,
      question: "What does the Hawley retainer's metal wire typically surround?",
      options: [
        "The six anterior teeth",
        "The four back molars",
        "The lower wisdom teeth",
        "The upper first premolars"
      ],
      correctAnswer: 0
    },
    {
      id: 996102,
      question: "How many loops does the labial wire, or Hawley bow, incorporate?",
      options: [
        "Five loops for adjustment",
        "Two loops for adjustment",
        "Eight loops for adjustment",
        "Ten loops for adjustment"
      ],
      correctAnswer: 1
    },
    {
      id: 996103,
      question: "Where is the Hawley bow anchored?",
      options: [
        "In a padded strap fastened behind the neck",
        "In dental cement on the molar tooth bands",
        "In an acrylic arch that sits in the palate",
        "In a soft rubber pad resting on the tongue"
      ],
      correctAnswer: 2
    },
    {
      id: 996104,
      question: "What is an advantage of the Hawley retainer?",
      options: [
        "It can never be removed at all once it is placed",
        "It widens the upper palate with an expansion screw",
        "It permanently fuses the upper front teeth together",
        "Its wires can be adjusted to continue minor movement"
      ],
      correctAnswer: 3
    },
    {
      id: 996105,
      question: "When is headgear used?",
      options: [
        "When the upper jaw is too far forward of the lower",
        "When the lower jaw is growing far too quickly",
        "When the upper palate is much too narrow",
        "When the front teeth have a noticeable gap"
      ],
      correctAnswer: 0
    },
    {
      id: 996106,
      question: "Which appearance is the condition treated by headgear often responsible for?",
      options: [
        "A wide gap between the lower back molar teeth",
        "Protruded upper front teeth or buck teeth",
        "A narrow and highly arched upper palate shape",
        "A crossbite affecting the upper back molar teeth"
      ],
      correctAnswer: 1
    },
    {
      id: 996107,
      question: "What other use does headgear have during space closure?",
      options: [
        "Quickly widening the narrow upper dental arch",
        "Whitening and polishing the upper front teeth",
        "Preventing upper back teeth from slipping forward",
        "Holding the lower front teeth firmly in place"
      ],
      correctAnswer: 2
    },
    {
      id: 996108,
      question: "What does the headgear use as an anchor?",
      options: [
        "The roof of the palate",
        "The lower front teeth",
        "The tongue muscle itself",
        "The back of the neck"
      ],
      correctAnswer: 3
    },
    {
      id: 996109,
      question: "Where does the inner part of the headgear slide?",
      options: [
        "Into tubes on the side of the first molars",
        "Into retentive clasps on the front incisors",
        "Into narrow grooves cut into the hard palate",
        "Into metal bands placed around the canines"
      ],
      correctAnswer: 0
    },
    {
      id: 996110,
      question: "Removable appliances are capable of very complex tooth movements.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 996111,
      question: "Functional appliances are also referred to as orthopedic appliances.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 996112,
      question: "A passive appliance exerts active force on the teeth while in the mouth.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 996113,
      question: "Maxillary removable appliances tend to be more stable than mandibular ones.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 996114,
      question: "Esthetics is the most important requirement of an orthodontic appliance.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 996115,
      question: "Stainless steel bands in fixed appliances are held in place with cement.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 996116,
      question: "Headgear uses the back of the neck as an anchor.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 996117,
      question: "A space maintainer is permanently bonded and never removed.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 996118,
      question: "The Bionator is no longer effective at influencing jaw growth after skeletal maturity.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 996119,
      question: "The average thickness of an acrylic plate is about ten to twelve millimeters.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 996120,
      question: "A Biteplane is used to reduce a deep overbite.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 996121,
      question: "Active appliances generate their forces within the appliance itself.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    }
  ],
  "8. Introduction to Orthodontics (Part 7)": [
    {
      id: 997001,
      question: "When is dental hygiene care for the adult orthodontic client considered complete?",
      options: [
        "When all the teeth have been fully aligned and straightened by the orthodontist",
        "When inflammatory conditions are controlled enough to safely begin tooth movement",
        "Once the client has received a full set of bands, brackets, and wires",
        "Once the client can remove plaque without using any special cleaning aids"
      ],
      correctAnswer: 1
    },
    {
      id: 997002,
      question: "How often must clients with periodontal disease be seen for supportive periodontal maintenance?",
      options: [
        "Every 6 to 8 months, or every 3 months if severe disease is present",
        "Every 12 months, or every 6 months if severe disease is present",
        "Every 4 to 5 months, or every 8 weeks if severe disease is present",
        "Every 2 to 3 months, or every 4 weeks if severe disease is present"
      ],
      correctAnswer: 3
    },
    {
      id: 997003,
      question: "What is the key to managing the adult client who has periodontal disease?",
      options: [
        "Careful control of the plaque biofilm in the mouth",
        "Routine removal of all bands and brackets from the teeth",
        "Taking daily systemic antibiotics throughout the care",
        "Scheduling frequent radiographs of the alveolar bone"
      ],
      correctAnswer: 0
    },
    {
      id: 997004,
      question: "Which of the following is part of the dental hygienist's role with the orthodontic client?",
      options: [
        "Surgically placing the orthodontic bands and brackets on the teeth",
        "Prescribing systemic pain medication to manage the client's discomfort",
        "Providing nutritional assessment and counseling for the client",
        "Designing the wire-bending sequence used for the tooth movement"
      ],
      correctAnswer: 2
    },
    {
      id: 997005,
      question: "How should the hygienist's written home-care directions relate to the orthodontic office?",
      options: [
        "They should replace any verbal instruction the hygienist provides",
        "They should list every product available on the consumer market",
        "They should be written only in highly technical clinical language",
        "They should correlate with the orthodontic office's recommendations"
      ],
      correctAnswer: 3
    },
    {
      id: 997006,
      question: "What brushing frequency and dentifrice are recommended for clients with fixed appliances?",
      options: [
        "Three times a day with a fluoride dentifrice (0.22% sodium fluoride)",
        "Once a day with a non-fluoride tooth-whitening dentifrice product",
        "Twice a week with a 1.1% stannous fluoride cleaning paste product",
        "Five times a day with a baking-soda-based abrasive dentifrice product"
      ],
      correctAnswer: 0
    },
    {
      id: 997007,
      question: "What is the recommended way to brush around the brackets?",
      options: [
        "Place the bristles flat and drag them straight across the bracket faces",
        "Aim the bristles only at the incisal edges and avoid the brackets entirely",
        "Place bristles above aiming down, then below aiming up, toward the brackets",
        "Press the bristles hard onto the brackets and hold them still without moving"
      ],
      correctAnswer: 2
    },
    {
      id: 997008,
      question: "How should an oral irrigator be used by the orthodontic client?",
      options: [
        "On high power twice a day, aimed straight down into the gingival sulcus",
        "On low power once a day, aimed perpendicularly just above the papilla",
        "On low power once a week, aimed only at the incisal edges of the teeth",
        "On high power once a month, aimed beneath the free gingival margin"
      ],
      correctAnswer: 1
    },
    {
      id: 997009,
      question: "When chlorhexidine is prescribed, how should it be timed relative to fluoride?",
      options: [
        "Separate chlorhexidine from fluoride use by about 60 minutes",
        "Use chlorhexidine and fluoride together at the exact same moment",
        "Separate chlorhexidine from fluoride use by only about 5 minutes",
        "Never use any fluoride product while taking a chlorhexidine rinse"
      ],
      correctAnswer: 0
    },
    {
      id: 997010,
      question: "Which fluoride products are recommended for once-daily home use with fixed appliances?",
      options: [
        "A 0.2% sodium fluoride rinse, or a 5.0% sodium fluoride gel or paste",
        "A 0.12% stannous fluoride rinse, or a 2.5% fluoride gel or paste",
        "A 0.05% sodium fluoride rinse, or a 1.1% sodium fluoride gel or paste",
        "A 1.0% sodium fluoride rinse, or a 0.22% fluoride gel or paste"
      ],
      correctAnswer: 2
    },
    {
      id: 997011,
      question: "What is the purpose of a rubber-tip stimulator in interdental cleaning?",
      options: [
        "To place dental floss underneath the orthodontic archwire",
        "To disrupt plaque and to gently massage the gingival papillae",
        "To remove loose cement from beneath a loosened metal band",
        "To polish the smooth facial surface of each bonded bracket"
      ],
      correctAnswer: 1
    },
    {
      id: 997012,
      question: "What is the purpose of a floss threader for the orthodontic client?",
      options: [
        "To disrupt plaque and massage the papillae between the brackets",
        "To scrub plaque away from the gingival margin around the brackets",
        "To stimulate and toughen the gingiva around a loosened band",
        "To place floss under the archwire so it can clean between teeth"
      ],
      correctAnswer: 3
    },
    {
      id: 997013,
      question: "Which group of foods should be AVOIDED while wearing fixed orthodontic appliances?",
      options: [
        "Yogurt, applesauce, soft pasta, and well-cooked soft vegetables",
        "Cut fresh fruit, low-sugar foods, and soft easy-to-chew breads",
        "Chewing gum, sticky candies, hard foods such as nuts, and ice",
        "Warm soups, mashed potatoes, scrambled eggs, and soft cheeses"
      ],
      correctAnswer: 2
    },
    {
      id: 997014,
      question: "Which group of foods is recommended to INCLUDE while wearing fixed appliances?",
      options: [
        "Fresh fruits and vegetables that have been cut into small pieces",
        "Whole crunchy apples, raw whole carrots, and hard salty pretzels",
        "Chewy caramels, Tootsie Rolls, and thick spoonfuls of peanut butter",
        "Buttered popcorn, corn on the cob, and a stick of chewing gum"
      ],
      correctAnswer: 0
    },
    {
      id: 997015,
      question: "While in the hospital, oral hygiene care for the surgical orthodontic client consists of:",
      options: [
        "Vigorous daily brushing with a large, firm-bristled manual toothbrush",
        "Careful daily flossing with a floss threader between each tooth",
        "Hourly rinsing with an undiluted, full-strength chlorhexidine product",
        "Frequent saline irrigation with a 30-mL syringe and a blunt needle"
      ],
      correctAnswer: 3
    },
    {
      id: 997016,
      question: "For the first 2 weeks after surgery, what do surgical orthodontic clients do?",
      options: [
        "They begin immediate scaling and root planing at home",
        "They continue to irrigate using saline and a syringe",
        "They switch to a high-power irrigator on its strongest setting",
        "They stop all oral hygiene until the surgeon removes the sutures"
      ],
      correctAnswer: 1
    },
    {
      id: 997017,
      question: "During maxillomandibular fixation, special suction-unit brushes can clean which surfaces?",
      options: [
        "The lingual surfaces; the labial surfaces will not be accessible",
        "Both the labial and lingual surfaces equally during week one",
        "Only the occlusal surfaces of the posterior molars and bicuspids",
        "The labial surfaces; the lingual surfaces will not be accessible"
      ],
      correctAnswer: 3
    },
    {
      id: 997018,
      question: "Which antimicrobial agent is recommended in postsurgical plaque control, and why?",
      options: [
        "Hydrogen peroxide, because of its strong and visible foaming action",
        "Full-strength ethanol, because of its rapid surface drying effect",
        "Chlorhexidine, because of its effectiveness and low alcohol content",
        "A gritty salt paste, because of its strong abrasive scrubbing power"
      ],
      correctAnswer: 2
    },
    {
      id: 997019,
      question: "From 2 to 8 weeks after surgery, brushing may be started using:",
      options: [
        "Modified sulcular brushing with a small, soft-bristled toothbrush",
        "Aggressive scrub brushing with a large, firm-bristled toothbrush",
        "No brushing of any kind until eight full weeks have gone by",
        "Brushing only the appliance itself and never the natural teeth"
      ],
      correctAnswer: 0
    },
    {
      id: 997020,
      question: "In the postsurgical diet, which beverages should be avoided?",
      options: [
        "Plain water and clear nutritious drinks should be avoided",
        "Carbonated beverages should be avoided during recovery",
        "High-caloric supplement liquids should be strictly avoided",
        "Room-temperature herbal teas should be avoided completely"
      ],
      correctAnswer: 1
    },
    {
      id: 997021,
      question: "What is significant about the moon-shaped area between the bracket and the gingiva?",
      options: [
        "It is the smoothest and easiest area to keep fully clean",
        "It should never be touched by the toothbrush bristles at all",
        "It becomes a target area where food tends to be trapped",
        "It naturally cleans itself through the normal act of chewing"
      ],
      correctAnswer: 2
    },
    {
      id: 997022,
      question: "What is true about the areas behind the wire?",
      options: [
        "They are not cleaned by brushing alone and need additional aids",
        "They are fully cleaned by simply brushing twice every single day",
        "They do not collect any plaque or trapped pieces of food debris",
        "They should only ever be cleaned by the dental hygienist in office"
      ],
      correctAnswer: 0
    },
    {
      id: 997023,
      question: "What is true about decalcification during orthodontic treatment?",
      options: [
        "It disappears completely as soon as the braces have been removed",
        "It affects only the gingiva and never the underlying tooth enamel",
        "It is quickly reversed by simply using a daily whitening toothpaste",
        "It leaves permanent markings on the teeth and can lead to decay"
      ],
      correctAnswer: 3
    },
    {
      id: 997024,
      question: "Home fluoride rinses are especially recommended for which clients?",
      options: [
        "Clients who have already completed all of their orthodontic care",
        "Clients who are unable or unwilling to keep their teeth clean",
        "Clients who brush and floss perfectly after every single meal",
        "Clients who have no brackets, bands, or wires in their mouth"
      ],
      correctAnswer: 1
    },
    {
      id: 997025,
      question: "Why are hard and sticky foods a concern for clients with appliances?",
      options: [
        "They permanently stain the visible surface of every metal bracket",
        "They may bend wires, loosen cement, or break brackets and tubes",
        "They cause the metal archwire to rust within just a few hours",
        "They make the colored elastic ligatures quickly change their shade"
      ],
      correctAnswer: 1
    },
    {
      id: 997026,
      question: "What are the small donut-shaped elastic ligatures used for?",
      options: [
        "Large metal clips that permanently fuse the wire onto each tooth",
        "Soft rubber pads placed to protect the cheeks from the brackets",
        "Thin plastic strips placed to cover the sharp ends of the wire",
        "Small donut-shaped elastics that hold the wire and brace together"
      ],
      correctAnswer: 3
    },
    {
      id: 997027,
      question: "Which foods should be cut up so they can be eaten more safely?",
      options: [
        "Apples cut into small wedges and carrots cut into thin curls",
        "Whole bagels eaten in big bites and full ears of corn on the cob",
        "Hard candies sucked slowly and crunchy nuts eaten by the handful",
        "Sticky caramels chewed slowly and tough beef jerky torn by hand"
      ],
      correctAnswer: 0
    },
    {
      id: 997028,
      question: "If high-sugar foods are eaten, what is the recommended guidance?",
      options: [
        "Eat them slowly throughout the day, between each of the meals",
        "Eat them first so that the mouth feels clean again afterward",
        "Eat them only at the end of a meal and then brush immediately",
        "Eat them only right before going to sleep for the night"
      ],
      correctAnswer: 2
    },
    {
      id: 997029,
      question: "Which habits should the client with appliances be told to avoid?",
      options: [
        "Drinking plain water, eating soft yogurt, and chewing soft pasta",
        "Biting pencils and pens, chewing ice and hard candy, biting nails",
        "Brushing gently, flossing once daily, and rinsing well with water",
        "Cutting apples into wedges and eating spoonfuls of soft applesauce"
      ],
      correctAnswer: 1
    },
    {
      id: 997030,
      question: "Which toothbrush and technique are recommended for oral self-care?",
      options: [
        "A hard toothbrush held at a 90-degree angle, moved in long strokes",
        "A medium toothbrush held flat, moved with firm back-and-forth scrubs",
        "A soft toothbrush held at a 45-degree angle, moved in small circles",
        "A firm toothbrush held at a 30-degree angle, moved in single sweeps"
      ],
      correctAnswer: 2
    },
    {
      id: 997031,
      question: "What are the three parts that must be brushed once appliances are placed?",
      options: [
        "Above the ortho, between the brackets and wires, and below the braces",
        "Only the facial surfaces of the upper front teeth near the lip line",
        "Just the brackets themselves and nothing else around or near them",
        "Only the chewing surfaces of the back molar teeth in both arches"
      ],
      correctAnswer: 0
    },
    {
      id: 997032,
      question: "What is described as the \"most important step\" in the brushing technique?",
      options: [
        "Brushing only the flat front surface of each individual bracket",
        "Brushing the tongue using firm and quick back-and-forth strokes",
        "Brushing the chewing surfaces with a single quick passing stroke",
        "Brushing at an angle toward the gums to clean along the gumline"
      ],
      correctAnswer: 3
    },
    {
      id: 997033,
      question: "What is the correct role of a Waterpik or home irrigator?",
      options: [
        "It is a complete replacement for both daily brushing and flossing",
        "It is a tool meant to be used only by the hygienist in the office",
        "It is a device that should never be used by any orthodontic client",
        "It is an adjunct to home care but not a substitute for flossing"
      ],
      correctAnswer: 3
    },
    {
      id: 997034,
      question: "How often should orthodontic clients usually come in for recare visits?",
      options: [
        "More frequent visits, usually about every 3 to 4 months",
        "Much less frequent visits, usually every 12 to 18 months",
        "Only one single visit at the very end of all the treatment",
        "Weekly visits for the entire length of the orthodontic care"
      ],
      correctAnswer: 0
    },
    {
      id: 997035,
      question: "On average, how long should it take to brush and floss with full orthodontics?",
      options: [
        "Roughly 1 to 2 minutes for each cleaning session",
        "Roughly 8 to 15 minutes for each cleaning session",
        "Roughly 30 to 45 minutes for each cleaning session",
        "Roughly 20 to 25 minutes for each cleaning session"
      ],
      correctAnswer: 1
    },
    {
      id: 997036,
      question: "How should a removable retainer be cared for?",
      options: [
        "Soak it in boiling hot water and then wrap it in soft tissue paper",
        "Leave it loose in a pocket or a purse between each of the meals",
        "Brush it with soap and water, store it in its case, keep it from pets",
        "Clean it with bleach and store it on a warm and sunny windowsill"
      ],
      correctAnswer: 2
    },
    {
      id: 997037,
      question: "What is true about a fixed (lingual) retainer?",
      options: [
        "It needs no cleaning at all because it stays fixed in one place",
        "It should be taken out and soaked in cleaner every single night",
        "It is plaque-retentive, so floss daily and use a floss threader",
        "It stops any calculus from ever forming near the bonded wire"
      ],
      correctAnswer: 2
    },
    {
      id: 997038,
      question: "When and how does discomfort usually occur after the appliance is placed?",
      options: [
        "It starts 2 to 3 hours later and peaks on the first evening and day two",
        "It starts right away and then disappears within about ten minutes",
        "It begins a full week later and then lasts for only about one hour",
        "It never occurs at all because modern appliances are fully painless"
      ],
      correctAnswer: 0
    },
    {
      id: 997039,
      question: "What is the purpose of orthodontic relief wax?",
      options: [
        "To permanently glue a loose bracket back into place on the tooth",
        "To relieve rubbing on soft tissue while that tissue toughens up",
        "To take the place of daily brushing of the area around the wire",
        "To dissolve the archwire so that it stops poking into the cheek"
      ],
      correctAnswer: 1
    },
    {
      id: 997040,
      question: "What is a temporary anchorage device (TAD)?",
      options: [
        "A permanent metal crown that is cemented over a badly damaged molar",
        "A removable plastic tray that is worn only at night for whitening",
        "A soft rubber spacer that is placed between two tightly crowded teeth",
        "A device temporarily fixed to bone to enhance anchorage, then removed"
      ],
      correctAnswer: 3
    },
    {
      id: 997041,
      question: "Why is a loose band considered an orthodontic concern?",
      options: [
        "It immediately speeds up the desired movement of the involved tooth",
        "It is completely harmless and can simply be ignored until the end",
        "It causes the involved tooth to whiten faster than the other teeth",
        "It creates an increased plaque-retention area that should be avoided"
      ],
      correctAnswer: 3
    },
    {
      id: 997042,
      question: "Where is a removable appliance or retainer considered safe?",
      options: [
        "It is perfectly safe when wrapped inside a napkin during a meal",
        "It is safest when carried loose inside a front or back jeans pocket",
        "It is only safe in the mouth or in the case (\"in your face or the case\")",
        "It is fine to store inside a purse as long as it is wrapped in paper"
      ],
      correctAnswer: 2
    },
    {
      id: 997043,
      question: "When a piece of wire is being cut, what may be helpful to manage it?",
      options: [
        "Use a folded Kleenex to trap and catch the cut piece of wire",
        "Swallow the cut piece of wire since it will pass without harm",
        "Let the cut piece of wire fall freely into the back of the throat",
        "Push the cut piece of wire down between the gum and the cheek"
      ],
      correctAnswer: 0
    },
    {
      id: 997044,
      question: "How do dental implants differ from temporary anchorage devices (TADs)?",
      options: [
        "Implants and TADs are identical, and both are removed after treatment",
        "Implants supporting a prosthesis are not TADs, since they are not removed",
        "Implants can never be used to provide any orthodontic anchorage at all",
        "TADs are always left in the bone permanently in order to support a crown"
      ],
      correctAnswer: 1
    },
    {
      id: 997045,
      question: "Initially rotated or malpositioned teeth trap more food and are harder to access with regular brushing.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 997046,
      question: "A proxabrush, sulca brush, and end-tuft brush are all options for cleaning areas that a regular toothbrush cannot reach.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 997047,
      question: "Orthodontic relief wax is dangerous to swallow because it contains active medications.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 997048,
      question: "Threaders, superfloss, and floss must be used to clean interproximally and subgingivally.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 997049,
      question: "A fixed retainer should be removed by the client every night for cleaning.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    }
  ],
  "8. Introduction to Orthodontics (Part 8)": [
    {
      id: 998001,
      question: "What approach does Invisalign use to straighten teeth?",
      options: [
        "A fixed set of metal brackets and tightening wires",
        "A single rigid plastic mouthguard worn at night",
        "A custom-made series of clear aligner trays",
        "A bonded permanent wire placed behind the teeth"
      ],
      correctAnswer: 2
    },
    {
      id: 998002,
      question: "What are the Invisalign aligner trays made of?",
      options: [
        "Smooth, comfortable, and virtually invisible plastic",
        "Rigid, brightly colored, and very visible acrylic",
        "Flexible stainless steel wire woven into a mesh",
        "Soft rubberized silicone padding with foam lining"
      ],
      correctAnswer: 0
    },
    {
      id: 998003,
      question: "How do the aligners move the teeth?",
      options: [
        "They instantly snap teeth into their final position",
        "They loosen the teeth so they can be removed faster",
        "They permanently fuse the teeth to the jawbone below",
        "They gradually and gently shift teeth into place"
      ],
      correctAnswer: 3
    },
    {
      id: 998004,
      question: "Compared with traditional braces, Invisalign involves:",
      options: [
        "Stronger metal brackets and thicker tightening wires",
        "No metal brackets to attach and no wires to tighten",
        "More frequent wire adjustments made at every visit",
        "Extra headgear that must be worn outside the mouth"
      ],
      correctAnswer: 1
    },
    {
      id: 998005,
      question: "How often does a patient switch to a new set of aligners?",
      options: [
        "Approximately every two weeks during the treatment",
        "Approximately every two days during the treatment",
        "Approximately every two months during treatment",
        "Only one single time at the very end of treatment"
      ],
      correctAnswer: 0
    },
    {
      id: 998006,
      question: "Who plans the exact movements of the teeth?",
      options: [
        "The patient choosing the movements on their own",
        "A retail pharmacy technician working at the store",
        "The dentist or orthodontist treating the patient",
        "The factory workers who package the aligner trays"
      ],
      correctAnswer: 2
    },
    {
      id: 998007,
      question: "What is the first step a patient takes to begin treatment?",
      options: [
        "Ordering the aligner trays directly from a website",
        "Selecting an Invisalign-trained provider to consult",
        "Buying replacement wires straight from a pharmacy",
        "Taking the dental impressions at home with no doctor"
      ],
      correctAnswer: 1
    },
    {
      id: 998008,
      question: "Why is choosing the right doctor described as so essential?",
      options: [
        "It is only a small and minor cosmetic styling choice",
        "It is needed to renew a yearly product subscription",
        "It is required in order to qualify for a tax refund",
        "It is an important medical and financial decision"
      ],
      correctAnswer: 3
    },
    {
      id: 998009,
      question: "What range of cases can Invisalign now address?",
      options: [
        "Only the most severe surgical jaw realignment cases",
        "Many cases, ranging from simple to more complex",
        "Only the baby teeth found in very young children",
        "Only one single front tooth treated at any one time"
      ],
      correctAnswer: 1
    },
    {
      id: 998010,
      question: "What can a patient take ahead of time to check candidacy?",
      options: [
        "A blood test ordered at the local hospital lab",
        "A written history exam all about orthodontics",
        "A full-body magnetic resonance imaging scan",
        "The Smile Assessment offered by Invisalign"
      ],
      correctAnswer: 3
    },
    {
      id: 998011,
      question: "During the consultation, the patient can ask about:",
      options: [
        "Costs, dental or orthodontic insurance, and concerns",
        "Recipes, grocery prices, and weekly cooking plans",
        "Travel routes, flight times, and hotel reservations",
        "Car repairs, fuel prices, and parking arrangements"
      ],
      correctAnswer: 0
    },
    {
      id: 998012,
      question: "What records does the doctor collect to build the plan?",
      options: [
        "Blood samples, urine tests, and full allergy panels",
        "Hearing tests, eye exams, and basic reflex checks",
        "X-rays, pictures, and impressions of the teeth",
        "Diet logs, sleep charts, and daily stress surveys"
      ],
      correctAnswer: 2
    },
    {
      id: 998013,
      question: "What does Invisalign create from the collected records?",
      options: [
        "A handwritten paper chart describing the teeth",
        "A solid plaster statue of the patient's whole head",
        "A flat two-dimensional black-and-white sketch",
        "A digital three-dimensional image of the teeth"
      ],
      correctAnswer: 3
    },
    {
      id: 998014,
      question: "What does the doctor map out in the treatment plan?",
      options: [
        "The patient's daily meal and afternoon snack plan",
        "The exact tooth movements and approximate length",
        "The preferred color of the aligner storage container",
        "The clinic's billing and appointment software setup"
      ],
      correctAnswer: 1
    },
    {
      id: 998015,
      question: "About how long does treatment typically take for adults?",
      options: [
        "Approximately one week, the same for everyone",
        "Approximately five years, the same for everyone",
        "Approximately one year, though every case varies",
        "Approximately one day, the same for every patient"
      ],
      correctAnswer: 2
    },
    {
      id: 998016,
      question: "For teens, the length of Invisalign treatment is:",
      options: [
        "Comparable to the length of treatment with braces",
        "Always far shorter than the treatment with braces",
        "Always exactly double the treatment with braces",
        "Completely unrelated to any treatment with braces"
      ],
      correctAnswer: 0
    },
    {
      id: 998017,
      question: "What feature of the aligner plastic is highlighted?",
      options: [
        "It is BPA-free and won't irritate cheeks and gums",
        "It contains BPA and often irritates the gum tissue",
        "It is metal-based and abrasive against the cheeks",
        "It is wood-based and stains the teeth very quickly"
      ],
      correctAnswer: 0
    },
    {
      id: 998018,
      question: "When should the patient remove the aligners?",
      options: [
        "Only when sleeping at night during each evening",
        "Only during the weekly checkups at the dental clinic",
        "When eating or to brush and floss the teeth",
        "Only after the entire treatment has been finished"
      ],
      correctAnswer: 2
    },
    {
      id: 998019,
      question: "Why do most people not notice the aligners?",
      options: [
        "Because the aligners are kept inside a small case",
        "Because the aligners are virtually invisible to see",
        "Because the aligners are only worn while sleeping",
        "Because the aligners are painted to match the lips"
      ],
      correctAnswer: 1
    },
    {
      id: 998020,
      question: "Putting on a new set of aligners advances the patient to:",
      options: [
        "The first stage of the overall treatment plan",
        "The final fitting of permanent metal brackets",
        "The completion of all required retainer wear",
        "The next stage of the overall treatment plan"
      ],
      correctAnswer: 3
    },
    {
      id: 998021,
      question: "How often are checkups with the doctor usually needed?",
      options: [
        "Usually only about every six days during treatment",
        "Usually only about every six months during treatment",
        "Usually only about every six weeks during treatment",
        "Usually only about every six hours during treatment"
      ],
      correctAnswer: 2
    },
    {
      id: 998022,
      question: "How many hours per day should aligners be worn?",
      options: [
        "About 20 to 22 hours during every single day",
        "About 2 to 4 hours during every single day",
        "About 8 to 10 hours during every single day",
        "About 14 to 16 hours during every single day"
      ],
      correctAnswer: 0
    },
    {
      id: 998023,
      question: "What is the purpose of a retainer after treatment?",
      options: [
        "To continue moving the teeth much farther along",
        "To completely replace the need for daily brushing",
        "To whiten and polish the outer surfaces of teeth",
        "To keep the teeth in their new corrected position"
      ],
      correctAnswer: 3
    },
    {
      id: 998024,
      question: "Vivera retainers are made using:",
      options: [
        "Recycled metal taken from old traditional braces",
        "The same state-of-the-art technology as Invisalign",
        "Simple hand-bent wire shaped by hand at the clinic",
        "Off-the-shelf one-size-fits-all sports mouthguards"
      ],
      correctAnswer: 1
    },
    {
      id: 998025,
      question: "How are retainers worn during the first 3 to 6 months?",
      options: [
        "For only about 1 to 2 hours each day at first",
        "For only on the weekends each week at first",
        "For no time at all during those first months",
        "For about 12 to 22 hours each day at first"
      ],
      correctAnswer: 3
    },
    {
      id: 998026,
      question: "The retainer wearing schedule varies depending on:",
      options: [
        "The patient's favorite color and preferred music",
        "The complexity of the problem and the patient's age",
        "The distance the patient lives from the dental clinic",
        "The brand of toothpaste the patient chooses to use"
      ],
      correctAnswer: 1
    },
    {
      id: 998027,
      question: "What kinds of problems can Invisalign correct?",
      options: [
        "Malocclusion, overbite, underbite, gaps, and crowding",
        "Only the color and surface whiteness of the teeth",
        "Only missing teeth that need a full replacement set",
        "Only jaw injuries caused by accidents and trauma"
      ],
      correctAnswer: 0
    },
    {
      id: 998028,
      question: "What did the 26-year-old female patient's case involve?",
      options: [
        "Widely spaced teeth that were placed very far apart",
        "Upper teeth that bit on the inside of the lower teeth",
        "Overly crowded teeth with not enough room in the jaw",
        "A deep overbite overlapping the lower teeth too much"
      ],
      correctAnswer: 2
    },
    {
      id: 998029,
      question: "According to the file, untreated overly crowded teeth can:",
      options: [
        "Cure decay and lower the chance of gum disease",
        "Cause decay and raise the chance of gum disease",
        "Strengthen the enamel and whiten the teeth fast",
        "Speed up the eruption of brand-new adult teeth"
      ],
      correctAnswer: 1
    },
    {
      id: 998030,
      question: "According to the file, spacing issues in teeth can cause:",
      options: [
        "A permanent loss of the patient's sense of taste",
        "A much higher risk of suddenly breaking the jaw",
        "An immediate and lasting change in the eye color",
        "Some periodontal, gum-related diseases over time"
      ],
      correctAnswer: 3
    },
    {
      id: 998031,
      question: "The 27-year-old female patient's misaligned jaws caused:",
      options: [
        "Lower teeth to fall out within a few short weeks",
        "The teeth to become fused firmly to the jawbone",
        "Upper teeth to bite inside lower teeth, causing wear",
        "The jaw to lock completely shut while she was eating"
      ],
      correctAnswer: 2
    },
    {
      id: 998032,
      question: "Among the cases shown, what was the longest treatment?",
      options: [
        "About 20 months for the overbite/overlap case",
        "About 2 months for the overbite/overlap case",
        "About 50 months for the overbite/overlap case",
        "About 36 months for the overbite/overlap case"
      ],
      correctAnswer: 0
    },
    {
      id: 998033,
      question: "Invisalign aligners should be worn about 20 to 22 hours per day for best results.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 998034,
      question: "Invisalign uses metal brackets and wires that must be tightened regularly.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 998035,
      question: "Vivera retainers are used after treatment to help keep the teeth in their new position.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    }
  ]
};
